/* Pease Door System Calculator scripts (tab shell, exterior, interior).
   Moved out of sections/door-system-calculator-combined.liquid to keep the
   section under Shopify's 256 KB limit. Each calculator finds its roots by
   class and guards against double init, so re-running is safe (theme editor
   section reloads call it again). */
(function () {
  // ---- Shared UI helpers (both calculators) ----

  // Visual button groups drive the hidden <select data-input> elements, so
  // all calculator logic keeps reading plain select values. A button's
  // data-set is "key=value" or "key=value;key2=value2".
  function parseSet(btn) {
    return btn.getAttribute('data-set').split(';').map(function (pair) {
      var kv = pair.split('=');
      return { key: kv[0], value: kv[1] };
    });
  }
  // "35 3/4", "35-3/4", "35.75", "3/4" -> number (NaN if unparseable).
  function parseFrac(raw) {
    var t = String(raw || '').trim().replace(/["”]$/, '');
    var m;
    if (/^\d+(\.\d+)?$/.test(t)) return parseFloat(t);
    if ((m = t.match(/^(\d+)\s*\/\s*(\d+)$/))) return +m[2] ? m[1] / m[2] : NaN;
    if ((m = t.match(/^(\d+)(?:\s+|-)(\d+)\s*\/\s*(\d+)$/))) return +m[3] ? +m[1] + m[2] / m[3] : NaN;
    return NaN;
  }
  // Size quick picks fill the text field next to them; the field stays
  // editable for any other size.
  function wireChips(root) {
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('.pease-chip');
      if (!chip || !root.contains(chip)) return;
      var key = chip.closest('[data-chips-for]').getAttribute('data-chips-for');
      var input = root.querySelector('[data-input="' + key + '"]');
      input.value = chip.getAttribute('data-chip');
      input.setAttribute('data-last-good', input.value);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }
  function syncChips(root) {
    root.querySelectorAll('[data-chips-for]').forEach(function (group) {
      var input = root.querySelector('[data-input="' + group.getAttribute('data-chips-for') + '"]');
      var v = parseFrac(input.value.trim() || input.getAttribute('data-default'));
      group.querySelectorAll('.pease-chip').forEach(function (chip) {
        var on = Math.abs(parseFrac(chip.getAttribute('data-chip')) - v) < 1e-6;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  function wireChoices(root) {
    wireChips(root);
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.pease-choice__btn');
      if (!btn || !root.contains(btn) || btn.disabled) return;
      parseSet(btn).forEach(function (kv) {
        var el = root.querySelector('[data-input="' + kv.key + '"]');
        if (!el || el.value === kv.value) return;
        el.value = kv.value;
        if (el.tagName === 'SELECT') {
          el.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          // Starter layouts also fill text fields (sizes).
          el.setAttribute('data-last-good', kv.value);
          el.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    });
  }
  // Mark the pressed button and hide buttons whose option is hidden (the
  // calculators hide options that don't apply, e.g. sidelites with no door).
  function syncChoices(root) {
    syncChips(root);
    root.querySelectorAll('.pease-choice__btn').forEach(function (btn) {
      var on = true, avail = true;
      var starter = !!btn.closest('.pease-choice--starters');
      parseSet(btn).forEach(function (kv) {
        var el = root.querySelector('[data-input="' + kv.key + '"]');
        if (!el) return;
        if (el.tagName === 'SELECT') {
          if (el.value !== kv.value) on = false;
          var opt = el.querySelector('option[value="' + kv.value + '"]');
          // Starters set several fields at once, so never hide them.
          if (!starter && opt && (opt.hidden || opt.disabled)) avail = false;
        } else {
          var cur = parseFrac(el.value.trim() || el.getAttribute('data-default'));
          if (Math.abs(cur - parseFrac(kv.value)) > 1e-6) on = false;
        }
      });
      btn.hidden = !avail;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  // Validation messages: { text, key, level }. level is 'error' (bad input)
  // or 'note' (allowed, but custom or unusual). A message with a key shows
  // under that field when the field is visible; everything else goes in the
  // summary box at the top of the form.
  function msg(text, key, level) {
    return { text: text, key: key || null, level: level || 'error' };
  }
  function renderMessages(root, ns, list) {
    root.querySelectorAll('.pease-field-msg').forEach(function (el) { el.remove(); });
    root.querySelectorAll('[aria-invalid="true"]').forEach(function (el) {
      el.removeAttribute('aria-invalid');
      el.removeAttribute('aria-describedby');
      el.classList.remove('is-invalid');
    });
    var general = [];
    list.forEach(function (m, idx) {
      var input = m.key && root.querySelector('[data-input="' + m.key + '"]');
      var field = input && input.closest('.pease-' + ns + '__field');
      if (field && field.getClientRects().length) {
        var p = document.createElement('p');
        p.className = 'pease-field-msg is-' + m.level;
        p.id = root.id + '-msg-' + idx;
        p.textContent = m.text;
        field.appendChild(p);
        if (m.level === 'error') {
          input.classList.add('is-invalid');
          input.setAttribute('aria-invalid', 'true');
          input.setAttribute('aria-describedby', p.id);
        }
      } else {
        var inAdv = input && input.closest('[data-adv-body]');
        var inCuts = input && input.closest('[data-cut-body]');
        var inSide = input && input.closest('[data-scut-body]');
        general.push({ text: m.text + (inAdv ? ' (see Advanced settings)' : inCuts ? ' (see Door glass & pet door)' :
          inSide ? ' (see Sidelite glass)' : ''), level: m.level });
      }
    });
    var box = root.querySelector('[data-warnings]');
    box.textContent = '';
    general.forEach(function (m) {
      var d = document.createElement('div');
      d.className = 'pease-' + ns + '__warning' + (m.level === 'note' ? ' is-note' : '');
      d.textContent = m.text;
      box.appendChild(d);
    });
  }

  // Inches -> "35 3/4" (nearest 1/16", no inch mark), for filling fields.
  function fracStr(v) {
    var whole = Math.floor(v + 1e-9), n = Math.round((v - whole) * 16), d = 16;
    if (n === 16) { whole += 1; n = 0; }
    if (!n) return String(whole);
    while (n % 2 === 0) { n /= 2; d /= 2; }
    return (whole ? whole + ' ' : '') + n + '/' + d;
  }
  function snap8(v) { return Math.round(v * 8) / 8; }

  // ---- Size by rough opening ----
  // Find the slab dimension that fits a rough opening. calc(i) returns the
  // calculator's results, whose ro{W,H}{min,max} are the opening range a
  // unit needs. Prefer the largest standard size whose range contains the
  // opening; otherwise the largest 1/8" size that still leaves the minimum
  // shim space (a custom size).
  function fitAxis(i, calc, key, axis, std) {
    var target = axis === 'W' ? i.roW : i.roH;
    function ro(v, which) {
      var t = {};
      for (var k in i) t[k] = i[k];
      t[key] = v;
      return calc(t)['ro' + axis + which];
    }
    var best = null;
    (std || []).forEach(function (sz) {
      if (ro(sz, 'min') <= target + 1e-9 && ro(sz, 'max') >= target - 1e-9 && (best === null || sz > best)) best = sz;
    });
    var b0 = ro(0, 'min'), a = ro(1, 'min') - b0;
    var exact = Math.floor(((target - b0) / a) * 8 + 1e-9) / 8;
    return { value: best !== null ? best : exact, standard: best !== null };
  }
  // Returns sizeByOpening(i): in rough-opening mode it replaces the slab
  // size in i with the size that fits; switching modes carries sizes over.
  function roSizer(root, calc, opts) {
    function setField(key, v) {
      var el = root.querySelector('[data-input="' + key + '"]');
      if (!el) return;
      el.value = fracStr(v);
      el.setAttribute('data-last-good', el.value);
    }
    return function (i) {
      var last = root._sizeMode || 'slab';
      root._sizeMode = i.sizeMode;
      if (i.sizeMode === 'ro') {
        var prev = (root._dscLast || root._idcLast || {}).r;
        if (last !== 'ro' && prev) {
          // Start the opening at the middle of the current unit's range.
          i.roW = snap8((prev.roWmin + prev.roWmax) / 2);
          i.roH = snap8((prev.roHmin + prev.roHmax) / 2);
          setField('roW', i.roW);
          setField('roH', i.roH);
        }
        var widthKey = opts.widthKey(i);
        var std = typeof opts.std === 'function' ? opts.std(i) : opts.std;
        var fw = fitAxis(i, calc, widthKey, 'W', std[widthKey]);
        i[widthKey] = fw.value;
        var fh = fitAxis(i, calc, 'slabH', 'H', std.slabH);
        i.slabH = fh.value;
        var inRange = function (key, v) { var rg = opts.range[key]; return v >= rg[0] - 1e-9 && v <= rg[1] + 1e-9; };
        fw.ok = inRange(widthKey, fw.value);
        fh.ok = inRange('slabH', fh.value);
        i.roFit = { widthKey: widthKey, w: fw, h: fh };
        root._roFit = i.roFit;
      } else if (last === 'ro' && root._roFit) {
        var f = root._roFit;
        i[f.widthKey] = f.w.value;
        i.slabH = f.h.value;
        setField(f.widthKey, f.w.value);
        setField('slabH', f.h.value);
      }
    };
  }
  function chipLabel(root, key, v) {
    var hit = '';
    root.querySelectorAll('[data-chips-for="' + key + '"] .pease-chip').forEach(function (c) {
      if (Math.abs(parseFrac(c.getAttribute('data-chip')) - v) < 1e-6) {
        var sm = c.querySelector('small');
        hit = sm ? sm.textContent : '';
      }
    });
    return hit;
  }
  function renderFit(root, i) {
    root.querySelectorAll('[data-group="ro-fields"]').forEach(function (el) {
      el.style.display = i.sizeMode === 'ro' ? '' : 'none';
    });
    root.querySelectorAll('[data-group="slab-fields"]').forEach(function (el) {
      el.style.display = i.sizeMode === 'ro' ? 'none' : '';
    });
    var box = root.querySelector('[data-ro-fit]');
    if (!box) return;
    box.textContent = '';
    box.classList.remove('is-custom', 'is-none');
    if (i.sizeMode !== 'ro' || !i.roFit) return;
    var f = i.roFit;
    var what = f.widthKey === 'sideliteW' ? 'Sidelite' : 'Slab';
    if (!f.w.ok || !f.h.ok) {
      var none = document.createElement('strong');
      none.textContent = 'No ' + what.toLowerCase() + ' fits this opening with this layout.';
      box.appendChild(none);
      var fix = document.createElement('p');
      fix.textContent = 'Check the opening size, or change the doors, sidelites or transom above.';
      box.appendChild(fix);
      box.classList.add('is-none');
      return;
    }
    var head = document.createElement('strong');
    head.textContent = what + ' that fits: ' + fracStr(f.w.value) + '" × ' + fracStr(f.h.value) + '"';
    box.appendChild(head);
    var labels = [chipLabel(root, f.widthKey, f.w.value), chipLabel(root, 'slabH', f.h.value)].filter(Boolean);
    if (labels.length) box.appendChild(document.createTextNode(' (' + labels.join(', ') + ')'));
    var note = document.createElement('p');
    var custom = [];
    if (!f.w.standard) custom.push('width');
    if (!f.h.standard) custom.push('height');
    note.textContent = custom.length
      ? 'No standard ' + custom.join(' or ') + ' fits this opening, so this is a custom size. The slab may need trimming or a special order.'
      : 'A standard size. Every measurement below uses this ' + what.toLowerCase() + '.';
    if (custom.length) box.classList.add('is-custom');
    box.appendChild(note);
  }

  // ---- Summary line + sticky results bar (phones) ----
  function setSummary(root, text, stickyText) {
    var el = root.querySelector('[data-summary]');
    if (el) el.textContent = text;
    var st = root.querySelector('[data-sticky-text]');
    if (st) st.textContent = stickyText;
  }
  function wireSticky(root, ns) {
    var bar = root.querySelector('[data-sticky]');
    var inputs = root.querySelector('.pease-' + ns + '__panel--inputs');
    var outputs = root.querySelector('.pease-' + ns + '__panel--outputs');
    if (!bar || !inputs || !outputs || !('IntersectionObserver' in window)) return;
    var inVis = false, outVis = false;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.target === inputs) inVis = e.isIntersecting; else outVis = e.isIntersecting;
      });
      bar.hidden = !(inVis && !outVis);
    }).observe(inputs);
    // A second observer instance keeps the callback simple per target.
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { outVis = e.isIntersecting; });
      bar.hidden = !(inVis && !outVis);
    }).observe(outputs);
    bar.querySelector('[data-sticky-go]').addEventListener('click', function () {
      outputs.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // ---- Shareable link ----
  // The link holds every input that differs from its default, in the URL
  // hash (#calc=ext&slabW=35+3/4&...), so nothing is sent to the server.
  function shareUrl(root, calcKey) {
    var params = new URLSearchParams();
    params.set('calc', calcKey);
    root.querySelectorAll('[data-input]').forEach(function (el) {
      var k = el.getAttribute('data-input'), v;
      if (el.tagName === 'SELECT') {
        var def = Array.prototype.filter.call(el.options, function (o) { return o.defaultSelected; })[0] || el.options[0];
        if (el.value === def.value) return;
        v = el.value;
      } else {
        v = el.value.trim();
        if (!v) return;
        // Skip values that just restate the default, and opening sizes
        // unless the calculator is sizing by rough opening.
        if (Math.abs(parseFrac(v) - parseFrac(el.getAttribute('data-default'))) < 1e-6) return;
        var modeSel = root.querySelector('[data-input="sizeMode"]');
        var roMode = modeSel && modeSel.value === 'ro';
        if (el.closest('[data-group="ro-fields"]') && !roMode) return;
        if (el.closest('[data-group="slab-fields"]') && roMode) return;
      }
      params.set(k, v);
    });
    return location.origin + location.pathname + '#' + params.toString();
  }
  function applyShare(root, calcKey) {
    var h = location.hash.replace(/^#/, '');
    if (!h) return false;
    var params = new URLSearchParams(h);
    if (params.get('calc') !== calcKey) return false;
    var openAdv = false;
    params.forEach(function (v, k) {
      if (k === 'calc') return;
      var el = root.querySelector('[data-input="' + k + '"]');
      if (!el) return;
      el.value = v;
      if (el.tagName !== 'SELECT') el.setAttribute('data-last-good', v);
      if (el.closest('[data-adv-body]')) openAdv = true;
    });
    if (openAdv) {
      root.querySelector('[data-adv-body]').hidden = false;
      root.querySelector('[data-adv-toggle]').setAttribute('aria-expanded', 'true');
    }
    return true;
  }
  function wireShare(root, calcKey) {
    var btn = root.querySelector('[data-action="share"]');
    var out = root.querySelector('[data-share-msg]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var url = shareUrl(root, calcKey);
      function done() { out.textContent = 'Link copied. Anyone with it sees this exact setup.'; }
      function fallback() { window.prompt('Copy this link:', url); }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, fallback);
      } else {
        fallback();
      }
    });
  }

  // "Standard" dropdown entries: label the auto option with today's standard
  // value and drop the explicit option that would repeat it (e.g. no second
  // "2 3/8" under "Standard (2 3/8)"). Picking the explicit twin is folded
  // into Standard, which is the same value.
  function setStdOption(root, key, std, label) {
    var sel = root.querySelector('[data-input="' + key + '"]');
    if (!sel) return;
    if (!sel._allOpts) {
      sel._allOpts = Array.prototype.map.call(sel.options, function (o) {
        return { value: o.value, text: o.textContent };
      });
    }
    var cur = sel.value;
    if (cur !== 'auto' && Math.abs(parseFloat(cur) - std) < 1e-9) cur = 'auto';
    var sig = std + '|' + label;
    if (sel._stdSig !== sig) {
      sel._stdSig = sig;
      sel.textContent = '';
      sel._allOpts.forEach(function (o) {
        if (o.value !== 'auto' && Math.abs(parseFloat(o.value) - std) < 1e-9) return;
        var opt = document.createElement('option');
        opt.value = o.value;
        opt.textContent = o.value === 'auto' ? label : o.text;
        opt.defaultSelected = o.value === 'auto';
        sel.appendChild(opt);
      });
    }
    sel.value = cur;
  }

  // ---- Shop services (SKU list) ----
  // SKU -> [description, price]. Prices checked against Shopify on
  // October 14, 2026; update here when Shopify prices change.
  var SVC = {
    'ZASY-INSTALL-GLASS': ["Glass Ships Installed in its Cutout", 0],
    'ZASY-INSTALL-PET': ["Pet Door Ships Installed in its Cutout", 0],
    'ZTRIM-SLAB': ["Trim to Size (within the door's allowance)", 99],
    'ZTRIM-RERAIL': ["Trim and Re-rail (cut from the bottom, new bottom rail)", 199],
    'SE-RAIL-36': ["Rail Component: door 35-3/4\" wide or narrower", 49],
    'SE-RAIL-72': ["Rail Component: door wider than 35-3/4\"", 119],
    'ZPREP-EXT-HL-FRE': ["Fire-rated Custom Hinge and/or Lock Prep", 399],
    'ZASY-SETUP-LHIS': ["Door Setup: Left Hand Inswing", 0],
    'ZASY-SETUP-RHIS': ["Door Setup: Right Hand Inswing", 0],
    'ZASY-SETUP-LHOS': ["Door Setup: Left Hand Outswing", 0],
    'ZASY-SETUP-RHOS': ["Door Setup: Right Hand Outswing", 0],
    'ZPREP-EXT-HL-STD': ["Standard Hinge & Lock Prep", 79],
    'ZPREP-EXT-H-STD': ["Standard Hinge Prep", 49],
    'ZPREP-EXT-H-CUST': ["Custom Hinge Prep", 99],
    'ZPREP-EXT-L-STD': ["Standard Lock Prep: Double Bore, 2 3/8\" Backset", 49],
    'ZPREP-EXT-L-DB-LONG': ["Double Bore Lock Prep: 2 3/4\" Backset (long)", 79],
    'ZPREP-EXT-L-DB-SHORT': ["Double Bore Lock Prep: 2\" Backset (short)", 79],
    'ZPREP-EXT-L-SB-STD': ["Single Bore Lock Prep: 2 3/8\" Backset", 49],
    'ZPREP-EXT-L-SB-LONG': ["Single Bore Lock Prep: 2 3/4\" Backset (long)", 69],
    'ZPREP-EXT-L-SB-SHORT': ["Single Bore Lock Prep: 2\" Backset (short)", 69],
    'ZPREP-EXT-L-CUST-CYL': ["Custom Cylindrical Lock Prep", 99],
    'ZPREP-EXT-NOLOCK': ["No Lock Prep (no bore or mortise)", 0],
    'ZPREP-EXT-NOHINGE': ["No Hinge Prep (no hinge mortises)", 0],
    'ZPREP-INT-HL-STD-LH': ["Standard Hinge & Lock Prep: Left Hand Inswing", 79],
    'ZPREP-INT-HL-STD-RH': ["Standard Hinge & Lock Prep: Right Hand Inswing", 79],
    'ZPREP-INT-H-STD-LH': ["Standard Hinge Prep: Left Hand Inswing", 49],
    'ZPREP-INT-H-STD-RH': ["Standard Hinge Prep: Right Hand Inswing", 49],
    'ZPREP-INT-H-CUST': ["Custom Hinge Prep", 99],
    'ZPREP-INT-L-SB-STD': ["Standard Lock Prep: Single Bore, 2 3/8\" Backset", 49],
    'ZPREP-INT-L-SB-LONG': ["Single Bore Lock Prep: 2 3/4\" Backset (long)", 69],
    'ZPREP-INT-L-SB-SHORT': ["Single Bore Lock Prep: 2\" Backset (short)", 69],
    'ZPREP-INT-L-CUST-CYL': ["Custom Cylindrical Lock Prep", 99],
    'ZPREP-INT-NOLOCK': ["No Lock Prep (no bore)", 0],
    'ZPREP-INT-NOHINGE': ["No Hinge Prep (no hinge mortises)", 0],
    'ZASY-EXT-PREHUNG': ["Prehung: Single (ships assembled)", 299],
    'ZASY-EXT-PREHUNG-SLL': ["Prehung + Left Sidelite, viewed from exterior (pickup only)", 349],
    'ZASY-EXT-PREHUNG-SLR': ["Prehung + Right Sidelite, viewed from exterior (pickup only)", 349],
    'ZASY-EXT-PREHUNG-SL2': ["Prehung + Two Sidelites (pickup only)", 449],
    'ZASY-EXT-PREHUNG-DBL': ["Prehung: Double (pickup only)", 399],
    'ZASY-EXT-KIT': ["Pre-drilled Kit: Single (ships unassembled)", 149],
    'ZASY-EXT-KIT-SLL': ["Pre-drilled Kit + Left Sidelite, viewed from exterior", 199],
    'ZASY-EXT-KIT-SLR': ["Pre-drilled Kit + Right Sidelite, viewed from exterior", 199],
    'ZASY-EXT-KIT-SL2': ["Pre-drilled Kit + Two Sidelites", 299],
    'ZASY-EXT-KIT-DBL': ["Pre-drilled Kit: Double (floating astragal)", 249],
    'ZASY-EXT-COMP': ["Components (ships loose, no prep)", 0],
    'ZASY-INT-PREHUNG': ["Prehung: Single (ships assembled)", 149],
    'ZASY-INT-KIT': ["Pre-drilled Kit: Single (ships unassembled)", 99],
    'ZASY-INT-KIT-DBL-FLOAT': ["Pre-drilled Kit: Double, Floating Astragal", 199],
    'ZASY-INT-KIT-DBL-FIXED': ["Pre-drilled Kit: Double, Fixed Astragal", 199],
    'ZASY-INT-KIT-DBL-NONE': ["Pre-drilled Kit: Double, No Astragal", 199],
    'ZASY-INT-COMP': ["Components (ships loose, no prep)", 0]
  };
  // Prices stay in the catalog for a later customer-facing version but are
  // not shown for now.
  var SHOW_PRICES = false;
  function money(n) { return '$' + n.toFixed(2).replace(/\.00$/, ''); }
  // res = { lines: [{ sku, qty, why }], notes: [text], orderNotes: [text] }
  function renderItemList(root, rows) {
    var ul = root.querySelector('[data-item-list]');
    if (!ul) return;
    ul.textContent = '';
    rows.forEach(function (row) {
      var li = document.createElement('li');
      var a = document.createElement('span'); a.textContent = row[0];
      var b = document.createElement('strong'); b.textContent = row[1];
      li.appendChild(a); li.appendChild(b);
      ul.appendChild(li);
    });
  }
  function renderServices(root, ns, res, link) {
    var table = root.querySelector('[data-svc-table]');
    if (!table) return;
    table.textContent = '';
    var head = table.insertRow();
    (SHOW_PRICES ? ['SKU', 'Shop service', 'Qty', 'Price'] : ['SKU', 'Shop service', 'Qty']).forEach(function (h) {
      var th = document.createElement('th');
      th.textContent = h;
      head.appendChild(th);
    });
    var total = 0;
    var text = ['Shop services for this setup'];
    res.lines.forEach(function (l) {
      var c = SVC[l.sku] || [l.desc || '', 0];
      if (l.desc) c = [l.desc, c[1]];
      var row = table.insertRow();
      var props = l.props || {};
      var why = props.Door ? '' : l.why;     // the Door property already says which leaf
      var propText = Object.keys(props).map(function (k) { return k + ': ' + props[k]; }).join(' \u00b7 ');
      var cells = [l.sku, c[0] + (why ? ' \u2014 ' + why : ''), String(l.qty)];
      if (SHOW_PRICES) cells.push(money(c[1] * l.qty));
      cells.forEach(function (v, k) {
        var td = row.insertCell();
        td.textContent = v;
        if (k === 0) td.className = 'is-sku';
        if (k === 1 && propText) {
          var sm = document.createElement('small');
          sm.className = 'pease-svc-props';
          sm.textContent = propText;
          td.appendChild(sm);
        }
      });
      total += c[1] * l.qty;
      text.push(l.sku + '  x' + l.qty + '  ' + (SHOW_PRICES ? money(c[1] * l.qty) + '  ' : '') + c[0] + (why ? ' (' + why + ')' : '') +
        Object.keys(props).map(function (k) { return '  [' + k + ': ' + props[k] + ']'; }).join(''));
    });
    if (SHOW_PRICES) {
      var foot = table.insertRow();
      foot.className = 'is-total';
      var a = foot.insertCell(); a.colSpan = 3; a.textContent = 'Total shop services';
      foot.insertCell().textContent = money(total);
      text.push('Total: ' + money(total));
    }
    var ul = root.querySelector('[data-svc-notes]');
    ul.textContent = '';
    res.notes.concat(res.orderNotes.map(function (n) { return 'Order notes: ' + n; })).forEach(function (n) {
      var li = document.createElement('li');
      li.textContent = n;
      ul.appendChild(li);
    });
    if (res.notes.length) text.push('', 'Notes:', '- ' + res.notes.join('\n- '));
    if (res.orderNotes.length) text.push('', 'Order notes:', '- ' + res.orderNotes.join('\n- '));
    text.push('', 'Setup link: ' + link);
    root._svcText = text.join('\n');
    var svcSum = root.querySelector('[data-svc-summary]');
    if (svcSum) svcSum.textContent = res.lines.length + ' SKU' + (res.lines.length === 1 ? '' : 's') + ' \u00b7 for Pease staff';
  }
  function wireServices(root) {
    var btn = root.querySelector('[data-action="copy-skus"]');
    var out = root.querySelector('[data-svc-msg]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var t = root._svcText || '';
      function done() { out.textContent = 'SKU list copied.'; }
      function fallback() { window.prompt('Copy the SKU list:', t); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t).then(done, fallback);
      else fallback();
    });
  }

  function svgTitle(el, text) {
    var t = document.createElementNS('http://www.w3.org/2000/svg', 'title');
    t.textContent = text;
    el.appendChild(t);
    return el;
  }

  function initPeaseCalculators() {
    // ---- shell ----
    document.querySelectorAll('.pease-calc-shell').forEach(function (shell) {
    if (!shell || shell.dataset.shellInit) return;
    shell.dataset.shellInit = '1';

    var tabs = shell.querySelectorAll('[data-calc-tab]');
    var panels = shell.querySelectorAll('[data-calc-panel]');

    function activate(name) {
      tabs.forEach(function (t) {
        var active = t.getAttribute('data-calc-tab') === name;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var show = p.getAttribute('data-calc-panel') === name;
        if (show) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
      // Trigger a resize so any nested calculator that listens to it
      // (some SVG layouts do) reflows now that its panel is visible.
      try { window.dispatchEvent(new Event('resize')); } catch (e) {}
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        activate(t.getAttribute('data-calc-tab'));
      });
    });

    // Default: exterior is active (matches markup).
    });

    // ---- dsc ----
    document.querySelectorAll('.pease-dsc').forEach(function (sectionEl) {
    if (!sectionEl || sectionEl.dataset.initialized) return;
    sectionEl.dataset.initialized = '1';
    var DOOR = window.PEASE_DOOR_DATA || null;
    renderStyleThumbs();
    wireChoices(sectionEl);
    var sizeByOpening = roSizer(sectionEl, function (t) { return calculate(t); }, {
      widthKey: function (i) { return i.numDoors > 0 ? 'slabW' : 'sideliteW'; },
      std: function (i) {
        var dc = doorChoice(i);
        if (dc && dc.sizes.length) {
          var ws = [], hs = [];
          dc.sizes.forEach(function (z) {
            if (ws.indexOf(z.w) < 0) ws.push(z.w);
            if (hs.indexOf(z.h) < 0) hs.push(z.h);
          });
          return { slabW: ws, sideliteW: [9.875, 11.875, 13.875], slabH: hs };
        }
        return { slabW: [29.75, 31.75, 33.75, 35.75, 41.75], sideliteW: [9.875, 11.875, 13.875], slabH: [79, 80, 83, 84, 95, 96] };
      },
      range: { slabW: [20, 50], sideliteW: [9, 50], slabH: [70, 100] }
    });
    sectionEl._calcKey = 'ext';
    if (!window._peaseHashWatch) {
      window._peaseHashWatch = true;
      window.addEventListener('hashchange', function () {
        if (/(^#|&)calc=/.test(location.hash)) location.reload();
      });
    }
    applyShare(sectionEl, 'ext');
    wireShare(sectionEl, 'ext');
    wireServices(sectionEl);
    wireSticky(sectionEl, 'dsc');
    // Drawing shortcuts: click a door to flip handing, the plan swing to
    // switch inswing/outswing.
    sectionEl.querySelectorAll('[data-drawing]').forEach(function (svg) {
      svg.addEventListener('click', function (e) {
        var t = e.target.closest('[data-draw-action]');
        if (!t) return;
        var flip = t.getAttribute('data-draw-action') === 'flip-handing';
        var sel = sectionEl.querySelector('[data-input="' + (flip ? 'handing' : 'swing') + '"]');
        sel.value = flip ? (sel.value === 'Left' ? 'Right' : 'Left') : (sel.value === 'Inswing' ? 'Outswing' : 'Inswing');
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // ---- Fraction formatter (inches → nearest 1/8", displayed as mixed fraction) ----
    function toFraction(v, den) {
      if (v === null || v === undefined || v === 'na' || (typeof v === 'number' && !isFinite(v))) return 'n/a';
      if (typeof v !== 'number') return v;
      den = den || 8;
      var sign = v < 0 ? '-' : '';
      v = Math.abs(v);
      var whole = Math.floor(v);
      var frac = v - whole;
      var numer = Math.round(frac * den);
      if (numer === den) { whole += 1; numer = 0; }
      if (numer === 0) return sign + whole + '"';
      // reduce
      while (numer % 2 === 0) { numer /= 2; den /= 2; }
      return sign + (whole > 0 ? whole + ' ' : '') + numer + '/' + den + '"';
    }

    // 1/16" precision helper — used for values that can land on 16ths rather
    // than 8ths (e.g. wall/jamb depths like 4 9/16", 6 9/16").
    function toFraction16(v) { return toFraction(v, 16); }

    // ---- Round to nearest 1/8" (matches Excel ROUND(x*8,0)/8) ----
    function r8(v) { return Math.round(v * 8) / 8; }
    // ---- Round to nearest 1/16" — used as the canonical input snap so all
    //      downstream dimensions land on a 1/16" grid and display without
    //      rounding distortion. ----
    function r16(v) { return Math.round(v * 16) / 16; }

    // ---- Fractional input parsing ----
    // Accepts: "33", "33.5", "33.5625",
    //          "33 9/16", "33-9/16",  (whole + space/dash + fraction)
    //          "9/16",                 (pure fraction)
    //          and tolerates a trailing inch mark.
    // Returns NaN if it can't parse.
    function parseFractional(raw) {
      if (raw === null || raw === undefined) return NaN;
      var s = String(raw).trim();
      if (!s) return NaN;
      s = s.replace(/["”]$/, '').trim();
      if (/^-?\d+(\.\d+)?$/.test(s)) return parseFloat(s);
      var pure = s.match(/^(\d+)\s*\/\s*(\d+)$/);
      if (pure) {
        var d1 = parseInt(pure[2], 10);
        return d1 === 0 ? NaN : parseInt(pure[1], 10) / d1;
      }
      var mixed = s.match(/^(\d+)(?:\s+|-)(\d+)\s*\/\s*(\d+)$/);
      if (mixed) {
        var d2 = parseInt(mixed[3], 10);
        return d2 === 0 ? NaN : parseInt(mixed[1], 10) + parseInt(mixed[2], 10) / d2;
      }
      return NaN;
    }

    // Snap to nearest 1/16" and clamp to [data-min, data-max] on the input.
    function snapAndClamp(value, el) {
      var snapped = r16(value);
      var min = parseFloat(el.getAttribute('data-min'));
      var max = parseFloat(el.getAttribute('data-max'));
      if (!isNaN(min) && snapped < min) snapped = r16(min);
      if (!isNaN(max) && snapped > max) snapped = r16(max);
      return snapped;
    }

    // Canonical input display: like toFraction16 but without the inch mark.
    function formatFractionalInput(v) {
      return toFraction16(v).replace(/["”]$/, '');
    }

    // ---- Input gathering ----
    function getInputs() {
      var g = function (k) { return sectionEl.querySelector('[data-input="' + k + '"]'); };
      // num() reads numeric inputs. Fractional text inputs parse via
      // parseFractional; empty fractional fields fall back to data-default
      // so the placeholder ghost text acts as the working default.
      var num = function (k) {
        var el = g(k);
        if (el.getAttribute('data-fractional') === 'true') {
          var raw = el.value.trim();
          if (!raw) {
            var def = el.getAttribute('data-default');
            var dn = parseFractional(def);
            return isNaN(dn) ? 0 : dn;
          }
          var n = parseFractional(raw);
          return isNaN(n) ? 0 : n;
        }
        return parseFloat(el.value) || 0;
      };
      // numOpt() reads an optional override (Advanced settings): blank or
      // unparseable means "use the standard value" and returns null.
      var numOpt = function (k) {
        var n = parseFractional(g(k).value.trim());
        return isNaN(n) ? null : n;
      };
      var str = function (k) { return g(k).value; };
      var slabW = num('slabW'), slabH = num('slabH');
      var hingeCountSel = str('hingeCount'), backsetSel = str('backset');
      var numSlRaw = str('numSidelites');                       // "0" | "1" | "1L" | "1R" | "2"
      var sideliteSide = /L$/.test(numSlRaw) ? 'L'
                       : /R$/.test(numSlRaw) ? 'R'
                       : null;
      return {
        slabW: slabW,
        slabH: slabH,
        handing: str('handing'),
        swing: str('swing'),
        threshold: str('threshold'),
        numDoors: parseInt(str('numDoors'), 10),
        numSidelites: parseInt(numSlRaw, 10),
        sideliteSide: sideliteSide,        // 'L' or 'R' for 1-sidelite + doors; null otherwise
        sideliteW: num('sideliteW'),
        transom: parseInt(str('transom'), 10),
        transomH: num('transomH'),
        hingeSize: num('hingeSize'),
        // "auto" = the Shop Services Guide standard for this door size
        hingeCount: hingeCountSel === 'auto' ? stdHingeCount(slabH) : parseInt(hingeCountSel, 10),
        hingeCountStd: stdHingeCount(slabH),
        firstHingeOffset: num('firstHingeOffset'),
        hinge2: numOpt('hinge2'),           // Advanced overrides (null = standard)
        hinge3: numOpt('hinge3'),
        hinge4: numOpt('hinge4'),
        latchBoreTop: numOpt('latchBoreTop'),
        mullHeadDrop: num('mullHeadDrop'),
        mullSillDeck: num('mullSillDeck'),
        lockPrep: str('lockPrep'),          // 'double' | 'single' | 'none'
        boreSpacing: num('boreSpacing'),    // deadbolt-to-latch, center to center
        backset: backsetSel === 'auto' ? stdBackset(slabW) : parseFloat(backsetSel),
        backsetStd: stdBackset(slabW),
        jambDepthPreset: parseFloat(str('jambDepthPreset')),
        jambDepthCustom: numOpt('jambDepthCustom'),
        jambDepth: numOpt('jambDepthCustom') !== null ? numOpt('jambDepthCustom') : parseFloat(str('jambDepthPreset')),
        sizeMode: str('sizeMode'),          // 'slab' | 'ro' (size by rough opening)
        roW: num('roW'),
        roH: num('roH'),
        ship: str('ship'),                  // 'prehung' | 'kit' | 'slab' | 'components'
        hingePrep: str('hingePrep'),        // slab/components only: 'yes' | 'no'
        doorMaterial: str('doorMaterial'),  // 'none' | 'fiberglass' | 'steel'
        doorStyle: str('doorStyle'),        // style code, e.g. '6PT'
        doorTexture: str('doorTexture'),    // 'SFG' | 'RFG' (fiberglass)
        doorBuild: str('doorBuild'),        // 'PRM' | 'IMP' | 'FRE' | 'SED' | 'WED'
        doorCut: str('doorCut'),            // cutout SKU or 'none'
        sideCut: str('sideCut'),            // sidelite cutout SKU or 'none'
        cutInstall: str('cutInstall'),      // door glass: 'yes' | 'no'
        sideInstall: str('sideInstall'),    // sidelite glass: 'yes' | 'no'
        petDoor: str('petDoor'),            // pet door cutout SKU or 'none'
        petBottom: numOpt('petBottom')      // inches above the slab bottom (null = 5 1/8)
      };
    }

    // Shop Services Guide standards. Hinges: 3, or 4 above 84 1/2".
    // Backset: 2 3/8", long 2 3/4" on doors wider than 36", short 2" on
    // doors narrower than 32". Judged on the nominal door width, so an
    // exterior 35 3/4" slab (a 36" door) stays standard.
    function stdHingeCount(slabH) { return slabH > 84.5 ? 4 : 3; }
    // Minimum slab above the top hinge and below the bottom hinge.
    var HINGE_EDGE_MIN = 4;
    function stdBackset(slabW) {
      if (slabW > 36.25) return 2.75;
      if (slabW < 31.5) return 2;
      return 2.375;
    }

    // Standard values for the Advanced settings, used to flag custom setups.
    var ADV_STD = { hingeSize: 4, firstHingeOffset: 6.5, mullHeadDrop: 0.75, mullSillDeck: 0.625 };
    function customHinges(i) {
      return i.hinge2 !== null || (i.hingeCount >= 3 && i.hinge3 !== null)
        || (i.hingeCount === 4 && i.hinge4 !== null)
        || i.hingeCount !== i.hingeCountStd
        || Math.abs(i.hingeSize - ADV_STD.hingeSize) > 1e-9
        || Math.abs(i.firstHingeOffset - ADV_STD.firstHingeOffset) > 1e-9;
    }
    function hasCustomAdvanced(i) {
      return customHinges(i)
        || (i.lockPrep !== 'none' && i.latchBoreTop !== null)
        || (i.lockPrep !== 'none' && i.backset !== i.backsetStd)
        || (i.lockPrep === 'double' && Math.abs(i.boreSpacing - 5.5) > 1e-9)
        || i.jambDepthCustom !== null
        || i.threshold !== 'Saddle'
        || Math.abs(i.firstHingeOffset - ADV_STD.firstHingeOffset) > 1e-9
        || Math.abs(i.mullHeadDrop - ADV_STD.mullHeadDrop) > 1e-9
        || Math.abs(i.mullSillDeck - ADV_STD.mullSillDeck) > 1e-9;
    }

    var LOCK_PREP_LABELS = {
      double: 'Double bore',
      single: 'Single bore (latch only)',
      none: 'No bore'
    };

    // ---- Constants (from spreadsheet's Assumptions block) ----
    var C = {
      jambLegLen: 2.75,          // D27
      bumperJambReduce: 1,       // D28
      slabToJambOffset: 0.875,   // D29
      astragalAdder: 0.5,        // D30
      slabHeadGap: 0.25,         // D31
      sideliteHeadGap: 0.125,    // D32
      jambThickness: 0.75,       // D33
      bmLegInswing: 1.25,        // D34
      bmLegOutswing: 1.5,        // D35
      bmHeadInswing: 2.5,        // D36
      bmHeadOutswing: 3,         // D37
      bmDepth: 1 + 3 / 16,       // D38
      dbMortLen: 2.25,           // D40
      latchMortLen: 2.25,        // D41
      boreDiameter: 2.125,       // Standard bore hole diameter (2 1/8")
      roSideMin: 0.5,            // D42
      roSideMax: 1.5,            // D43
      roTopMin: 0.25,            // D44
      roTopMax: 1                // D45
    };

    // A low-profile threshold keeps the high-dam height: the shop raises its adjustable cap 1/4"
    // to meet the sweep instead of cutting the jambs (Oct 27, 2026). Only a bumper shortens the unit.
    function jambReduce(i) {
      return i.threshold === 'Bumper' ? C.bumperJambReduce : 0;
    }

    // ---- Core calculation — ports Excel formulas in Calculator sheet ----
    function calculate(i) {
      var r = {};

      // D71 (corrected): Head jamb width spans from the inside of the left
      // outer jamb to the inside of the right outer jamb. It contains:
      //   - door contribution (slab + slabHeadGap, with astragalAdder if 2 doors)
      //   - each sidelite (sideliteW + sideliteHeadGap)
      //   - one mull (= 2 × jambThickness) between each sidelite and a door
      //     panel adjacent to it. Mulls only exist when there's at least one
      //     door AND at least one sidelite. With sidelite-only, no mulls.
      var headJambW;
      if (i.numDoors === 2) {
        headJambW = ((C.slabHeadGap + i.slabW) * 2) + C.astragalAdder;
      } else if (i.numDoors === 1) {
        headJambW = i.slabW + C.slabHeadGap;
      } else {
        headJambW = 0;
      }
      headJambW += i.numSidelites * (i.sideliteW + C.sideliteHeadGap);
      if (i.numDoors > 0) {
        headJambW += i.numSidelites * C.jambThickness * 2;
      }
      r.headJamb = headJambW;
      r.threshold = headJambW;

      // D57: Jamb height = slabH + jambLegLen - (1 if bumper). A low-profile threshold (inswing
      // low-profile or outswing saddle) has its adjustable cap raised 1/4" to meet the sweep.
      var jambH = i.slabH + C.jambLegLen - jambReduce(i);
      r.jambHt = jambH;

      // D8 (corrected): Unit width = head jamb + the two outer jambs.
      // The outer jambs always exist whenever there's any panel (door or
      // sidelite), so they always contribute jambThickness × 2 to the unit
      // width.
      var unitW = headJambW + (i.numDoors + i.numSidelites > 0 ? C.jambThickness * 2 : 0);
      r.unitW = unitW;

      // D9: Unit height (no brickmold) = D57 + (D20*D21)
      var unitH = jambH + (i.transom * i.transomH);
      r.unitH = unitH;

      // D10: Depth = D25
      r.unitD = i.jambDepth;

      // D75: Brickmold legs = jambH + inswing:1.25/outswing:1.5 + transom
      var bmLegs = jambH + (i.swing === 'Inswing' ? C.bmLegInswing : C.bmLegOutswing)
                 + (i.transom * i.transomH);
      r.bmLegs = bmLegs;

      // D76: Brickmold head = unitW + inswing:2.5/outswing:3
      var bmHead = unitW + (i.swing === 'Inswing' ? C.bmHeadInswing : C.bmHeadOutswing);
      r.bmHead = bmHead;

      // H8, H9, H10 (with brickmold)
      r.unitBmW = bmHead;
      r.unitBmH = bmLegs;
      r.unitBmD = i.jambDepth + C.bmDepth;

      // Rough opening
      r.roWmin = unitW + C.roSideMin;
      r.roWmax = unitW + C.roSideMax;
      r.roHmin = unitH + C.roTopMin;
      r.roHmax = unitH + C.roTopMax;
      // RO depth (wall thickness) relative to jamb depth:
      // jamb must be >= wall and <= wall + 1/8", so wall ranges jamb-1/8 to jamb.
      r.roDmin = i.jambDepth - 0.125;
      r.roDmax = i.jambDepth;

      // ---- Slab hinge positions (rounded to 1/8") ----
      // E49 = firstHingeOffset
      r.slab1 = r8(i.firstHingeOffset);

      // Common formula used in both branches of E50:
      // ((slabH - (hingeCount*hingeSize) - firstOffset*2) / (hingeCount-1)) + firstOffset + hingeSize
      var slab2_raw = ((i.slabH - (i.hingeCount * i.hingeSize) - i.firstHingeOffset * 2)
                       / (i.hingeCount - 1)) + i.firstHingeOffset + i.hingeSize;
      r.slab2 = r8(slab2_raw);

      // E51: hingeCount=3 → slabH - (firstOffset + hingeSize); else → slab2_raw + firstOffset/term + hingeSize
      // 2 hinges: the formula above already lands the 2nd hinge at
      // slabH - (firstOffset + hingeSize), mirroring the top hinge.
      if (i.hingeCount === 2) {
        r.slab3 = 'na';
        r.slab4 = 'na';
      } else if (i.hingeCount === 3) {
        r.slab3 = r8(i.slabH - (i.firstHingeOffset + i.hingeSize));
        r.slab4 = 'na';
      } else {
        var slab3_raw = ((i.slabH - (i.hingeCount * i.hingeSize) - i.firstHingeOffset * 2)
                         / (i.hingeCount - 1)) + slab2_raw + i.hingeSize;
        r.slab3 = r8(slab3_raw);
        // E52: slabH - (firstOffset + hingeSize)  [note: formula uses D24, which is firstHingeOffset]
        r.slab4 = r8(i.slabH - (i.firstHingeOffset + i.hingeSize));
      }

      // Advanced overrides: keep the standard positions in r.std (the
      // override fields show them as placeholders), then apply any override.
      r.std = { slab2: r.slab2, slab3: r.slab3, slab4: r.slab4 };
      if (i.hinge2 !== null) r.slab2 = r8(i.hinge2);
      if (i.hinge3 !== null && r.slab3 !== 'na') r.slab3 = r8(i.hinge3);
      if (i.hinge4 !== null && r.slab4 !== 'na') r.slab4 = r8(i.hinge4);

      // Bore holes
      // Lock prep: double bore (latch + deadbolt), single bore (latch only,
      // same latch position as a double), or no bore at all.
      var hasLatch = i.lockPrep !== 'none';
      var hasDeadbolt = i.lockPrep === 'double';
      r.hasLatch = hasLatch;
      r.hasDeadbolt = hasDeadbolt;
      // E55: slabH < 84.5 ? slabH - 33.125 : slabH - 38.625
      var latchBore = i.slabH < 84.5 ? (i.slabH - 33.125) : (i.slabH - 38.625);
      r.std.latchBore = r8(latchBore);
      if (i.latchBoreTop !== null) latchBore = i.latchBoreTop;
      // E54: deadbolt = latch - bore spacing (std 5.5)
      var dbBore = latchBore - i.boreSpacing;
      r.latchBore = hasLatch ? r8(latchBore) : 'na';
      r.deadboltBore = hasDeadbolt ? r8(dbBore) : 'na';

      // ---- Jamb measurements (add slabToJambOffset to slab positions) ----
      var off = C.slabToJambOffset;
      r.jamb1 = r.slab1 === 'na' ? 'na' : r.slab1 + off;
      r.jamb2 = r.slab2 === 'na' ? 'na' : r.slab2 + off;
      r.jamb3 = r.slab3 === 'na' ? 'na' : r.slab3 + off;
      r.jamb4 = r.slab4 === 'na' ? 'na' : r.slab4 + off;

      // Strike positions
      if (hasDeadbolt) {
        var dbStrike = r.deadboltBore + off;
        r.dbStrike = dbStrike;
        r.dbMortTop = dbStrike - C.dbMortLen / 2;
        r.dbMortBot = dbStrike + C.dbMortLen / 2;
      } else {
        r.dbStrike = r.dbMortTop = r.dbMortBot = 'na';
      }

      if (hasLatch) {
        var latchStrike = r.latchBore + off;
        r.latchStrike = latchStrike;
        r.latchMortTop = latchStrike - C.latchMortLen / 2;
        r.latchMortBot = latchStrike + C.latchMortLen / 2;
      } else {
        r.latchStrike = r.latchMortTop = r.latchMortBot = 'na';
      }

      // ---- Mull posts ----
      // Walk the panel layout and classify every door edge: an edge that
      // meets a sidelite lands on a mull post, an outer edge lands on a leg
      // jamb. The mull tenons into a mortise in the head jamb, so its top
      // sits mullHeadDrop (std 3/4") below the top of the leg jambs and every
      // mull prep location is the leg jamb value minus that. Its bottom sits
      // on the threshold sill deck, mullSillDeck (std 5/8") above the bottom
      // of the leg jambs: a 79" slab gets 81 3/4" legs and an 80 3/8" mull.
      var prep = classifyPrepEdges(buildPanels(i));
      r.mullCount = prep.mullCount;
      r.mullHinge = prep.mullHinge;        // # of mulls carrying hinge prep
      r.mullStrike = prep.mullStrike;      // # of mulls carrying strike prep
      r.legHinge = prep.legHinge;          // a leg jamb carries hinge prep
      r.legStrike = prep.legStrike;        // a leg jamb (or astragal) carries strike prep
      var drop = function (v) { return v === 'na' ? 'na' : v - i.mullHeadDrop; };
      r.mullHt = jambH - i.mullHeadDrop - i.mullSillDeck;
      r.mull1 = drop(r.jamb1);
      r.mull2 = drop(r.jamb2);
      r.mull3 = drop(r.jamb3);
      r.mull4 = drop(r.jamb4);
      r.mullDbMortTop = drop(r.dbMortTop);
      r.mullDbStrike = drop(r.dbStrike);
      r.mullDbMortBot = drop(r.dbMortBot);
      r.mullLatchMortTop = drop(r.latchMortTop);
      r.mullLatchStrike = drop(r.latchStrike);
      r.mullLatchMortBot = drop(r.latchMortBot);

      return r;
    }

    // Classify where each door's hinge and strike edges land. Panels come
    // from buildPanels() in left-to-right (exterior view) order. A door's
    // hinge edge is on its p.hinge side; the strike edge is the other side
    // and only matters on the active door (passive leaves carry flush bolts).
    // Each mull sits between a door and a sidelite.
    function classifyPrepEdges(panels) {
      var out = { mullCount: 0, mullHinge: 0, mullStrike: 0, legHinge: false, legStrike: false };
      for (var k = 0; k < panels.length - 1; k++) {
        var a = panels[k].type, b = panels[k + 1].type;
        if (a !== b) out.mullCount++;
      }
      var single = panels.filter(function (p) { return p.type === 'door'; }).length === 1;
      panels.forEach(function (p, k) {
        if (p.type !== 'door') return;
        var hingeNbr = p.hinge === 'L' ? panels[k - 1] : panels[k + 1];
        if (!hingeNbr) out.legHinge = true;
        else if (hingeNbr.type === 'sidelite') out.mullHinge++;
        if (p.active || single) {
          var strikeNbr = p.hinge === 'L' ? panels[k + 1] : panels[k - 1];
          if (strikeNbr && strikeNbr.type === 'sidelite') out.mullStrike++;
          else out.legStrike = true; // leg jamb, or the astragal on a pair
        }
      });
      return out;
    }

    // ============================================================
    // DRAWING — SVG elevation + plan with swing arc
    // Coordinate system: real-world inches, scaled to fit a pixel
    // viewport. All geometry derived from the same calculate() result
    // so the drawing is guaranteed consistent with displayed numbers.
    // ============================================================
    var SVG_NS = 'http://www.w3.org/2000/svg';
    function svgMk(tag, attrs) {
      var e = document.createElementNS(SVG_NS, tag);
      for (var k in attrs) e.setAttribute(k, attrs[k]);
      return e;
    }
    function svgClear(svg) { while (svg.firstChild) svg.removeChild(svg.firstChild); }

    // Panel layout — which panels (door/sidelite), in what order, which is active.
    // Mirrors the spreadsheet's unit composition logic, interpreted visually.
    // Compute the hinge side (viewed from EXTERIOR, which is the elevation's
    // orientation) for an active door given the handing and swing inputs.
    //
    // Industry convention:
    //   Inswing  + Left Hand  → hinges on LEFT  (from exterior)
    //   Inswing  + Right Hand → hinges on RIGHT
    //   Outswing + Left Hand  → hinges on RIGHT (flipped from inswing)
    //   Outswing + Right Hand → hinges on LEFT
    //
    // Handing describes the *swing direction* of the door (the standard
    // "stand at the hinges, look toward the lock" rule), and that resolves to
    // opposite hinge sides in the exterior view depending on swing.
    function activeHingeSide(handing, swing) {
      if (swing === 'Outswing') {
        return handing === 'Left' ? 'R' : 'L';
      }
      return handing === 'Left' ? 'L' : 'R';
    }

    function buildPanels(i) {
      var panels = [];
      var hinge = activeHingeSide(i.handing, i.swing);
      var hingeOnLeft = (hinge === 'L');
      // For 1-sidelite configurations, respect the user's explicit choice of
      // which side (from exterior view) the sidelite goes on. Fall back to
      // putting it on the strike side of the active door if no side was
      // specified (legacy/no-doors case).
      var sideliteOnLeft;
      if (i.sideliteSide === 'L') sideliteOnLeft = true;
      else if (i.sideliteSide === 'R') sideliteOnLeft = false;
      else sideliteOnLeft = !hingeOnLeft; // legacy: strike side of active door

      if (i.numDoors === 1 && i.numSidelites === 1) {
        if (sideliteOnLeft) {
          panels.push({type:'sidelite'});
          panels.push({type:'door', hinge: hinge, active:true});
        } else {
          panels.push({type:'door', hinge: hinge, active:true});
          panels.push({type:'sidelite'});
        }
      } else if (i.numDoors === 1 && i.numSidelites === 2) {
        panels.push({type:'sidelite'});
        panels.push({type:'door', hinge: hinge, active:true});
        panels.push({type:'sidelite'});
      } else if (i.numDoors === 2 && i.numSidelites === 0) {
        // Active door placed on the side corresponding to its hinge side.
        // The other door is the passive (astragal) door, with its own hinge
        // on the outer side of the unit.
        panels.push({type:'door', hinge:'L', active: hingeOnLeft, astragal: !hingeOnLeft});
        panels.push({type:'door', hinge:'R', active: !hingeOnLeft, astragal: hingeOnLeft});
      } else if (i.numDoors === 2 && i.numSidelites === 1) {
        // Sidelite placement honors the user's explicit choice. The active
        // door stays on the side matching its hinge side; the passive door
        // (astragal) sits between the active door and the sidelite (or jamb,
        // depending on which side the sidelite is on).
        if (sideliteOnLeft) {
          panels.push({type:'sidelite'});
          if (hingeOnLeft) {
            // Active on left (next to sidelite), passive on right (next to jamb)
            panels.push({type:'door', hinge:'L', active:true});
            panels.push({type:'door', hinge:'R', astragal:true});
          } else {
            // Active on right (next to jamb), passive on left (next to sidelite)
            panels.push({type:'door', hinge:'L', astragal:true});
            panels.push({type:'door', hinge:'R', active:true});
          }
        } else {
          if (hingeOnLeft) {
            panels.push({type:'door', hinge:'L', active:true});
            panels.push({type:'door', hinge:'R', astragal:true});
          } else {
            panels.push({type:'door', hinge:'L', astragal:true});
            panels.push({type:'door', hinge:'R', active:true});
          }
          panels.push({type:'sidelite'});
        }
      } else if (i.numDoors === 2 && i.numSidelites === 2) {
        panels.push({type:'sidelite'});
        panels.push({type:'door', hinge:'L', active: hingeOnLeft, astragal: !hingeOnLeft});
        panels.push({type:'door', hinge:'R', active: !hingeOnLeft, astragal: hingeOnLeft});
        panels.push({type:'sidelite'});
      } else if (i.numDoors === 1 && i.numSidelites === 0) {
        panels.push({type:'door', hinge: hinge, active:true});
      } else if (i.numDoors === 0) {
        for (var k = 0; k < i.numSidelites; k++) panels.push({type:'sidelite'});
      }
      return panels;
    }

    // Given a list of panels and the available interior width (between outer
    // jambs), compute each panel's x-offset and drawn width.
    function layoutPanels(i, panels, totalInnerW) {
      var jt = C.jambThickness;
      var mullCount = Math.max(0, panels.length - 1);
      var avail = totalInnerW - mullCount * jt;
      var realWs = panels.map(function (p) { return p.type === 'door' ? i.slabW : i.sideliteW; });
      var total = realWs.reduce(function (a, b) { return a + b; }, 0);
      var scale = total > 0 ? avail / total : 1;
      var widths = realWs.map(function (w) { return w * scale; });
      var x = 0;
      return widths.map(function (w, idx) {
        var pos = { x: x, w: w };
        x += w;
        if (idx < panels.length - 1) x += jt;
        return pos;
      });
    }

    // Horizontal dimension line. By default, extension ticks extend upward
    // toward the drawing and the label sits below the dim line (dim is below
    // the feature). Pass labelAbove=true to flip: ticks extend downward toward
    // the drawing, label sits above (dim is above the feature).
    // Horizontal dimension line. By default, extension ticks extend upward
    // toward the drawing and the label sits below the dim line (dim is BELOW
    // the feature). Pass labelAbove=true to flip: ticks extend downward, label
    // sits above (dim is ABOVE the feature).
    //
    // Arrow convention: both arrowheads point INWARD toward the span center
    // (apex at the span boundary, base inside the span). Robust to xL/xR
    // ordering — the caller may pass either as either parameter.
    function drawHorizDim(svg, xL, xR, y, label, color, labelAbove) {
      // Normalize so xLeft is the smaller SVG x and xRight is larger.
      var xLeft = Math.min(xL, xR);
      var xRight = Math.max(xL, xR);
      var extLen = 5, extReach = 14, arrowSize = 5;
      var tickDir = labelAbove ? 1 : -1; // ticks point toward drawing
      var labelOffset = labelAbove ? -6 : 14; // label on opposite side
      // Extension ticks
      svg.appendChild(svgMk('line', {
        x1: xLeft, y1: y + tickDir * extLen,
        x2: xLeft, y2: y + tickDir * extReach,
        stroke: color, 'stroke-width': 0.5
      }));
      svg.appendChild(svgMk('line', {
        x1: xRight, y1: y + tickDir * extLen,
        x2: xRight, y2: y + tickDir * extReach,
        stroke: color, 'stroke-width': 0.5
      }));
      // Main dim line
      svg.appendChild(svgMk('line', {
        x1: xLeft, y1: y, x2: xRight, y2: y,
        stroke: color, 'stroke-width': 0.8
      }));
      // Left arrow: apex at xLeft, base INSIDE span (to the right). ▶ shape.
      svg.appendChild(svgMk('polygon', {
        points: xLeft + ',' + y + ' '
              + (xLeft + arrowSize) + ',' + (y - arrowSize / 2) + ' '
              + (xLeft + arrowSize) + ',' + (y + arrowSize / 2),
        fill: color
      }));
      // Right arrow: apex at xRight, base INSIDE span (to the left). ◀ shape.
      svg.appendChild(svgMk('polygon', {
        points: xRight + ',' + y + ' '
              + (xRight - arrowSize) + ',' + (y - arrowSize / 2) + ' '
              + (xRight - arrowSize) + ',' + (y + arrowSize / 2),
        fill: color
      }));
      // Label
      var t = svgMk('text', {
        x: (xLeft + xRight) / 2, y: y + labelOffset,
        'text-anchor': 'middle', 'font-size': 11, 'font-weight': 700,
        fill: color, 'font-family': 'Source Sans 3, Source Sans Pro, sans-serif'
      });
      t.textContent = label;
      svg.appendChild(t);
    }

    // Vertical dimension line (arrows inward, label rotated 90° left of line)
    // Vertical dimension line. By default, extension ticks extend leftward
    // toward the drawing and the label sits to the right of the dim line (dim
    // is on the RIGHT side of the feature). Pass labelRight=false to flip:
    // ticks extend rightward toward the drawing, label sits to the left (dim
    // is on the LEFT side of the feature).
    //
    // Arrow convention: both arrowheads point INWARD toward the span center
    // (apex at the span boundary, base inside the span). This function is
    // robust to either yT/yB ordering — the caller may pass the top boundary
    // as either parameter. The function normalizes internally.
    function drawVertDim(svg, x, yT, yB, label, color, labelRight) {
      if (labelRight === undefined) labelRight = true;
      // Normalize so yTop is the smaller SVG y (top of screen) and yBot is
      // larger (bottom of screen), regardless of which we were passed as yT/yB.
      var yTop = Math.min(yT, yB);
      var yBot = Math.max(yT, yB);
      var extLen = 5, extReach = 14, arrowSize = 5;
      var tickDir = labelRight ? -1 : 1; // ticks point toward drawing
      var labelOffset = labelRight ? 14 : -14;
      // Extension ticks — reach from just past the dim line (at x+extLen)
      // toward the feature (at x+extReach in the tickDir direction).
      svg.appendChild(svgMk('line', {
        x1: x + tickDir * extLen, y1: yTop,
        x2: x + tickDir * extReach, y2: yTop,
        stroke: color, 'stroke-width': 0.5
      }));
      svg.appendChild(svgMk('line', {
        x1: x + tickDir * extLen, y1: yBot,
        x2: x + tickDir * extReach, y2: yBot,
        stroke: color, 'stroke-width': 0.5
      }));
      // Main dim line between the two endpoints
      svg.appendChild(svgMk('line', {
        x1: x, y1: yTop, x2: x, y2: yBot,
        stroke: color, 'stroke-width': 0.8
      }));
      // Top arrow: apex at yTop, base INSIDE the span (below apex on screen).
      // This is a ▼ shape pointing down into the span.
      svg.appendChild(svgMk('polygon', {
        points: x + ',' + yTop + ' '
              + (x - arrowSize / 2) + ',' + (yTop + arrowSize) + ' '
              + (x + arrowSize / 2) + ',' + (yTop + arrowSize),
        fill: color
      }));
      // Bottom arrow: apex at yBot, base INSIDE the span (above apex on screen).
      // This is a ▲ shape pointing up into the span.
      svg.appendChild(svgMk('polygon', {
        points: x + ',' + yBot + ' '
              + (x - arrowSize / 2) + ',' + (yBot - arrowSize) + ' '
              + (x + arrowSize / 2) + ',' + (yBot - arrowSize),
        fill: color
      }));
      // Rotated label in the middle
      var cy = (yTop + yBot) / 2;
      var t = svgMk('text', {
        x: x + labelOffset, y: cy + 4,
        'text-anchor': 'middle', 'font-size': 11, 'font-weight': 700,
        fill: color, 'font-family': 'Source Sans 3, Source Sans Pro, sans-serif',
        transform: 'rotate(-90 ' + (x + labelOffset) + ' ' + cy + ')'
      });
      t.textContent = label;
      svg.appendChild(t);
    }

    // Elevation view (front, looking at exterior)
    function drawElevation(i, r, showBm) {
      var svg = sectionEl.querySelector('[data-drawing="elevation"]');
      if (!svg) return;
      svgClear(svg);

      var DIM_MARGIN = 60;
      var logicalW = Math.max(r.unitW, r.unitBmW);
      var logicalH = Math.max(r.unitH, r.unitBmH);
      // Pick a scale that gives a comfortable on-screen size. Elevation target
      // roughly 520x520px; the SVG itself will stretch to its container.
      var availW = 520 - DIM_MARGIN * 2;
      var availH = 520 - DIM_MARGIN * 2;
      var scale = Math.min(availW / logicalW, availH / logicalH);

      var drawnW = logicalW * scale + DIM_MARGIN * 2;
      var drawnH = logicalH * scale + DIM_MARGIN * 2;
      svg.setAttribute('viewBox', '0 0 ' + drawnW + ' ' + drawnH);
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');

      var bmSideProj = (r.unitBmW - r.unitW) / 2;
      var bmTopProj = r.unitBmH - r.unitH;
      var unitXinLogical = bmSideProj; // center unit within logical box
      var unitLeftPx = DIM_MARGIN + unitXinLogical * scale;
      var unitBottomPxY = DIM_MARGIN + logicalH * scale;

      function px(x) { return unitLeftPx + x * scale; }
      function py(y) { return unitBottomPxY - y * scale; }

      // Brickmold (drawn behind unit)
      if (showBm) {
        svg.appendChild(svgMk('rect', {
          x: px(-bmSideProj), y: py(r.unitH + bmTopProj),
          width: r.unitBmW * scale, height: bmTopProj * scale,
          fill: '#FEF6EC', stroke: '#CC5E47', 'stroke-width': 1.25
        }));
        svg.appendChild(svgMk('rect', {
          x: px(-bmSideProj), y: py(r.unitH),
          width: bmSideProj * scale, height: r.unitH * scale,
          fill: '#FEF6EC', stroke: '#CC5E47', 'stroke-width': 1.25
        }));
        svg.appendChild(svgMk('rect', {
          x: px(r.unitW), y: py(r.unitH),
          width: bmSideProj * scale, height: r.unitH * scale,
          fill: '#FEF6EC', stroke: '#CC5E47', 'stroke-width': 1.25
        }));
      }

      var hasAnything = i.numDoors > 0 || i.numSidelites > 0;
      if (!hasAnything) {
        svg.appendChild(svgMk('rect', {
          x: px(0), y: py(r.unitH),
          width: r.unitW * scale, height: r.unitH * scale,
          fill: '#F3F7FC', stroke: '#26292C', 'stroke-width': 1.5
        }));
      } else {
        // Unit outer frame
        svg.appendChild(svgMk('rect', {
          x: px(0), y: py(r.unitH),
          width: r.unitW * scale, height: r.unitH * scale,
          fill: 'none', stroke: '#26292C', 'stroke-width': 1.5
        }));

        var jt = C.jambThickness;
        var panels = buildPanels(i);
        var positions = layoutPanels(i, panels, r.unitW - 2 * jt);

        // Vertical stackup (all dimensions in inches, bottom-up from y=0):
        //
        //   Saddle (inswing or outswing): threshold(1 3/8") + sweep(1/2") +
        //     slab(slabH) + gap(1/8") + head jamb(3/4") = slabH + 2 3/4"
        //
        //   Outswing bumper: threshold contribution(3/8") + sweep(1/2") +
        //     slab(slabH) + gap(1/8") + head jamb(3/4") = slabH + 1 3/4"
        //     Physical threshold is 1 1/2" tall; the bumper projects 1 1/8"
        //     above the slab-bottom reference line to form the face stop.
        //
        // These numbers match the spreadsheet's jambLegLen (2.75 / 1.75).
        var isBumper = (i.threshold === 'Bumper');

        // Real-world dimensions (these feed the jambHt calc in the spreadsheet
        // and are shown on dimension labels):
        // A low-profile threshold is 1-1/8" tall, but its adjustable cap is raised 1/4" to meet the
        // sweep, so it stacks like a high-dam (1-3/8").
        var THRESHOLD_STACK_REAL = isBumper ? 0.375 : 1.375;
        var THRESHOLD_PHYS_REAL  = isBumper ? 1.5   : 1.375;
        var SWEEP_H_REAL         = 0.5;
        var HEAD_GAP_REAL        = 0.125;
        var HEAD_H_REAL          = 0.75;

        // Visual exaggeration: at accurate proportions these stackup elements
        // render 1-2% of unit height (near-invisible). Like door thickness in
        // plan view, we diagrammatically scale them up for readability. Real
        // unit height (shown on the dimension line) is unchanged; we borrow
        // the extra visual space from the slab zone so the total still equals
        // jambHt and the outer frame aligns with the dimension line.
        var VIS_FACTOR = 1.4;
        var THRESHOLD_STACK = THRESHOLD_STACK_REAL * VIS_FACTOR;
        var THRESHOLD_PHYS  = THRESHOLD_PHYS_REAL  * VIS_FACTOR;
        var SWEEP_H         = SWEEP_H_REAL         * VIS_FACTOR;
        var HEAD_GAP        = HEAD_GAP_REAL        * VIS_FACTOR;
        var HEAD_H          = HEAD_H_REAL          * VIS_FACTOR;
        // Slab "visual height" = original slab height minus the visual bonus
        // we've added to the other stackup elements.
        var realStackupTotal = THRESHOLD_STACK_REAL + SWEEP_H_REAL + HEAD_GAP_REAL + HEAD_H_REAL;
        var visualStackupTotal = THRESHOLD_STACK + SWEEP_H + HEAD_GAP + HEAD_H;
        var slabVisualH = i.slabH - (visualStackupTotal - realStackupTotal);

        // Zones
        var thresholdBotY = 0;
        var thresholdTopY = thresholdBotY + THRESHOLD_STACK;
        var sweepBotY     = thresholdTopY;
        var sweepTopY     = sweepBotY + SWEEP_H;
        var slabBotY      = sweepTopY;
        var slabTopY      = slabBotY + slabVisualH;
        var headGapBotY   = slabTopY;
        var headGapTopY   = headGapBotY + HEAD_GAP;
        var headBotY      = headGapTopY;
        var headTopY      = headBotY + HEAD_H;

        // Door panel occupies only the slab zone (not threshold or head jamb).
        // Sidelite panels fill full height between threshold top and head jamb
        // bottom (essentially from sweepBotY up to headGapBotY), since they're
        // single glass panels with no separate slab/sweep assembly.
        var panelBotY     = slabBotY;
        var panelTopY     = slabTopY;
        var panelH        = panelTopY - panelBotY;
        var sideliteBotY  = thresholdTopY;
        var sideliteTopY  = headBotY;

        // Jamb styling — all jamb pieces (head, legs, and stops) share a
        // consistent white fill with a dark border so the frame reads as a
        // unified surround. Stops have slight transparency so hinges/bores
        // behind them on inswing doors remain visible as spec markers.
        var JAMB_FILL = '#FFFFFF';
        var JAMB_STROKE = '#26292C';
        var JAMB_STROKE_W = 0.8;
        var STOP_OPACITY = 0.6;

        // Head jamb band — the 3/4" visible head jamb between headBotY and headTopY.
        svg.appendChild(svgMk('rect', {
          x: px(jt), y: py(headTopY),
          width: (r.unitW - 2 * jt) * scale,
          height: HEAD_H * scale,
          fill: JAMB_FILL, stroke: JAMB_STROKE, 'stroke-width': JAMB_STROKE_W
        }));
        // Head jamb gap above slab (air space between slab top and head jamb)
        svg.appendChild(svgMk('rect', {
          x: px(jt), y: py(headBotY),
          width: (r.unitW - 2 * jt) * scale,
          height: HEAD_GAP * scale,
          fill: '#F3F7FC', stroke: 'none'
        }));

        // Leg jambs (hinge side + strike side) — drawn as explicit vertical
        // rectangles on both sides of the unit, from threshold top up to the
        // underside of the head jamb. Consistent styling with the head jamb.
        svg.appendChild(svgMk('rect', {
          x: px(0), y: py(headBotY),
          width: jt * scale, height: (headBotY - thresholdTopY) * scale,
          fill: JAMB_FILL, stroke: JAMB_STROKE, 'stroke-width': JAMB_STROKE_W
        }));
        svg.appendChild(svgMk('rect', {
          x: px(r.unitW - jt), y: py(headBotY),
          width: jt * scale, height: (headBotY - thresholdTopY) * scale,
          fill: JAMB_FILL, stroke: JAMB_STROKE, 'stroke-width': JAMB_STROKE_W
        }));

        panels.forEach(function (p, idx) {
          var pos = positions[idx];
          var pxLeft = jt + pos.x;
          var pw = pos.w;

          // Per-panel top/bottom: doors draw at slab height; sidelites span
          // the full interior (threshold-top to head-jamb-bottom).
          var myPanelTopY = (p.type === 'door') ? panelTopY : sideliteTopY;
          var myPanelBotY = (p.type === 'door') ? panelBotY : sideliteBotY;
          var myPanelH    = myPanelTopY - myPanelBotY;

          // Panel body. A door is clickable to flip the handing.
          var panelBody = svgMk('rect', {
            x: px(pxLeft), y: py(myPanelTopY),
            width: pw * scale, height: myPanelH * scale,
            fill: '#F3F7FC', stroke: '#42474D', 'stroke-width': 1
          });
          if (p.type === 'door') {
            panelBody.setAttribute('data-draw-action', 'flip-handing');
            panelBody.setAttribute('class', 'pease-draw-hit');
            svgTitle(panelBody, 'Door: ' + (i.handing === 'Left' ? 'left' : 'right') + ' hand ' + i.swing.toLowerCase() + '. Click to flip the handing.');
          } else {
            svgTitle(panelBody, 'Sidelite: ' + toFraction(i.sideliteW) + ' wide');
          }
          svg.appendChild(panelBody);
          var cutsNow = i.cuts || {};
          var doorCutOk = p.type === 'door' && cutsNow.door && !cutsNow.blocked && cutsNow.door.place.ok;
          if (p.type === 'door' && i.doorFit && i.doorFit.ok && i.doorFit.geom) {
            drawDoorPanels(svg, i.doorFit.geom, pxLeft, pw, panelTopY, (panelTopY - panelBotY) / i.slabH, px, py, scale,
              doorCutOk ? cutsNow.door.place.covered : []);
          }
          (function () {
            var topY = myPanelTopY, ky2 = myPanelH / i.slabH, kx2 = pw / (p.type === 'door' ? i.slabW : i.sideliteW);
            var X = function (x) { return px(pxLeft + x * kx2).toFixed(2); };
            var Y = function (y) { return py(topY - y * ky2).toFixed(2); };
            var draw = function (cut) {
              cut.place.rects.forEach(function (rc) { drawCutShape(svg, svgMk, cut.c, rc, X, Y, kx2 * scale, ky2 * scale, false); });
            };
            if (doorCutOk) draw(cutsNow.door);
            if (p.type === 'door' && p.active && cutsNow.pet && !cutsNow.blocked && cutsNow.pet.place.ok) draw(cutsNow.pet);
            if (p.type === 'sidelite' && cutsNow.side && cutsNow.side.place.ok) draw(cutsNow.side);
          })();

          if (p.type === 'door') {
            // Hinges and bores are measured from the TOP OF SLAB (the
            // spreadsheet's convention for slab1..slab4, latchBore, etc).
            // All slab-relative measurements are scaled to the drawing's
            // shrunken-slab zone so they still sit at the correct
            // proportional positions within the drawn slab.
            var slabShrink = slabVisualH / i.slabH;

            // Bore holes: latch (lower) and deadbolt (upper), 2 1/8" diameter.
            // Only rendered on the active door. For single-door configs the
            // sole door is always active. Passive (astragal) doors have flush
            // bolts instead of a bored lockset and are left unbored here.
            var isActive = (p.active === true) || (i.numDoors === 1);
            if (isActive && r.hasLatch) {
              var boreR = C.boreDiameter / 2;
              var strikeEdgeX = p.hinge === 'L' ? pxLeft + pw : pxLeft; // opposite of hinge
              var boreXin = p.hinge === 'L' ? -i.backset : i.backset;
              var boreCenterX = strikeEdgeX + boreXin;
              var boreYs = [slabTopY - r.latchBore * slabShrink];
              var boreTips = ['Latch bore: ' + toFraction(r.latchBore) + ' from top of door to center'];
              if (r.hasDeadbolt) {
                boreYs.push(slabTopY - r.deadboltBore * slabShrink);
                boreTips.push('Deadbolt bore: ' + toFraction(r.deadboltBore) + ' from top of door to center');
              }
              boreYs.forEach(function (boreY, bi) {
                svg.appendChild(svgTitle(svgMk('circle', {
                  cx: px(boreCenterX), cy: py(boreY),
                  r: boreR * scale,
                  fill: 'rgba(255,255,255,0.01)', stroke: '#26292C', 'stroke-width': 0.6
                }), boreTips[bi] + ', ' + toFraction(i.backset) + ' backset'));
                svg.appendChild(svgMk('circle', {
                  cx: px(boreCenterX), cy: py(boreY),
                  r: 0.15 * scale, fill: '#26292C'
                }));
              });
            }

            // Hinges — reflect actual count, size, and calculated positions.
            // slab1..slab4 are distances from top of slab, already rounded to
            // 1/8" by calculate(). We draw each hinge as a rectangle of
            // hingeSize height on the hinge-side edge. Positions are scaled
            // to the shrunken slab zone so they sit at correct proportional
            // locations within the drawn slab.
            var hingeWidth = 0.5; // visual width (the hinge leaf on the slab face)
            var hingeX = p.hinge === 'L' ? pxLeft : pxLeft + pw - hingeWidth;
            var hingePositions = [r.slab1, r.slab2, r.slab3, r.slab4]
              .filter(function (v) { return v !== 'na' && typeof v === 'number' && isFinite(v); });
            hingePositions.forEach(function (topFromSlabTop, hi) {
              var hingeTopY = slabTopY - topFromSlabTop * slabShrink;
              svg.appendChild(svgTitle(svgMk('rect', {
                x: px(hingeX), y: py(hingeTopY),
                width: hingeWidth * scale, height: i.hingeSize * slabShrink * scale,
                fill: '#1A2028', stroke: '#26292C', 'stroke-width': 0.4
              }), ['1st', '2nd', '3rd', '4th'][hi] + ' hinge: ' + toFraction(topFromSlabTop) + ' from top of door to top of hinge'));
            });

            // Inswing only: visible door stops around the slab perimeter. The
            // stop sits in front of the slab (toward exterior) and overlaps
            // the outer 0.375" of the slab's face on each side that has a
            // jamb (not the astragal side of a double door). Drawn AFTER
            // hinges and bores with slight transparency so those spec markers
            // remain visible through the stop from the exterior view.
            if (i.swing === 'Inswing') {
              var STOP_W = 0.5;
              var prev = idx > 0 ? panels[idx - 1] : null;
              var nextP = idx < panels.length - 1 ? panels[idx + 1] : null;
              var leftIsAstragal = prev && prev.type === 'door';
              var rightIsAstragal = nextP && nextP.type === 'door';
              var mkStop = function (x, y, w, h) {
                svg.appendChild(svgMk('rect', {
                  x: px(x), y: py(y), width: w * scale, height: h * scale,
                  fill: JAMB_FILL, stroke: JAMB_STROKE, 'stroke-width': JAMB_STROKE_W,
                  opacity: STOP_OPACITY, 'pointer-events': 'none'
                }));
              };
              mkStop(pxLeft, slabTopY, pw, STOP_W);             // top
              mkStop(pxLeft, slabBotY + STOP_W, pw, STOP_W);    // bottom
              if (!leftIsAstragal)  mkStop(pxLeft, slabTopY, STOP_W, slabVisualH);
              if (!rightIsAstragal) mkStop(pxLeft + pw - STOP_W, slabTopY, STOP_W, slabVisualH);
            }
          }

          // Mull (between door and sidelite) — simple vertical strip
          if (idx < panels.length - 1) {
            var next = panels[idx + 1];
            var isDoorDoor = p.type === 'door' && next.type === 'door';
            var mullX = jt + pos.x + pos.w;
            if (isDoorDoor) {
              // Astragal between double doors. Dimensions per spec:
              //   - 0.75" wide at the narrow point (between door slabs)
              //   - 1.75" wide at the exterior face (overlapping 0.5" onto
              //     each door's exterior face)
              //   - height matches slab height (not including sweep)
              //
              // What's visible from the EXTERIOR elevation depends on swing:
              //   - Inswing: astragal attaches to exterior face of passive
              //     door. The full 1.75" stepped profile shows.
              //   - Outswing: astragal attaches to INTERIOR face of passive
              //     door. From the exterior we only see the narrow 0.75"
              //     portion sitting in the gap between slabs.
              var isInswing = i.swing === 'Inswing';
              var ASTRAGAL_OVERLAP = 0.5;
              var astragalX, astragalW;
              if (isInswing) {
                astragalX = mullX - ASTRAGAL_OVERLAP;
                astragalW = jt + 2 * ASTRAGAL_OVERLAP; // 0.75 + 1.0 = 1.75"
              } else {
                astragalX = mullX;
                astragalW = jt; // 0.75" narrow portion only
              }
              var astragalTopY = slabTopY;
              var astragalBotY = slabBotY;
              var astragalH = astragalTopY - astragalBotY;
              svg.appendChild(svgMk('rect', {
                x: px(astragalX), y: py(astragalTopY),
                width: astragalW * scale, height: astragalH * scale,
                fill: '#3D4651', stroke: '#26292C', 'stroke-width': 0.5
              }));
              // Inswing only: subtle seam lines at the edges of the narrow
              // portion to hint at the stepped profile of the overlap.
              if (isInswing) {
                svg.appendChild(svgMk('line', {
                  x1: px(mullX), y1: py(astragalTopY),
                  x2: px(mullX), y2: py(astragalBotY),
                  stroke: '#6B7280', 'stroke-width': 0.4
                }));
                svg.appendChild(svgMk('line', {
                  x1: px(mullX + jt), y1: py(astragalTopY),
                  x2: px(mullX + jt), y2: py(astragalBotY),
                  stroke: '#6B7280', 'stroke-width': 0.4
                }));
              }
            } else {
              // Standard mull (door-to-sidelite or sidelite-to-sidelite) —
              // fills the full interior height from threshold top to head
              // jamb bottom, matching sidelite panel height.
              svg.appendChild(svgMk('rect', {
                x: px(mullX), y: py(sideliteTopY),
                width: jt * scale, height: (sideliteTopY - sideliteBotY) * scale,
                fill: '#677079', stroke: '#26292C', 'stroke-width': 0.5
              }));
            }
          }
        });

        // Transom
        if (i.transom) {
          svg.appendChild(svgMk('rect', {
            x: px(jt), y: py(r.jambHt),
            width: (r.unitW - 2 * jt) * scale, height: jt * scale,
            fill: '#677079', stroke: '#26292C', 'stroke-width': 0.5
          }));
          var tFrame = 1.5;
          svg.appendChild(svgTitle(svgMk('rect', {
            x: px(jt + tFrame), y: py(r.unitH - jt - tFrame),
            width: (r.unitW - 2 * jt - 2 * tFrame) * scale,
            height: (i.transomH - 2 * jt - 2 * tFrame) * scale,
            fill: '#D4E1F5', stroke: '#8CAEE8', 'stroke-width': 0.75, opacity: 0.7
          }), 'Transom: ' + toFraction(i.transomH) + ' tall including jamb'));
        }

        // Sweep — thin compressible strip between slab bottom and threshold.
        // Drawn on all three threshold styles (saddle inswing, saddle
        // outswing, bumper outswing).
        svg.appendChild(svgMk('rect', {
          x: px(jt), y: py(sweepTopY),
          width: (r.unitW - 2 * jt) * scale,
          height: SWEEP_H * scale,
          fill: '#2C3542', stroke: '#26292C', 'stroke-width': 0.4
        }));

        // Threshold — full physical height (may exceed its stack contribution
        // in the bumper case, where the bumper rail projects up past the
        // slab-bottom reference).
        svg.appendChild(svgMk('rect', {
          x: px(0), y: py(THRESHOLD_PHYS),
          width: r.unitW * scale,
          height: THRESHOLD_PHYS * scale,
          fill: '#4A525E', stroke: '#26292C', 'stroke-width': 0.6
        }));

        if (isBumper) {
          // Bumper face-stop: a narrow darker strip on the exterior side of
          // the threshold's top portion, representing the kerf/foam that
          // seals against the slab's exterior face. The bumper projects up
          // by (THRESHOLD_PHYS - THRESHOLD_STACK) past the slab-bottom ref.
          var bumperFaceH = THRESHOLD_PHYS - THRESHOLD_STACK; // 1 1/8" visible projection
          svg.appendChild(svgMk('rect', {
            x: px(0), y: py(THRESHOLD_STACK + bumperFaceH),
            width: r.unitW * scale,
            height: bumperFaceH * scale,
            fill: '#2C3542', stroke: '#26292C', 'stroke-width': 0.4
          }));
        }
      }

      // Dimension lines
      var dimW = showBm ? r.unitBmW : r.unitW;
      var dimH = showBm ? r.unitBmH : r.unitH;
      var dimWxL = showBm ? -bmSideProj : 0;
      var dimWxR = showBm ? r.unitW + bmSideProj : r.unitW;
      var dimHyT = showBm ? r.unitH + bmTopProj : r.unitH;
      var dimColor = showBm ? '#CC5E47' : '#21409A';

      drawHorizDim(svg, px(dimWxL), px(dimWxR), py(0) + 28, toFraction16(dimW), dimColor);
      drawVertDim(svg, px(dimWxR) + 28, py(0), py(dimHyT), toFraction16(dimH), dimColor);
    }

    // Plan view (top-down) — includes wall, brickmold projection, and swing arc
    function drawPlan(i, r, showBm) {
      var svg = sectionEl.querySelector('[data-drawing="plan"]');
      if (!svg) return;
      svgClear(svg);

      var DIM_MARGIN = 52;
      var WALL_EXTEND = 12;
      var LABEL_SPACE = 18;
      // Extra vertical padding when stacking two width dims on one side. Each
      // stacked dim needs roughly 32px of additional space beyond the first.
      var DIM_STACK_PAD = showBm ? 32 : 0;
      // Plan sits below elevation, full panel width; arc extension makes the
      // natural shape roughly square for inswing single, so give it generous
      // vertical budget rather than forcing a wide/shallow box.
      var availW = 700 - DIM_MARGIN * 2;
      var availH = 420 - DIM_MARGIN * 2 - LABEL_SPACE * 2 - DIM_STACK_PAD;

      var planW = r.unitW;
      // planD is always the WALL depth (jamb depth). Brickmold projects past
      // this toward exterior when showBm is true.
      var planD = r.unitD;
      var bmProjY = showBm ? (r.unitBmD - r.unitD) : 0;
      var bmProjX = showBm ? (r.unitBmW - r.unitW) / 2 : 0;
      var swingR = i.numDoors > 0 ? i.slabW : 0;

      // Shim space per side — midpoint of the 1/4"–3/4" range, representing
      // typical install clearance between unit edge and rough opening.
      var SHIM = 0.5;

      // Plan convention: INTERIOR is drawn at the TOP (smaller y), EXTERIOR at
      // the BOTTOM (larger y). Inswing arcs extend above the unit (toward
      // interior); outswing arcs and brickmold project below (toward exterior).
      var spaceAbove = i.swing === 'Inswing' ? swingR : 0;
      var spaceBelow = (i.swing === 'Outswing' ? swingR : 0) + bmProjY;

      // Left/right horizontal margin around the unit — accommodate whichever
      // is wider: the shim gap alone, or the brickmold projection past the
      // jamb (brickmold is typically ~1.25" which is wider than the 0.5" shim).
      var sideMargin = Math.max(SHIM, bmProjX);
      var logicalW = planW + 2 * sideMargin + 2 * WALL_EXTEND;
      var logicalH = planD + spaceAbove + spaceBelow;
      var scale = Math.min(availW / logicalW, availH / logicalH);

      var drawnW = logicalW * scale + DIM_MARGIN * 2;
      var drawnH = logicalH * scale + DIM_MARGIN * 2 + LABEL_SPACE * 2 + DIM_STACK_PAD;
      svg.setAttribute('viewBox', '0 0 ' + drawnW + ' ' + drawnH);
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');

      var unitXinLogical = sideMargin + WALL_EXTEND;
      var unitYinLogical = spaceAbove;

      var unitLeftPx = DIM_MARGIN + unitXinLogical * scale;
      // Reserve extra padding on the arc-opposite side when stacking two
      // width dims (brickmold mode). Inswing stacks below → bottom pad;
      // outswing stacks above → top pad.
      var topPadExtra = (showBm && i.swing === 'Outswing') ? DIM_STACK_PAD : 0;
      var unitTopPx = DIM_MARGIN + LABEL_SPACE + topPadExtra + unitYinLogical * scale;

      function px(x) { return unitLeftPx + x * scale; }
      function py(y) { return unitTopPx + y * scale; }

      // Walls sit outside the ROUGH OPENING (not the unit). That leaves a
      // visible SHIM gap on each side between the unit jamb and the wall —
      // which is exactly the space the installer shims into.
      //
      // Wall assembly (exterior to interior): sheathing + stud + drywall.
      // Standard: 1/2" drywall + 1/2" sheathing + 1/16" fudge = 1.0625" of
      // finish, so stud depth = jamb depth − 1.0625". For the 6 9/16" default
      // jamb, that gives a 5 1/2" stud (2x6). For 4 9/16", it's a 3 1/2" 2x4.
      // For very thin jambs (< ~2.5"), fall back to a single solid layer.
      var DRYWALL = 0.5;
      var SHEATHING = 0.5;
      var FUDGE = 0.0625;
      var studDepth = planD - DRYWALL - SHEATHING - FUDGE;
      var showLayered = studDepth >= 1.0; // below this, wall is too thin to meaningfully layer

      function drawWallSide(xStart, wallW) {
        if (showLayered) {
          // INTERIOR side at top (y=0): drywall
          svg.appendChild(svgMk('rect', {
            x: px(xStart), y: py(0),
            width: wallW * scale, height: (DRYWALL + FUDGE) * scale,
            fill: '#ECE7DB', stroke: '#677079', 'stroke-width': 0.5
          }));
          // Stud cavity (middle)
          var studY0 = DRYWALL + FUDGE;
          var studY1 = studY0 + studDepth;
          svg.appendChild(svgMk('rect', {
            x: px(xStart), y: py(studY0),
            width: wallW * scale, height: studDepth * scale,
            fill: '#F5EFE4', stroke: '#677079', 'stroke-width': 0.5
          }));
          // Diagonal cross-hatch inside stud cavity to indicate framing/insulation
          var hatchStep = Math.max(1.2, studDepth * 0.25);
          // Clip path so hatches don't escape the stud band
          var clipId = 'dsc-stud-clip-' + Math.random().toString(36).slice(2, 9);
          var defs = svgMk('defs', {});
          var clip = svgMk('clipPath', { id: clipId });
          clip.appendChild(svgMk('rect', {
            x: px(xStart), y: py(studY0),
            width: wallW * scale, height: studDepth * scale
          }));
          defs.appendChild(clip);
          svg.appendChild(defs);
          for (var hx = xStart - studDepth; hx < xStart + wallW + studDepth; hx += hatchStep) {
            svg.appendChild(svgMk('line', {
              x1: px(hx), y1: py(studY0),
              x2: px(hx + studDepth), y2: py(studY1),
              stroke: '#A89D85', 'stroke-width': 0.4,
              'clip-path': 'url(#' + clipId + ')'
            }));
          }
          // EXTERIOR side at bottom (y=planD): sheathing
          svg.appendChild(svgMk('rect', {
            x: px(xStart), y: py(studY1),
            width: wallW * scale, height: SHEATHING * scale,
            fill: '#D6CFC0', stroke: '#677079', 'stroke-width': 0.5
          }));
        } else {
          // Fallback for very thin walls — simple single layer with hatch
          svg.appendChild(svgMk('rect', {
            x: px(xStart), y: py(0),
            width: wallW * scale, height: planD * scale,
            fill: '#E8E3DA', stroke: '#677079', 'stroke-width': 0.5
          }));
          var hatchSpacing = 1.8;
          for (var thinHx = xStart; thinHx < xStart + wallW; thinHx += hatchSpacing) {
            svg.appendChild(svgMk('line', {
              x1: px(thinHx), y1: py(0),
              x2: px(thinHx + hatchSpacing), y2: py(planD),
              stroke: '#677079', 'stroke-width': 0.4
            }));
          }
        }
      }

      drawWallSide(-SHIM - WALL_EXTEND, WALL_EXTEND);
      drawWallSide(planW + SHIM, WALL_EXTEND);

      // Brickmold projection into exterior — extends past the jamb by bmProjX
      // on each side (1 1/4" inswing / 1 1/2" outswing), which is its real
      // construction width. Covers the shim joint and sits on the exterior
      // wall face (sheathing). With EXTERIOR now at the bottom of the plan,
      // it projects from the unit's exterior face (y=planD) downward.
      if (showBm) {
        svg.appendChild(svgMk('rect', {
          x: px(-bmProjX), y: py(planD),
          width: (planW + 2 * bmProjX) * scale, height: bmProjY * scale,
          fill: '#FEF6EC', stroke: '#CC5E47', 'stroke-width': 1.25
        }));
      }

      // Unit frame (plan section)
      svg.appendChild(svgMk('rect', {
        x: px(0), y: py(0),
        width: planW * scale, height: planD * scale,
        fill: '#F3F7FC', stroke: '#26292C', 'stroke-width': 1.2
      }));

      // Panels
      var jt = C.jambThickness;
      var planPanels = buildPanels(i);
      var planPositions = layoutPanels(i, planPanels, r.unitW - 2 * jt);

      planPanels.forEach(function (p, idx) {
        var pos = planPositions[idx];
        var pxLeft = jt + pos.x;
        var pw = pos.w;

        if (p.type === 'sidelite') {
          var slGlass = i.cuts && i.cuts.side && i.cuts.side.place.ok;
          svg.appendChild(svgMk('rect', {
            x: px(pxLeft), y: py(planD / 2 - 0.6),
            width: pw * scale, height: 1.2 * scale,
            fill: slGlass ? '#D4E1F5' : '#F3F7FC', stroke: slGlass ? '#8CAEE8' : '#42474D', 'stroke-width': 0.5
          }));
        } else if (p.type === 'door') {
          if (p.active || i.numDoors === 1) {
            // Active door — draw at 90° open with swing arc.
            // Plan has INTERIOR at top (smaller y), EXTERIOR at bottom.
            // Inswing arcs go UP (toward interior); outswing arcs go DOWN.
            var pivotX = p.hinge === 'L' ? pxLeft : pxLeft + pw;
            var pivotY = planD / 2;
            var dirY = i.swing === 'Inswing' ? -1 : 1;
            var doorLen = pw;
            var doorThick = 1.75;
            var thickDir = p.hinge === 'L' ? 1 : -1;
            var doorX1 = pivotX;
            var doorX2 = pivotX + thickDir * doorThick;
            var doorY1 = pivotY;
            var doorY2 = pivotY + dirY * doorLen;

            var minX = Math.min(doorX1, doorX2), maxX = Math.max(doorX1, doorX2);
            var minY = Math.min(doorY1, doorY2), maxY = Math.max(doorY1, doorY2);
            var swingTip = 'Door swings ' + (i.swing === 'Inswing' ? 'in' : 'out') + '. Click to switch to ' + (i.swing === 'Inswing' ? 'outswing' : 'inswing') + '.';
            svg.appendChild(svgTitle(svgMk('polygon', {
              points: px(minX) + ',' + py(minY) + ' ' + px(maxX) + ',' + py(minY) + ' ' + px(maxX) + ',' + py(maxY) + ' ' + px(minX) + ',' + py(maxY),
              fill: '#42474D', stroke: '#26292C', 'stroke-width': 0.5,
              'data-draw-action': 'toggle-swing', 'class': 'pease-draw-hit pease-draw-hit--leaf'
            }), swingTip));

            // Swing arc from closed (along wall) to open (90°)
            var strikeDir = p.hinge === 'L' ? 1 : -1;
            var closedEndX = pivotX + strikeDir * doorLen;
            var closedEndY = pivotY;
            var openEndX = pivotX;
            var openEndY = pivotY + dirY * doorLen;
            var sweep;
            if (p.hinge === 'L' && dirY === 1) sweep = 1;
            else if (p.hinge === 'L' && dirY === -1) sweep = 0;
            else if (p.hinge === 'R' && dirY === 1) sweep = 0;
            else sweep = 1;

            var arcD = 'M ' + px(closedEndX) + ' ' + py(closedEndY) + ' A ' + (doorLen * scale) + ' ' + (doorLen * scale) + ' 0 0 ' + sweep + ' ' + px(openEndX) + ' ' + py(openEndY);
            svg.appendChild(svgMk('path', {
              d: arcD,
              fill: 'none', stroke: '#3B6CC7', 'stroke-width': 1, 'stroke-dasharray': '4 3'
            }));
            // Wide invisible copy of the arc so it is easy to click.
            svg.appendChild(svgTitle(svgMk('path', {
              d: arcD, fill: 'none', stroke: 'transparent', 'stroke-width': 14,
              'data-draw-action': 'toggle-swing', 'class': 'pease-draw-hit-line'
            }), swingTip));
          } else {
            // Inactive door of a pair — shown closed
            svg.appendChild(svgMk('rect', {
              x: px(pxLeft), y: py(planD / 2 - 0.8),
              width: pw * scale, height: 1.6 * scale,
              fill: '#677079', stroke: '#26292C', 'stroke-width': 0.3
            }));
          }
        }
      });

      // Astragal in plan view — drawn after all panels so it overlays them.
      // The astragal is attached to the passive door; its face-overlap is on
      // the weather-facing side: exterior face for inswing (weather pushes
      // doors inward against the astragal's seal), interior face for outswing
      // (weather still pushes doors toward stops, which sit on the exterior
      // side, so the astragal's overlap ends up on the interior face).
      if (i.numDoors === 2) {
        var astragalPassive = null, astragalActive = null;
        planPanels.forEach(function (p, idx) {
          if (p.type === 'door') {
            var pos = planPositions[idx];
            if (p.astragal) astragalPassive = { x: jt + pos.x, w: pos.w, hinge: p.hinge };
            else if (p.active) astragalActive = { x: jt + pos.x, w: pos.w, hinge: p.hinge };
          }
        });
        if (astragalPassive && astragalActive) {
          // Passive door's strike edge faces the active door. Active door's
          // strike edge faces the passive door. The astragal sits across this
          // meeting point, centered on the gap between them.
          var passiveStrikeX = astragalPassive.hinge === 'L'
            ? astragalPassive.x + astragalPassive.w
            : astragalPassive.x;
          var activeStrikeX = astragalActive.hinge === 'L'
            ? astragalActive.x + astragalActive.w
            : astragalActive.x;
          var gapCenterX = (passiveStrikeX + activeStrikeX) / 2;

          // Astragal full width: 1 3/4" centered on gap. At plan scale the
          // astragal's true 1/2" projection reads as a hairline, so we draw
          // the projection exaggerated (like door thickness itself is
          // diagrammatic in plan). Width stays true to spec.
          var ASTRAGAL_W = 1.75;
          var ASTRAGAL_PROJECT_VISUAL = 1.0; // exaggerated from 0.5" actual for readability
          var astragalLeftX = gapCenterX - ASTRAGAL_W / 2;
          // Passive door rectangle spans planD/2 - 0.8 (INTERIOR face, in the
          // new top-is-interior convention) to planD/2 + 0.8 (EXTERIOR face).
          // Astragal projects from the weather-facing face outward:
          //   Inswing  → from exterior face (planD/2 + 0.8) toward y=planD (EXTERIOR, bottom)
          //   Outswing → from interior face (planD/2 - 0.8) toward y=0 (INTERIOR, top)
          var astragalSvgY;
          if (i.swing === 'Inswing') {
            var inswingExteriorY = planD / 2 + 0.8;
            astragalSvgY = py(inswingExteriorY);
          } else {
            var outswingInteriorY = planD / 2 - 0.8;
            astragalSvgY = py(outswingInteriorY - ASTRAGAL_PROJECT_VISUAL);
          }

          svg.appendChild(svgMk('rect', {
            x: px(astragalLeftX), y: astragalSvgY,
            width: ASTRAGAL_W * scale, height: ASTRAGAL_PROJECT_VISUAL * scale,
            fill: '#1F2937', stroke: '#26292C', 'stroke-width': 0.4
          }));
        }
      }

      // Plan label/dim layout.
      //
      // Inswing (arc goes UP toward interior/top of drawing), top-to-bottom:
      //   arc → INTERIOR → unit → brickmold strip → EXTERIOR →
      //   brickmold-width dim → wall-width dim
      //
      // Outswing (arc goes DOWN toward exterior/bottom), top-to-bottom:
      //   wall-width dim → brickmold-width dim → INTERIOR → unit →
      //   brickmold strip → EXTERIOR → arc
      //
      // Rules:
      //  - INTERIOR label sits just above the unit (top edge, at y=0).
      //  - EXTERIOR label sits just below the brickmold strip (or the unit's
      //    exterior face when no brickmold).
      //  - Both width dims stack on the arc-opposite side, with the brickmold
      //    dim CLOSER to the drawing and the wall-width dim FURTHER out.
      //  - Depth dims: wall on the right (blue), brickmold on the left (coral).

      var exteriorEdgeY = py(planD + bmProjY); // where EXTERIOR label anchors

      // Labels
      var labelX = px(planW / 2);
      var labelYTop = py(0) - 6;          // INTERIOR anchor (unchanged)
      var labelYBot = exteriorEdgeY + 14; // EXTERIOR anchor (moved below brickmold)
      var tIn = svgMk('text', {
        x: labelX, y: labelYTop,
        'text-anchor': 'middle', 'font-size': 10, 'font-weight': 600,
        fill: '#677079', 'letter-spacing': '0.08em',
        'font-family': 'Source Sans 3, Source Sans Pro, sans-serif'
      });
      tIn.textContent = 'INTERIOR';
      svg.appendChild(tIn);
      var tEx = svgMk('text', {
        x: labelX, y: labelYBot,
        'text-anchor': 'middle', 'font-size': 10, 'font-weight': 600,
        fill: '#677079', 'letter-spacing': '0.08em',
        'font-family': 'Source Sans 3, Source Sans Pro, sans-serif'
      });
      tEx.textContent = 'EXTERIOR';
      svg.appendChild(tEx);

      // Depth dims (vertical, left and right of drawing).
      var wallDepthLabel = toFraction16(r.unitD);
      drawVertDim(svg, px(planW + sideMargin + WALL_EXTEND) + 14, py(0), py(planD),
                  wallDepthLabel, '#21409A');
      if (showBm) {
        var bmDepthLabel = toFraction16(r.unitBmD);
        drawVertDim(svg, px(-sideMargin - WALL_EXTEND) - 14, py(0), py(planD + bmProjY),
                    bmDepthLabel, '#CC5E47', false);
      }

      // Width dims stack below/above the EXTERIOR/INTERIOR label, both on the
      // arc-opposite side. Brickmold dim sits closer to the drawing; wall-width
      // dim sits further away.
      var DIM_FIRST_OFFSET = 22;  // gap from label to first (closer) dim
      var DIM_SECOND_OFFSET = 32; // additional gap to second (further) dim
      var wallWidthLabel = toFraction16(r.unitW);
      var bmWidthLabel = showBm ? toFraction16(r.unitBmW) : null;

      if (i.swing === 'Inswing') {
        // Arc is UP. Dims stack BELOW the EXTERIOR label.
        // Order: EXTERIOR → brickmold dim (closer) → wall dim (further).
        if (showBm) {
          drawHorizDim(svg, px(-bmProjX), px(planW + bmProjX),
                       labelYBot + DIM_FIRST_OFFSET, bmWidthLabel, '#CC5E47');
          drawHorizDim(svg, px(0), px(planW),
                       labelYBot + DIM_FIRST_OFFSET + DIM_SECOND_OFFSET,
                       wallWidthLabel, '#21409A');
        } else {
          drawHorizDim(svg, px(0), px(planW),
                       labelYBot + DIM_FIRST_OFFSET, wallWidthLabel, '#21409A');
        }
      } else {
        // Arc is DOWN. Dims stack ABOVE the INTERIOR label.
        // Order from INTERIOR going up: brickmold dim (closer) → wall dim (further).
        if (showBm) {
          drawHorizDim(svg, px(-bmProjX), px(planW + bmProjX),
                       labelYTop - DIM_FIRST_OFFSET, bmWidthLabel, '#CC5E47', true);
          drawHorizDim(svg, px(0), px(planW),
                       labelYTop - DIM_FIRST_OFFSET - DIM_SECOND_OFFSET,
                       wallWidthLabel, '#21409A', true);
        } else {
          drawHorizDim(svg, px(0), px(planW),
                       labelYTop - DIM_FIRST_OFFSET, wallWidthLabel, '#21409A', true);
        }
      }
    }

    // ---- Validation / warnings ----
    function validate(i) {
      var w = [];
      if (i.sizeMode === 'ro') {
        if (i.numDoors > 0 && (i.slabW < 20 || i.slabW > 50)) w.push(msg('No slab from 20" to 50" wide fits this opening.', 'roW'));
        if (i.numDoors === 0 && (i.sideliteW < 9 || i.sideliteW > 50)) w.push(msg('No sidelite from 9" to 50" wide fits this opening.', 'roW'));
        if (i.slabH < 70 || i.slabH > 100) w.push(msg('No slab from 70" to 100" tall fits this opening.', 'roH'));
      } else {
        if (i.slabW < 20 || i.slabW > 50) w.push(msg('Enter a slab width from 20" to 50".', 'slabW'));
        if (i.slabH < 70 || i.slabH > 100) w.push(msg('Enter a slab height from 70" to 100".', 'slabH'));
      }
      if (i.numSidelites > 0 && !(i.sizeMode === 'ro' && i.numDoors === 0) && (i.sideliteW < 9 || i.sideliteW > 50)) w.push(msg('Enter a sidelite width from 9" to 50".', 'sideliteW'));
      if (i.transom === 1 && (i.transomH < 10 || i.transomH > 40)) w.push(msg('Enter a transom height from 10" to 40".', 'transomH'));
      if (i.numDoors === 0 && i.numSidelites === 0) w.push(msg('Pick at least one door or sidelite.', 'numDoors'));
      var cs = i.cuts;
      if (cs) {
        if (cs.door && !cs.blocked && !cs.door.place.ok) {
          w.push(msg('The ' + cutName(cs.door.c, i.slabH) + " cutout won't work here: " + cs.door.place.why + '. Pick another or No glass.', 'doorCut'));
        }
        if (cs.blocked && i.doorCut !== 'none') w.push(msg(cs.blocked + ' The door glass choice is ignored.', 'doorBuild', 'note'));
        if (cs.side && !cs.side.place.ok) {
          w.push(msg('The ' + cutName(cs.side.c, i.slabH) + " cutout won't work here: " + cs.side.place.why + '. Pick another or No glass.', 'sideCut'));
        }
        if (cs.pet && !cs.blocked) {
          var pr = cs.pet.place.rects[0], petKey = i.petBottom !== null ? 'petBottom' : 'petDoor';
          if (!cs.pet.place.ok) w.push(msg("This pet door won't fit: " + cs.pet.place.why + '.', petKey));
          else if (i.slabH - pr.y > i.slabH - EDGE_TB + 1e-6) w.push(msg('Keep the top of the pet door at least 5 1/8" below the top of the door.', petKey));
          else if (cs.door && cs.door.place.ok && cs.door.place.rects.some(function (g) { return pr.y < g.y + g.h + 3 - 1e-6; })) {
            w.push(msg('The pet door runs into the glass. Keep at least 3" between them, or lower the pet door.', petKey));
          } else if (i.doorFit && i.doorFit.trim === 'rerail') {
            w.push(msg('The pet door is measured on the finished (trimmed) door.', petKey, 'note'));
          }
        }
      }
      if (i.door) {
        var f = i.doorFit, wKey = i.sizeMode === 'ro' ? 'roW' : 'slabW', hKey = i.sizeMode === 'ro' ? 'roH' : 'slabH';
        if (!i.door.sizes.length) {
          w.push(msg('This combination isn\'t sold. Pick another build or texture.', 'doorBuild'));
        } else if (!f.widthOk) {
          w.push(msg('The ' + i.door.name + ' comes ' + f.widths.map(function (x) { return toFraction(x); }).join(', ') +
            ' wide. ' + (i.door.steel ? 'Steel' : 'Fiberglass') + ' panel doors can\'t be trimmed in width.', wKey));
        } else if (!f.ok) {
          var tallest = Math.max.apply(null, f.heights);
          if (i.slabH > tallest + 1e-6) w.push(msg('The tallest ' + i.door.name + ' at this width is ' + toFraction(tallest) + '.', hKey));
          else if (!i.door.trimmable) w.push(msg((i.door.steel ? 'Steel' : 'Impact and fire-rated') + ' doors can\'t be trimmed. Pick ' +
            f.heights.map(function (x) { return toFraction(x); }).join(' or ') + '.', hKey));
          else w.push(msg('The ' + i.door.name + ' comes ' + f.heights.map(function (x) { return toFraction(x); }).join(' or ') +
            ' tall. Cutting a ' + toFraction(f.stock.h) + ' door to ' + toFraction(i.slabH) + ' takes ' + toFraction(f.stock.h - i.slabH) +
            ' off; this door allows ' + toFraction(f.maxCut) + ' (it has to stay 4" below the lowest panel). Pick a stock height or another style.', hKey));
        } else if (f.trim === 'rerail') {
          w.push(msg('Cutting ' + toFraction(f.cut) + ' off the bottom needs a re-rail (shop service).', hKey, 'note'));
        } else if (f.trim === 'slab') {
          w.push(msg('Trimmed ' + toFraction(f.cut) + ' off the bottom (shop service).', hKey, 'note'));
        }
      }
      if (i.jambDepthCustom !== null && (i.jambDepthCustom < 3.5625 || i.jambDepthCustom > 8.5625)) w.push(msg('Enter a jamb depth from 3 9/16" to 8 9/16".', 'jambDepthCustom'));
      if (i.firstHingeOffset < HINGE_EDGE_MIN || i.firstHingeOffset > 12) w.push(msg('Leave at least 4" between the top of the door and the top of the 1st hinge (max 12").', 'firstHingeOffset'));
      if (i.lockPrep === 'double' && (i.boreSpacing < 3 || i.boreSpacing > 12)) w.push(msg('Enter a bore spacing from 3" to 12".', 'boreSpacing'));
      // Advanced overrides
      var r = calculate(i);
      var hinges = [r.slab1, r.slab2, r.slab3, r.slab4].filter(function (v) { return typeof v === 'number'; });
      var lastHingeKey = 'hinge' + hinges.length;
      for (var h = 1; h < hinges.length; h++) {
        if (hinges[h] < hinges[h - 1] + i.hingeSize) { w.push(msg('This hinge overlaps the one above it. Each hinge must start below the bottom of the one above.', 'hinge' + (h + 1))); break; }
      }
      // Hinges need at least 4" of slab above the top hinge and below the
      // bottom hinge (the top limit is the 1st-hinge 4" minimum above).
      if (hinges.length && hinges[hinges.length - 1] + i.hingeSize > i.slabH - HINGE_EDGE_MIN) w.push(msg('Leave at least 4" between the bottom of the last hinge and the bottom of the slab.', lastHingeKey));
      if (r.hasLatch && (r.latchBore >= i.slabH || (r.hasDeadbolt ? r.deadboltBore : r.latchBore) <= 0)) w.push(msg('The lock bore falls outside the slab.', 'latchBoreTop'));
      // Notes: allowed, but custom or unusual
      if (i.lockPrep === 'double' && Math.abs(i.boreSpacing - 5.5) > 1e-9) w.push(msg('Bore spacing other than 5 1/2" is a custom lock prep.', 'boreSpacing', 'note'));
      if (customHinges(i)) w.push(msg('Non-standard hinge size, count or placement is a custom hinge prep.', 'hingeCount', 'note'));
      if (r.hasLatch && i.latchBoreTop !== null && Math.abs(r.latchBore - r.std.latchBore) > 1e-9) w.push(msg('Non-standard bore placement is a custom lock prep.', 'latchBoreTop', 'note'));
      if (i.slabH > 84.5 && i.hingeCount === 3) w.push(msg('Doors taller than 84 1/2" typically need 4 hinges.', 'hingeCount', 'note'));
      if (i.slabH > 60 && i.hingeCount === 2) w.push(msg('2 hinges is typically only for doors 60" or shorter. Taller doors need at least 3 to stay flat and carry the weight.', 'hingeCount', 'note'));
      return w;
    }

    // ---- Door style: material, panel style, texture, build ----
    // Data comes from assets/door-system-styles.js (generated from the
    // product spec sheets and the live catalog). Without it, or with
    // "Any door" chosen, the calculator works as before.
    var TEX_LABELS = { SFG: 'smooth fiberglass', RFG: 'woodgrain fiberglass', PRW: 'steel' };
    var BUILD_LABELS = { PRM: 'Premium', HMP: 'impact rated', WBD: 'impact rated', FRE: '20-minute fire rated', SED: 'steel edge', WED: 'wood edge' };
    function availKey(style, tex, build) { return style + '|' + tex + '|' + build; }
    function hasAvail(style, tex, build) { return !!(DOOR && DOOR.avail[availKey(style, tex, build)]); }
    // Impact doors are sold as HMP or WBD depending on the style.
    function impactCode(style, tex) { return hasAvail(style, tex, 'HMP') ? 'HMP' : 'WBD'; }
    function doorChoice(i) {
      if (!DOOR || i.doorMaterial === 'none' || i.numDoors === 0) return null;
      var steel = i.doorMaterial === 'steel';
      var tex = steel ? 'PRW' : i.doorTexture;
      var build = steel ? i.doorBuild : (i.doorBuild === 'IMP' ? impactCode(i.doorStyle, tex) : i.doorBuild);
      var codes = DOOR.avail[availKey(i.doorStyle, tex, build)] || [];
      var st = DOOR.styles[i.doorStyle] || { name: i.doorStyle, geom: {} };
      return {
        style: i.doorStyle, tex: tex, build: build, steel: steel,
        family: steel ? build : 'FG',
        name: st.name,
        label: st.name + ', ' + TEX_LABELS[tex] + (steel ? ' (' + BUILD_LABELS[build] + ')' : ', ' + BUILD_LABELS[build]),
        trimmable: !steel && build === 'PRM',
        sizes: codes.map(function (c) {
          var ww = parseInt(c.slice(0, 2), 10), hh = parseInt(c.slice(2), 10);
          return { ww: ww, hh: hh, w: ww - 0.25, h: hh };
        })
      };
    }
    // Panel geometry for a style at a stock size. Exact sheet first; else
    // the nearest sheet at that height with the stiles adjusted (widths keep
    // their panels on every sheet read); else the nearest height, scaled.
    function doorGeom(dc, ww, hh) {
      var st = DOOR && DOOR.styles[dc.style];
      if (!st) return null;
      var fams = [dc.family].concat(dc.family === 'FG' ? [] : ['SED', 'WED', 'FG']);
      var code = String(ww) + String(hh), i2, f, g;
      for (i2 = 0; i2 < fams.length; i2++) {
        g = st.geom[fams[i2]] && st.geom[fams[i2]][code];
        if (g) return { g: g, exact: i2 === 0 };
      }
      var W = ww - 0.25;
      for (i2 = 0; i2 < fams.length; i2++) {
        f = st.geom[fams[i2]];
        if (!f) continue;
        var best = null;
        Object.keys(f).forEach(function (k) {
          if (parseInt(k.slice(2), 10) === hh && (!best || Math.abs(f[k].w - W) < Math.abs(best.w - W))) best = f[k];
        });
        if (best) {
          var dx = (W - best.w) / 2;
          return { g: { w: W, h: best.h, stile: best.stile + dx, top: best.top, bottom: best.bottom, kind: best.kind,
            panels: best.panels.map(function (p) { return { x: p.x + dx, y: p.y, w: p.w, h: p.h, top: p.top, rise: p.rise }; }) },
            exact: false };
        }
      }
      // Different height: scale the panel zone between the top and bottom rails.
      f = st.geom[dc.family] || st.geom.FG;
      if (!f) return null;
      var near = null;
      Object.keys(f).forEach(function (k) {
        var h = parseInt(k.slice(2), 10);
        if (!near || Math.abs(h - hh) < Math.abs(near.h - hh)) near = f[k];
      });
      var k2 = (hh - near.top - near.bottom) / (near.h - near.top - near.bottom);
      var dx2 = (W - near.w) / 2;
      return { g: { w: W, h: hh, stile: near.stile + dx2, top: near.top, bottom: near.bottom, kind: near.kind,
        panels: near.panels.map(function (p) {
          return { x: p.x + dx2, y: near.top + (p.y - near.top) * k2, w: p.w, h: p.h * k2, top: p.top, rise: p.rise };
        }) }, exact: false };
    }
    // How a typed slab size relates to the chosen door: which stock size it
    // comes from and what trimming that takes.
    function doorFit(i, dc) {
      var res = { ok: false, widthOk: false, heightOk: false };
      var widths = [];
      dc.sizes.forEach(function (z) { if (widths.indexOf(z.w) < 0) widths.push(z.w); });
      widths.sort(function (a, b) { return a - b; });
      res.widths = widths;
      var match = dc.sizes.filter(function (z) { return Math.abs(z.w - i.slabW) < 1e-6; });
      if (!match.length) return res;
      res.widthOk = true;
      var heights = match.map(function (z) { return z.h; }).sort(function (a, b) { return a - b; });
      res.heights = heights;
      for (var k = 0; k < heights.length; k++) {
        var S = heights[k], cut = S - i.slabH;
        if (cut < -1e-6) continue;
        var z = match.filter(function (m) { return m.h === S; })[0];
        var geo = doorGeom(dc, z.ww, z.hh);
        var lowest = geo ? Math.max.apply(null, geo.g.panels.map(function (p) { return p.y + p.h; })) : S;
        var maxCut = dc.trimmable ? Math.max(0, S - lowest - 4) : 0;
        res.maxCut = maxCut;
        res.stock = z;
        res.geom = geo;
        if (cut <= maxCut + 1e-6 || Math.abs(cut) < 1e-6) {
          res.heightOk = true;
          res.ok = true;
          res.cut = Math.max(0, cut);
          res.trim = res.cut < 1e-6 ? 'none' : (res.cut <= 0.5 + 1e-6 ? 'slab' : 'rerail');
          return res;
        }
        break;
      }
      return res;
    }
    function nomLabel(z) { return z.ww + '"'; }
    function heightLabel(h) { return { 79: "6'8\"", 83: "7'0\"", 95: "8'0\"" }[h] || h + '"'; }
    // Keep the style, texture and build choices to what is actually sold.
    function syncDoorOptions(i) {
      var steel = i.doorMaterial === 'steel';
      var styleSel = sectionEl.querySelector('[data-input="doorStyle"]');
      var texSel = sectionEl.querySelector('[data-input="doorTexture"]');
      var buildSel = sectionEl.querySelector('[data-input="doorBuild"]');
      var anyFor = function (style, tex) {
        return Object.keys(DOOR.avail).some(function (k) { return k.indexOf(style + '|' + tex + '|') === 0; });
      };
      var fix = function (sel, okFn) {
        var first = null;
        Array.prototype.forEach.call(sel.options, function (o) {
          var ok = okFn(o.value);
          o.hidden = !ok; o.disabled = !ok;
          if (ok && first === null) first = o.value;
        });
        if (sel.options[sel.selectedIndex] && sel.options[sel.selectedIndex].disabled && first !== null) sel.value = first;
      };
      fix(styleSel, function (v) { return steel ? anyFor(v, 'PRW') : (anyFor(v, 'SFG') || anyFor(v, 'RFG')); });
      fix(texSel, function (v) { return !steel && anyFor(styleSel.value, v); });
      fix(buildSel, function (v) {
        if (steel) return (v === 'SED' || v === 'WED') && hasAvail(styleSel.value, 'PRW', v);
        if (v === 'SED' || v === 'WED') return false;
        if (v === 'IMP') return hasAvail(styleSel.value, texSel.value, 'HMP') || hasAvail(styleSel.value, texSel.value, 'WBD');
        return hasAvail(styleSel.value, texSel.value, v);
      });
      i.doorStyle = styleSel.value; i.doorTexture = texSel.value; i.doorBuild = buildSel.value;
    }
    // Thumbnails drawn from the same geometry as the elevation.
    function renderStyleThumbs() {
      var box = sectionEl.querySelector('[data-style-thumbs]');
      if (!box || !DOOR) return;
      var sel = sectionEl.querySelector('[data-input="doorStyle"]');
      // Runs during init, before the drawing's SVG constants are set.
      var mk = function (tag, attrs) {
        var n = document.createElementNS('http://www.w3.org/2000/svg', tag);
        Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
        return n;
      };
      box.textContent = '';
      Array.prototype.forEach.call(sel.options, function (o) {
        var st = DOOR.styles[o.value];
        var g = st && st.geom.FG && (st.geom.FG['3679'] || st.geom.FG[Object.keys(st.geom.FG)[0]]);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pease-choice__btn';
        btn.setAttribute('data-set', 'doorStyle=' + o.value);
        btn.setAttribute('aria-pressed', 'false');
        var svgEl = mk('svg', { viewBox: '0 0 40 80', width: 30, height: 60, 'aria-hidden': 'true' });
        svgEl.appendChild(mk('rect', { x: 1, y: 1, width: 38, height: 78, rx: 1, fill: 'none', stroke: 'currentColor', 'stroke-width': 1.4 }));
        if (g) {
          var sx = 38 / g.w, sy = 78 / g.h;
          g.panels.forEach(function (p) {
            svgEl.appendChild(mk('rect', { x: 1 + p.x * sx, y: 1 + p.y * sy, width: p.w * sx, height: p.h * sy,
              fill: 'currentColor', 'fill-opacity': 0.12, stroke: 'currentColor', 'stroke-width': 0.9 }));
          });
        }
        btn.appendChild(svgEl);
        var span = document.createElement('span');
        span.textContent = o.textContent;
        btn.appendChild(span);
        box.appendChild(btn);
      });
    }
    // Panels on the elevation, inside one door's slab rectangle.
    function drawDoorPanels(svg, geo, left, width, slabTopY, slabShrink, px, py, scale, skip) {
      var g = geo.g, kx = width / g.w;
      g.panels.forEach(function (p, idx) {
        if (skip && skip.indexOf(idx) >= 0) return;   // replaced by glass
        var x = left + p.x * kx, w = p.w * kx;
        var yTop = slabTopY - p.y * slabShrink, h = p.h * slabShrink;
        var common = { 'pointer-events': 'none' };
        var outer = svgMk('rect', { x: px(x), y: py(yTop), width: w * scale, height: h * scale,
          fill: '#E4EAF3', stroke: '#8A96A8', 'stroke-width': 0.7, 'pointer-events': 'none' });
        svg.appendChild(outer);
        if (g.kind === 'raised' || g.kind === 'shaker') {
          var inset = g.kind === 'raised' ? Math.min(1.6, w / 4, h / 4) : Math.min(0.7, w / 6, h / 6);
          var ix = x + inset, iw = w - 2 * inset, iyTop = yTop - inset * slabShrink, ih = h - 2 * inset * slabShrink;
          svg.appendChild(svgMk('rect', { x: px(ix), y: py(iyTop), width: iw * scale, height: ih * scale,
            fill: g.kind === 'raised' ? '#F4F7FB' : '#DCE3EE', stroke: '#9AA6B6', 'stroke-width': 0.5, 'pointer-events': 'none' }));
          if (g.kind === 'raised') {
            [[x, yTop, ix, iyTop], [x + w, yTop, ix + iw, iyTop],
             [x, yTop - h, ix, iyTop - ih], [x + w, yTop - h, ix + iw, iyTop - ih]].forEach(function (c) {
              svg.appendChild(svgMk('line', { x1: px(c[0]), y1: py(c[1]), x2: px(c[2]), y2: py(c[3]),
                stroke: '#AEB8C6', 'stroke-width': 0.5, 'pointer-events': 'none' }));
            });
          }
        }
        void common;
      });
    }

    // ---- Glass, sidelite and pet door cutouts (Shop Services Guide) ----
    // Cut sizes are what production cuts; the glass kit frame is cut + 1".
    // lay: one | pair (side by side) | stack (one above the other, gap apart).
    // shape: rect | round (half-circle top) | arch (shallow arch top, 2"
    // rise) | fan (half-ellipse fanlite). flush: never offered on a panel door.
    var EDGE_TB = 5.125, EDGE_DOOR = 4.375, EDGE_SIDE = 1.4375;
    var CUTS = {
      'ZCUT-GHL-2337': { name: 'Half Lite', w: 23, h: 37, price: 49 },
      'ZCUT-GHL-2137': { name: 'Half Lite, narrow', w: 21, h: 37, price: 49 },
      'ZCUT-GHL-2537': { name: 'Half Lite, wide', w: 25, h: 37, price: 49 },
      'ZCUT-G34-2349': { name: ['3/4 Lite', 'Tall Half Lite'], w: 23, h: 49, price: 49 },
      'ZCUT-G34-2149': { name: ['3/4 Lite, narrow', 'Tall Half Lite, narrow'], w: 21, h: 49, price: 49 },
      'ZCUT-GFL-2365': { name: ['Full Lite', 'Tall 3/4 Lite'], w: 23, h: 65, price: 49 },
      'ZCUT-GFL-2165': { name: ['Full Lite, narrow', 'Tall 3/4 Lite, narrow'], w: 21, h: 65, price: 49 },
      'ZCUT-GFL-2361': { name: 'ADA Full Lite', w: 23, h: 61, top: 3.5, flush: true, price: 49 },
      'ZCUT-GFL-2381': { name: 'Tall Full Lite', w: 23, h: 81, price: 69 },
      'ZCUT-GFL-2181': { name: 'Tall Full Lite, narrow', w: 21, h: 81, price: 69 },
      'ZCUT-GFL-2377': { name: 'ADA Tall Full Lite', w: 23, h: 77, top: 3.5, flush: true, price: 69 },
      'ZCUT-GCR-2316': { name: 'Craftsman Lite', w: 23, h: 16.25, price: 49 },
      'ZCUT-GCR-2318': { name: 'Craftsman Lite, tall', w: 23, h: 18, price: 49 },
      'ZCUT-GCR-2616': { name: 'Craftsman Lite, wide', w: 26, h: 16.25, price: 49 },
      'ZCUT-GTL-2307': { name: 'Top Lite, wide', w: 23, h: 7, price: 49 },
      'ZCUT-GTL-2311': { name: 'Top Lite', w: 23, h: 11, price: 49 },
      'ZCUT-GQ2-0937': { name: 'Quarter Lites (2)', w: 9, h: 37, lay: 'pair', price: 89 },
      'ZCUT-GH2-0949': { name: 'Tall Quarter Lites (2)', w: 9, h: 49, lay: 'pair', price: 129 },
      'ZCUT-GT2-0907': { name: 'Top Lites (2)', w: 9, h: 7, lay: 'pair', price: 69 },
      'ZCUT-GS3-1206': { name: 'Spotlites (3)', w: 12, h: 6, lay: 'stack', n: 3, gap: 4, flush: true, price: 99 },
      'ZCUT-GQ3-1313': { name: 'Square Lites (3)', w: 13, h: 13, lay: 'stack', n: 3, gap: 3, flush: true, price: 99 },
      'ZCUT-GS5-2345': { name: 'Strip Lites (5)', w: 23, h: 4.5, lay: 'stack', n: 5, gap: 3.625, flush: true, price: 129 },
      'ZCUT-GL3-2311': { name: 'Stacked Lites (3)', w: 23, h: 11, lay: 'stack', n: 3, gap: 2, flush: true, price: 129 },
      'ZCUT-GC3-2318': { name: 'Craftsman Lites (3)', w: 23, h: 18, lay: 'stack', n: 3, gap: 5.5, flush: true, price: 129 },
      'ZCUT-GFN-2311': { name: 'Fanlite', w: 23, h: 11, shape: 'fan', flush: true, price: 99 },
      'ZCUT-GFA-2311': { name: 'Fanlite, arch top', w: 23, h: 11, shape: 'arch', flush: true, price: 99 },
      'ZCUT-GHA-2339': { name: 'Half Lite, arch top', w: 23, h: 39, shape: 'arch', top: 3.125, flush: true, price: 149 },
      'ZCUT-GHR-2337': { name: 'Half Lite, round top', w: 23, h: 37, shape: 'round', flush: true, price: 149 },
      'ZCUT-GFR-2365': { name: 'Full Lite, round top', w: 23, h: 65, shape: 'round', flush: true, price: 149 },
      // Ovals: the medium one centered where a 23" x 49" lite would be, the large one 5 1/8" down.
      // Their kits aren't cut + 1", so the kit sizes are listed.
      'ZCUT-VAL-MD': { name: 'Oval, medium', w: 16, h: 40, shape: 'oval', top: 9.625, flush: true, price: 199,
        kit: { fw: 17.5, fh: 41.375, gw: 15.5, gh: 39.375 } },
      'ZCUT-VAL-LG': { name: 'Oval, large', w: 21, h: 57, shape: 'oval', flush: true, price: 199,
        kit: { fw: 24, fh: 60, gw: 20.5, gh: 56.375 } },
      // Sidelites
      'ZCUT-GHS-0937': { name: 'Half Sidelite', w: 9, h: 37, side: true, price: 49 },
      'ZCUT-G34-0949': { name: ['3/4 Sidelite', 'Tall Half Sidelite'], w: 9, h: 49, side: true, price: 49 },
      'ZCUT-GFS-0765': { name: 'Full Sidelite, narrow', w: 7, h: 65, side: true, price: 49 },
      'ZCUT-GFS-0865': { name: 'Full Sidelite', w: 8, h: 65, side: true, price: 49 },
      'ZCUT-GFS-0965': { name: ['Full Sidelite, wide', 'Tall 3/4 Sidelite'], w: 9, h: 65, side: true, price: 49 },
      'ZCUT-GFS-1565': { name: 'Full Sidelite, extra-wide', w: 15, h: 65, side: true, price: 49 },
      'ZCUT-GCS-0918': { name: 'Craftsman Sidelite', w: 9, h: 18, side: true, price: 49 },
      'ZCUT-GFS-0981': { name: 'Tall Full Sidelite', w: 9, h: 81, side: true, price: 69 },
      'ZCUT-GFS-1581': { name: 'Tall Full Sidelite, extra-wide', w: 15, h: 81, side: true, price: 69 },
      'ZCUT-GSR-0937': { name: 'Half Sidelite, round top', w: 9, h: 37, shape: 'round', side: true, price: 149 },
      // Pet doors (the customer supplies the pet door unless it is on the order)
      'ZCUT-PGM-0915': { name: 'Guard Dog pet door, medium', w: 9.25, h: 14.625, pet: true, price: 49 },
      'ZCUT-PGL-1318': { name: 'Guard Dog pet door, large', w: 13, h: 18.375, pet: true, price: 49 },
      'ZCUT-PES-1014': { name: 'Energy Efficient pet door, small', w: 10, h: 14.5, pet: true, price: 49 },
      'ZCUT-PEM-1317': { name: 'Energy Efficient pet door, medium', w: 13, h: 17.5, pet: true, price: 49 },
      'ZCUT-PEL-1521': { name: 'Energy Efficient pet door, large', w: 15, h: 21.5, pet: true, price: 49 },
      'ZCUT-PEX-2029': { name: 'Energy Efficient pet door, extra large', w: 20.25, h: 29, pet: true, price: 49 }
    };
    Object.keys(CUTS).forEach(function (k) {
      var c = CUTS[k];
      if (!SVC[k]) SVC[k] = [(c.pet ? '' : 'Cutout: ') + (Array.isArray(c.name) ? c.name.join(' / ') : c.name) +
        ' (' + toFraction(c.w).replace('"', '') + ' x ' + toFraction(c.h).replace('"', '') + (c.n ? ' each' : '') + ')', c.price];
    });
    // The same cut has a different name on an 8'0" door.
    function cutName(c, H) { return Array.isArray(c.name) ? c.name[H > 90 ? 1 : 0] : c.name; }
    // Glass kit frame and glass for a cut: frame = cut + 1", glass = cut - 1", except ovals.
    function kitSize(c) { return c.kit || { fw: c.w + 1, fh: c.h + 1, gw: c.w - 1, gh: c.h - 1 }; }

    // Each door's openings come from its spec sheet (the product's custom.glass_cutouts
    // list, page 3 of the sheet): "23x65|23x37", "i|..." on impact-rated doors. Keys map
    // to cut SKUs; pairs are 5" apart, the three craftsman lites 5 1/2" apart.
    var OPENING_SKUS = {
      '23x65': 'ZCUT-GFL-2365', '21x65': 'ZCUT-GFL-2165', '23x81': 'ZCUT-GFL-2381', '21x81': 'ZCUT-GFL-2181',
      '23x49': 'ZCUT-G34-2349', '21x49': 'ZCUT-G34-2149', '23x37': 'ZCUT-GHL-2337', '21x37': 'ZCUT-GHL-2137',
      '25x37': 'ZCUT-GHL-2537', '23x18': 'ZCUT-GCR-2318', '23x16.25': 'ZCUT-GCR-2316', '23x7': 'ZCUT-GTL-2307',
      '23x11': 'ZCUT-GFN-2311', '23x11R': 'ZCUT-GTL-2311', '23x11AT': 'ZCUT-GFA-2311', '23x37RT': 'ZCUT-GHR-2337',
      '23x65RT': 'ZCUT-GFR-2365', '23x39AT': 'ZCUT-GHA-2339', '23x61': 'ZCUT-GFL-2361', '23x77': 'ZCUT-GFL-2377',
      '2x9x37': 'ZCUT-GQ2-0937', '2x9x49': 'ZCUT-GH2-0949', '3x23x18': 'ZCUT-GC3-2318',
      '16x40OV': 'ZCUT-VAL-MD', '21x57OV': 'ZCUT-VAL-LG'
    };
    // Not sold online yet (David, Oct 22): top lite pairs, spotlites and strip lites until
    // their glass is on the website; square and stacked lites; narrow single lites on doors.
    var NOT_YET = ['2x9x7', '3x12x6', '5x23x4.5', '3x13x13', '3x23x11', '8x65', '9x65', '15x65', '9x81', '15x81'];
    // The lists by STYLE|BUILD|WWHH, from the live catalog on Oct 22, 2026 (impact-rated
    // builds, HMP or WBD, as HMP). Fire-rated doors take no cutouts.
    var GLASS_LISTS = (function () {
      var by = {
        '23x65': '1PS|PRM|3279 1PS|PRM|3479 1PS|PRM|3679',
        '23x81': '1PS|PRM|3295 1PS|PRM|3495 1PS|PRM|3695 3PS|PRM|3295 3PS|PRM|3495 3PS|PRM|3695',
        '23x65|23x49|16x40OV': '2P4|PRM|3279 2P4|PRM|3479 2P4|PRM|3679 2P4|SED|3279 2P4|SED|3479 2P4|SED|3679 2P4|WED|3279 2P4|WED|3283 2P4|WED|3479 2P4|WED|3483 2P4|WED|3679 2P4|WED|3683',
        '23x65|23x81': '2P4|PRM|3295 2P4|PRM|3495 2P4|PRM|3695',
        '23x65|23x37': '2PS|PRM|3279 2PS|PRM|3479 2PS|PRM|3679 2PT|PRM|3279 2PT|PRM|3283 2PT|PRM|3479 2PT|PRM|3483 2PT|PRM|3679 2PT|PRM|3683 2PT|SED|3279 2PT|SED|3479 2PT|SED|3679 2PT|WED|3279 2PT|WED|3479 2PT|WED|3679 6PT|PRM|3283 6PT|PRM|3483 6PT|PRM|3683',
        '23x81|23x49': '2PS|PRM|3295 2PS|PRM|3495 2PS|PRM|3695 2PT|PRM|3295 2PT|PRM|3495 2PT|PRM|3695 2PT|WED|3295 2PT|WED|3495 2PT|WED|3695 6PT|PRM|3295 6PT|PRM|3495 6PT|PRM|3695',
        '23x65|23x18': '3PC|PRM|3279 3PC|PRM|3479 3PC|PRM|3679',
        '23x81|23x18': '3PC|PRM|3295 3PC|PRM|3495 3PC|PRM|3695',
        '23x65|3x23x18': '3PS|PRM|3279 3PS|PRM|3479 3PS|PRM|3679',
        '21x65|21x37': '6PT|PRM|3079',
        '23x65|23x37|23x7': '6PT|PRM|3279 6PT|PRM|3479 6PT|PRM|3679',
        'i|23x65': '1PS|HMP|3279 1PS|HMP|3479 1PS|HMP|3679',
        'i|23x81': '1PS|HMP|3295 1PS|HMP|3495 1PS|HMP|3695 3PS|HMP|3295 3PS|HMP|3495 3PS|HMP|3695',
        'i|23x65|23x49|16x40OV': '2P4|HMP|3279 2P4|HMP|3479 2P4|HMP|3679',
        'i|23x65|23x81': '2P4|HMP|3295 2P4|HMP|3495 2P4|HMP|3695',
        'i|23x65|23x37': '2PS|HMP|3279 2PS|HMP|3479 2PS|HMP|3679 2PT|HMP|3279 2PT|HMP|3479 2PT|HMP|3679',
        'i|23x81|23x49': '2PS|HMP|3295 2PS|HMP|3495 2PS|HMP|3695 2PT|HMP|3295 2PT|HMP|3495 2PT|HMP|3695 6PT|HMP|3295 6PT|HMP|3495 6PT|HMP|3695',
        'i|23x65|23x18': '3PC|HMP|3279 3PC|HMP|3479 3PC|HMP|3679',
        'i|23x81|23x18': '3PC|HMP|3295 3PC|HMP|3495 3PC|HMP|3695',
        'i|23x65|3x23x18': '3PS|HMP|3279 3PS|HMP|3479 3PS|HMP|3679',
        'i|21x65|21x37': '6PT|HMP|3079',
        'i|23x65|23x37|23x7': '6PT|HMP|3279 6PT|HMP|3479 6PT|HMP|3679',
        '21x65|21x37|2x9x7|2x9x37': '6PT|SED|3079 6PT|WED|3079',
        '23x65|23x37|23x7|2x9x7|2x9x37': '6PT|SED|3279 6PT|SED|3479 6PT|SED|3679 6PT|WED|3279 6PT|WED|3283 6PT|WED|3479 6PT|WED|3483 6PT|WED|3679 6PT|WED|3683',
        // 96" steel 6 Panel: the tall quarter lites run into the rail below the middle panels (David, Oct 22).
        '23x81|23x49|2x9x49': '6PT|WED|3295 6PT|WED|3495 6PT|WED|3695'
      };
      var out = {};
      Object.keys(by).forEach(function (list) { by[list].split(' ').forEach(function (k) { out[k] = list; }); });
      return out;
    })();
    // The cut SKUs a door's spec sheet offers, or null when the calculator has no list for it.
    function glassListSkus(dc, z) {
      var list = GLASS_LISTS[dc.style + '|' + (dc.build === 'WBD' ? 'HMP' : dc.build) + '|' + z.ww + z.hh];
      if (!list) return null;
      return list.split('|').filter(function (k) { return k !== 'i' && NOT_YET.indexOf(k) < 0 && OPENING_SKUS[k]; })
        .map(function (k) { return OPENING_SKUS[k]; });
    }
    // An untrimmed 28" flush door's spec sheet lists the 21" lites and the large oval with
    // 3 3/8" a side; "Any door" at exactly that width gets the same allowance.
    var FLUSH28 = ['ZCUT-GFL-2165', 'ZCUT-GHL-2137', 'ZCUT-GFL-2181', 'ZCUT-VAL-LG'];

    // Where a cut lands on a slab W x H. geo = panel geometry (null = flush).
    // opts.list: an opening from the door's spec sheet, placed by the shop's rules
    // (centered, 5 1/8" from the top, 6 1/8" on a fiberglass 7'0") whatever the panels.
    // opts.stock: the untrimmed slab. Glass stays 4 3/8" from each side and 5 1/8" from
    // the bottom of the finished slab; where the spec sheet allows less room at stock size
    // (21" lites on a 28" door, quarter lites on a 30" 6 Panel), the opening fits at stock
    // and a trim can't take any of that room.
    // Returns { rects, covered (panel indexes the glass replaces), ok, why, aligned }.
    function placeCut(c, W, H, geo, opts) {
      opts = opts || {};
      var edge = c.side ? EDGE_SIDE : EDGE_DOOR, rects = [], n = c.n || 1, k;
      var top = c.top != null ? c.top : (geo && !opts.list ? geo.top : (opts.top7 ? 6.125 : EDGE_TB));
      if (c.pet) {
        var bot = opts.petBottom != null ? opts.petBottom : EDGE_TB;
        rects.push({ x: (W - c.w) / 2, y: H - bot - c.h, w: c.w, h: c.h });
      } else if (c.lay === 'pair') {
        var cols = geo && !opts.list ? panelColumns(geo) : null;
        if (geo && !opts.list && (!cols || cols.length !== 2)) return { ok: false, why: 'it needs two panel columns', rects: [], covered: [] };
        if (cols) cols.forEach(function (cx) { rects.push({ x: cx - c.w / 2, y: top, w: c.w, h: c.h }); });
        else {
          var x0 = (W - (2 * c.w + 5)) / 2;
          rects.push({ x: x0, y: top, w: c.w, h: c.h }, { x: x0 + c.w + 5, y: top, w: c.w, h: c.h });
        }
      } else if (c.lay === 'stack') {
        for (k = 0; k < n; k++) rects.push({ x: (W - c.w) / 2, y: top + k * (c.h + c.gap), w: c.w, h: c.h });
      } else {
        rects.push({ x: (W - c.w) / 2, y: top, w: c.w, h: c.h });
      }
      var res = { rects: rects, covered: [], ok: true, why: '', aligned: true };
      var minX = Math.min.apply(null, rects.map(function (r) { return r.x; }));
      var maxX = Math.max.apply(null, rects.map(function (r) { return r.x + r.w; }));
      var maxY = Math.max.apply(null, rects.map(function (r) { return r.y + r.h; }));
      var minY = Math.min.apply(null, rects.map(function (r) { return r.y; }));
      var span = maxX - minX, what = c.side ? 'sidelite' : 'door';
      var stock = c.pet ? null : opts.stock;
      var sideRoom = stock ? Math.max(0, Math.min(edge, (stock.w - span) / 2)) : edge;
      var botRoom = c.pet ? 0 : (stock ? Math.max(0, Math.min(EDGE_TB, stock.h - maxY)) : EDGE_TB);
      if ((W - span) / 2 < sideRoom - 1e-6) {
        res.ok = false;
        res.why = c.pet ? 'it\'s too wide for this door' : 'the glass has to stay ' + toFraction(sideRoom) + ' from each edge, so it needs a ' + what +
          ' at least ' + toFraction(span + 2 * sideRoom) + ' wide';
      } else if (maxY > H - botRoom + 1e-6) {
        res.ok = false;
        res.why = c.pet ? 'it\'s too tall for this door' : 'the glass has to end ' + toFraction(botRoom) + ' above the bottom, so it needs a ' + what +
          ' at least ' + toFraction(maxY + botRoom) + ' tall';
      } else if (minY < 3 - 1e-6) { res.ok = false; res.why = 'it\'s too tall for this ' + what; }
      // The shop's standard flush cuts: 32" and wider doors take the 23" lites, not the narrow 21" ones.
      else if (!opts.list && !c.side && !c.pet && !c.shape && c.w === 21 && W >= 31.75 - 1e-6) { res.ok = false; res.why = 'the 21" narrow lites are for doors narrower than 31 3/4"'; }
      if (!res.ok || !geo || c.pet) return res;
      // Lined up with the panels: every panel is either fully replaced by glass or untouched,
      // and the glass stays inside the panel area it replaces (no cutting into stiles or rails).
      var whole = [];
      geo.panels.forEach(function (pn, idx) {
        var f = panelCover(pn, rects);
        if (f >= 0.95) whole.push(idx);
        else if (f > 0.01) res.aligned = false;
        if (f >= (opts.list ? 0.5 : 0.95)) res.covered.push(idx);
      });
      if (!whole.length) res.aligned = false;
      if (res.aligned) {
        var bx0 = Infinity, by0 = Infinity, bx1 = -Infinity, by1 = -Infinity;
        whole.forEach(function (idx) {
          var pn = geo.panels[idx];
          bx0 = Math.min(bx0, pn.x); by0 = Math.min(by0, pn.y);
          bx1 = Math.max(bx1, pn.x + pn.w); by1 = Math.max(by1, pn.y + pn.h);
        });
        if (rects.some(function (r) { return r.x < bx0 - 0.25 || r.y < by0 - 0.25 || r.x + r.w > bx1 + 0.25 || r.y + r.h > by1 + 0.25; })) res.aligned = false;
      }
      // A spec-sheet opening fits wherever it lands (the sheet allows it; a cut that
      // crosses the panels gets its position on the order). Otherwise it has to line up.
      if (opts.list) return res;
      if (c.flush) { res.ok = false; res.why = 'it\'s for flush doors only'; }
      else if (!res.aligned) { res.ok = false; res.why = 'it doesn\'t line up with the panels'; }
      return res;
    }
    // How much of a panel the glass covers (0 to 1).
    function panelCover(pn, rects) {
      var a = 0;
      rects.forEach(function (r) {
        var ox = Math.max(0, Math.min(r.x + r.w, pn.x + pn.w) - Math.max(r.x, pn.x));
        var oy = Math.max(0, Math.min(r.y + r.h, pn.y + pn.h) - Math.max(r.y, pn.y));
        a += ox * oy;
      });
      return a / (pn.w * pn.h);
    }
    function panelColumns(geo) {
      var cs = [];
      geo.panels.forEach(function (pn) {
        var cx = pn.x + pn.w / 2;
        if (!cs.some(function (v) { return Math.abs(v - cx) < 0.5; })) cs.push(cx);
      });
      return cs.sort(function (a, b) { return a - b; });
    }
    // Everything the cutouts need for this setup.
    function cutState(i) {
      var out = { door: null, side: null, pet: null, doorList: [], sideList: [], blocked: '' };
      var fit = i.door && i.doorFit && i.doorFit.ok ? i.doorFit : null;
      var geo = fit && fit.geom ? fit.geom.g : null;
      var top7 = !!(fit && !i.door.steel && fit.stock.hh === 83);
      // A picked door offers the openings on its spec sheet, held to its stock size.
      var listed = fit ? glassListSkus(i.door, fit.stock) : null;
      var opts = listed ? { top7: top7, list: true, stock: { w: fit.stock.w, h: fit.stock.h } } : { top7: top7 };
      out.placeOpts = opts;
      if (i.door && i.door.build === 'FRE') out.blocked = 'Fire-rated doors can\'t take a cutout.';
      if (i.numDoors > 0 && !out.blocked) {
        Object.keys(CUTS).forEach(function (k) {
          var c = CUTS[k];
          if (c.side || c.pet) return;
          var o = opts;
          if (!i.door && FLUSH28.indexOf(k) >= 0 && Math.abs(i.slabW - 27.75) < 1e-6) o = { top7: top7, stock: { w: 27.75, h: i.slabH } };
          var pl = placeCut(c, i.slabW, i.slabH, geo, o);
          if (listed && listed.indexOf(k) < 0) pl = { rects: pl.rects, covered: pl.covered, ok: false, why: 'it isn\'t on this door\'s spec sheet' };
          else if (i.door && !fit) pl = { rects: pl.rects, covered: pl.covered, ok: false, why: 'the door size isn\'t sold' };
          if (pl.ok) out.doorList.push(k);
          if (k === i.doorCut) out.door = { sku: k, c: c, place: pl };
        });
        if (i.petDoor !== 'none' && CUTS[i.petDoor]) {
          var pc = CUTS[i.petDoor];
          out.pet = { sku: i.petDoor, c: pc, place: placeCut(pc, i.slabW, i.slabH, null, { petBottom: i.petBottom }) };
          var pr0 = out.pet.place.rects[0];
          if (out.pet.place.ok && out.door && out.door.place.ok &&
              out.door.place.rects.some(function (g) { return pr0.y < g.y + g.h + 3 - 1e-6; })) {
            out.pet.place.ok = false;
            out.pet.place.why = 'it runs into the glass. Keep at least 3" between them, or pick a shorter lite';
          }
          // A pet door through panels is fine, but production needs the position.
          out.pet.crossesPanels = !!geo && geo.panels.some(function (pn, idx) {
            var r = out.pet.place.rects[0];
            var hidden = out.door && out.door.place.ok && out.door.place.covered.indexOf(idx) >= 0;
            return !hidden && r.x < pn.x + pn.w && r.x + r.w > pn.x && r.y < pn.y + pn.h && r.y + r.h > pn.y;
          });
        }
      }
      if (i.numSidelites > 0) {
        var best = null;
        Object.keys(CUTS).forEach(function (k) {
          var c = CUTS[k];
          if (!c.side) return;
          var pl = placeCut(c, i.sideliteW, i.slabH, null, {});
          if (pl.ok) out.sideList.push(k);
          if (pl.ok && k.indexOf('ZCUT-GFS-') === 0 && (!best || c.w * c.h > best.c.w * best.c.h)) best = { sku: k, c: c, place: pl };
          if (k === i.sideCut) out.side = { sku: k, c: c, place: pl };
        });
        out.sideAuto = best ? best.sku : null;
        if (i.sideCut === 'auto' && best) { out.side = best; out.side.auto = true; }
      }
      out.geo = geo;
      out.top7 = top7;
      return out;
    }
    // Draw one cut (rect or shaped) with its glass-kit frame. X/Y map
    // slab inches (y down from the top) to SVG units; sx/sy scale lengths.
    function drawCutShape(svg, mk, c, r, X, Y, sx, sy, small) {
      var fr = 0.5;   // the kit frame is 1/2" bigger than the cut all round
      var path = function (x, y, w, h, grow) {
        x -= grow; y -= grow; w += 2 * grow; h += 2 * grow;
        var rx = (w / 2) * sx;
        if (c.shape === 'round') {
          var rr = Math.min(w / 2, h);
          return 'M' + X(x) + ',' + Y(y + h) + 'L' + X(x) + ',' + Y(y + rr) +
            'A' + rx + ',' + (rr * sy) + ' 0 0 1 ' + X(x + w) + ',' + Y(y + rr) + 'L' + X(x + w) + ',' + Y(y + h) + 'Z';
        }
        if (c.shape === 'oval') {
          var ry = (h / 2) * sy;
          return 'M' + X(x) + ',' + Y(y + h / 2) + 'A' + rx + ',' + ry + ' 0 1 1 ' + X(x + w) + ',' + Y(y + h / 2) +
            'A' + rx + ',' + ry + ' 0 1 1 ' + X(x) + ',' + Y(y + h / 2) + 'Z';
        }
        if (c.shape === 'arch') {
          var rise = Math.min(2, h / 3);
          return 'M' + X(x) + ',' + Y(y + h) + 'L' + X(x) + ',' + Y(y + rise) +
            'A' + rx + ',' + (rise * sy) + ' 0 0 1 ' + X(x + w) + ',' + Y(y + rise) + 'L' + X(x + w) + ',' + Y(y + h) + 'Z';
        }
        if (c.shape === 'fan') {
          return 'M' + X(x) + ',' + Y(y + h) + 'A' + rx + ',' + (h * sy) + ' 0 0 1 ' + X(x + w) + ',' + Y(y + h) + 'Z';
        }
        return 'M' + X(x) + ',' + Y(y) + 'H' + X(x + w) + 'V' + Y(y + h) + 'H' + X(x) + 'Z';
      };
      var np = { 'pointer-events': 'none' };
      var add = function (attrs) { var n = mk('path', attrs); n.setAttribute('pointer-events', 'none'); svg.appendChild(n); return n; };
      void np;
      if (c.pet) {
        add({ d: path(r.x, r.y, r.w, r.h, fr), fill: '#D5DAE1', stroke: '#6B7380', 'stroke-width': small ? 0.6 : 0.9 });
        add({ d: path(r.x + 0.75, r.y + 1.25, r.w - 1.5, r.h - 2, 0), fill: '#BCC3CD', stroke: '#8A929E', 'stroke-width': small ? 0.4 : 0.6 });
        return;
      }
      add({ d: path(r.x, r.y, r.w, r.h, fr), fill: '#EEF1F5', stroke: '#7D8898', 'stroke-width': small ? 0.6 : 0.9 });
      add({ d: path(r.x, r.y, r.w, r.h, 0), fill: '#CFE2F1', stroke: '#6C86A0', 'stroke-width': small ? 0.4 : 0.6 });
      if (c.shape === 'fan') {
        for (var k = 1; k < 6; k++) {
          var ang = Math.PI * k / 6;
          add({ d: 'M' + X(r.x + r.w / 2) + ',' + Y(r.y + r.h) + 'L' + X(r.x + r.w / 2 - Math.cos(ang) * r.w / 2 * 0.97) + ',' +
            Y(r.y + r.h - Math.sin(ang) * r.h * 0.97), fill: 'none', stroke: '#8FA6BD', 'stroke-width': small ? 0.3 : 0.6 });
        }
      } else if (!small && r.w > 4 && r.h > 4) {
        // Two light streaks so it reads as glass.
        var s1 = Math.min(r.w, r.h) * 0.35;
        add({ d: 'M' + X(r.x + r.w * 0.18) + ',' + Y(r.y + r.h * 0.5) + 'L' + X(r.x + r.w * 0.18 + s1) + ',' + Y(r.y + r.h * 0.5 - s1),
          fill: 'none', stroke: '#FFFFFF', 'stroke-width': 1.2, 'stroke-opacity': 0.8 });
        add({ d: 'M' + X(r.x + r.w * 0.18 + 2) + ',' + Y(r.y + r.h * 0.5 + 1) + 'L' + X(r.x + r.w * 0.18 + 2 + s1 * 0.6) + ',' + Y(r.y + r.h * 0.5 + 1 - s1 * 0.6),
          fill: 'none', stroke: '#FFFFFF', 'stroke-width': 0.8, 'stroke-opacity': 0.7 });
      }
    }
    // Thumbnail buttons: the door (with its panels) wearing each fitting cut.
    var SVGNS = 'http://www.w3.org/2000/svg';
    function mkNS(tag, attrs) {
      var n = document.createElementNS(SVGNS, tag);
      Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
      return n;
    }
    function renderCutThumbs(which, list, cur, W, H, geo, opts, autoSku) {
      var box = sectionEl.querySelector('[data-cut-thumbs="' + which + '"]');
      if (!box) return;
      var keys = (which === 'side' ? ['auto'] : []).concat(['none']).concat(list);
      if (keys.indexOf(cur) < 0) keys.push(cur);   // keep an invalid pick visible
      var sig = keys.join(',') + '|' + autoSku + '|' + W + 'x' + H + '|' + (geo ? JSON.stringify(geo.panels) : 'flush') + '|' + JSON.stringify(opts);
      if (box._sig === sig) return;
      box._sig = sig;
      box.textContent = '';
      var bh = 80, bw = which === 'side' ? Math.max(12, Math.round(78 * W / H) + 2) : 40, kx = (bw - 2) / W, ky = (bh - 2) / H;
      var X = function (x) { return (1 + x * kx).toFixed(2); };
      var Y = function (y) { return (1 + y * ky).toFixed(2); };
      keys.forEach(function (k) {
        var c = k === 'auto' ? (autoSku ? CUTS[autoSku] : null) : CUTS[k];
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pease-choice__btn';
        btn.setAttribute('data-set', (which === 'door' ? 'doorCut=' : 'sideCut=') + k);
        btn.setAttribute('aria-pressed', 'false');
        var svgEl = mkNS('svg', { viewBox: '0 0 ' + bw + ' ' + bh, width: 30, height: 60, 'aria-hidden': 'true',
          preserveAspectRatio: which === 'side' ? 'xMidYMid meet' : 'none' });
        var pl = c ? placeCut(c, W, H, geo, opts) : { rects: [], covered: [] };
        svgEl.appendChild(mkNS('rect', { x: 1, y: 1, width: bw - 2, height: bh - 2, rx: 1, fill: 'none', stroke: 'currentColor', 'stroke-width': 1.4 }));
        if (geo) geo.panels.forEach(function (pn, idx) {
          if (pl.covered.indexOf(idx) >= 0) return;
          svgEl.appendChild(mkNS('rect', { x: X(pn.x), y: Y(pn.y), width: (pn.w * kx).toFixed(2), height: (pn.h * ky).toFixed(2),
            fill: 'currentColor', 'fill-opacity': 0.1, stroke: 'currentColor', 'stroke-width': 0.7 }));
        });
        if (c) pl.rects.forEach(function (r) { drawCutShape(svgEl, mkNS, c, r, X, Y, kx, ky, true); });
        btn.appendChild(svgEl);
        var span = document.createElement('span');
        span.textContent = k === 'auto' ? 'Full glass' : (c ? cutName(c, H) : 'No glass');
        btn.appendChild(span);
        if (c) {
          var sm = document.createElement('small');
          sm.textContent = (k === 'auto' ? 'best fit, ' : '') + toFraction(c.w).replace('"', '') + ' x ' + toFraction(c.h).replace('"', '') + (c.n || c.lay === 'pair' ? ' each' : '');
          btn.appendChild(sm);
        }
        box.appendChild(btn);
      });
    }
    function renderCuts(i) {
      var fs = sectionEl.querySelector('[data-cut-fieldset]');
      if (!fs) return;
      var cs = i.cuts;
      var show = function (key, on) {
        var el = sectionEl.querySelector('[data-group="' + key + '"]');
        if (el) el.style.display = on ? '' : 'none';
      };
      show('door-cut', i.numDoors > 0 && !cs.blocked);
      show('pet-door', i.numDoors > 0 && !cs.blocked);
      show('pet-bottom', i.numDoors > 0 && !cs.blocked && i.petDoor !== 'none');
      fs.style.display = i.numDoors > 0 ? '' : 'none';
      var sfs = sectionEl.querySelector('[data-side-cut-fieldset]');
      if (sfs) sfs.style.display = i.numSidelites > 0 ? '' : 'none';
      show('cut-install', !!(cs.door && !cs.blocked));
      show('side-install', !!cs.side);
      var sh = sectionEl.querySelector('[data-cut-hint="side"]');
      if (sh) sh.textContent = i.numSidelites === 2
        ? 'Both sidelites get the same glass. Centered, 5 1/8" from the top.'
        : 'Centered, 5 1/8" from the top.';
      if (i.numDoors > 0 && !cs.blocked) renderCutThumbs('door', cs.doorList, i.doorCut, i.slabW, i.slabH, cs.geo, cs.placeOpts);
      if (i.numSidelites > 0) renderCutThumbs('side', cs.sideList, i.sideCut, i.sideliteW, i.slabH, null, {}, cs.sideAuto);
      var hint = sectionEl.querySelector('[data-cut-hint="door"]');
      if (hint) hint.textContent = cs.placeOpts && cs.placeOpts.list
        ? 'The openings on this door\'s spec sheet that fit its finished size. Glass stays 4 3/8" from each side and 5 1/8" from the bottom' +
          ', so trimming the door can rule some out. Pick "Any door" for flush-door cutouts.'
        : cs.geo
        ? 'Only cuts that line up with this door\'s panels are shown. Pick "Any door" for flush-door cutouts.'
        : 'Standard positions: centered, 5 1/8" from the top' + (cs.top7 ? ' (6 1/8" on a 7\'0" door)' : '') +
          '. Glass stays 4 3/8" from each side and 5 1/8" from the bottom of the finished slab.';
      var sum = sectionEl.querySelector('[data-cut-summary]');
      if (sum) {
        var picked = [];
        if (i.numDoors > 0 && !cs.blocked && cs.door) picked.push(cutName(cs.door.c, i.slabH));
        if (i.numDoors > 0 && !cs.blocked && cs.pet) picked.push('pet door');
        sum.textContent = picked.length ? picked.join(' · ') : 'None';
      }
      var ssum = sectionEl.querySelector('[data-scut-summary]');
      if (ssum) ssum.textContent = cs.side ? cutName(cs.side.c, i.slabH) + (i.numSidelites === 2 ? ' (both)' : '') : 'None';
      var info = sectionEl.querySelector('[data-cut-info]');
      var bits = [];
      if (cs.blocked) bits.push(cs.blocked);
      if (cs.door && !cs.blocked) bits.push('The glass kit is a separate line. Its frame is the cut size plus 1" (glass is the cut minus 1").');
      if (i.door && /HMP|WBD/.test(i.door.build) && cs.door) bits.push('Use impact-rated glass to keep the impact rating.');
      if (info) info.textContent = bits.join(' ');
    }

    // Detailed Measurements: where each cutout sits on the finished slab.
    function renderCutSpec(i) {
      var block = sectionEl.querySelector('[data-spec="cuts"]');
      var box = block && block.querySelector('[data-cut-spec]');
      if (!box) return;
      var cs = i.cuts || {};
      var items = [];
      if (i.numDoors > 0 && !cs.blocked && cs.door && cs.door.place.ok) {
        items.push({ title: 'Door glass' + (i.numDoors === 2 ? ' (each door)' : ''), cut: cs.door, W: i.slabW, edge: 'door' });
      }
      if (i.numDoors > 0 && !cs.blocked && cs.pet && cs.pet.place.ok) {
        items.push({ title: 'Pet door' + (i.numDoors === 2 ? ' (active door)' : ''), cut: cs.pet, W: i.slabW, edge: 'door' });
      }
      if (i.numSidelites > 0 && cs.side && cs.side.place.ok) {
        items.push({ title: 'Sidelite glass' + (i.numSidelites === 2 ? ' (each sidelite)' : ''), cut: cs.side, W: i.sideliteW, edge: 'sidelite' });
      }
      block.hidden = !items.length;
      box.textContent = '';
      var f = function (v) { return toFraction(v); };
      var dims = function (w, h) { return f(w).replace('"', '') + ' x ' + f(h); };
      items.forEach(function (it) {
        var c = it.cut.c, rs = it.cut.place.rects, H = i.slabH, r0 = rs[0], rl = rs[rs.length - 1];
        var h5 = document.createElement('h5');
        h5.className = 'pease-dsc__spec-sub';
        h5.textContent = it.title + ': ' + cutName(c, H) + ' (' + it.cut.sku + ')';
        box.appendChild(h5);
        var ul = document.createElement('ul');
        ul.className = 'pease-dsc__spec-list';
        var row = function (label, val) {
          var li = document.createElement('li');
          var a = document.createElement('span'); a.textContent = label;
          var b = document.createElement('strong'); b.textContent = val;
          li.appendChild(a); li.appendChild(b); ul.appendChild(li);
        };
        var n = rs.length;
        row('Cut size' + (n > 1 ? ' (each of ' + n + ')' : ''), dims(c.w, c.h));
        var ks = kitSize(c);
        if (!c.pet) row('Glass kit frame / glass', dims(ks.fw, ks.fh) + ' / ' + dims(ks.gw, ks.gh));
        if (c.pet) {
          row('Bottom of ' + it.edge + ' to bottom of cutout', f(H - r0.y - r0.h));
          row('Bottom of ' + it.edge + ' to top of cutout', f(H - r0.y));
        } else {
          row('Top of ' + it.edge + ' to top of cutout' + (c.shape === 'round' || c.shape === 'arch' || c.shape === 'fan' || c.shape === 'oval' ? ' (peak)' : ''), f(r0.y));
          if (c.shape === 'round') row('Top of ' + it.edge + ' to start of the round top', f(r0.y + Math.min(c.w / 2, c.h)));
          if (c.shape === 'arch') row('Top of ' + it.edge + ' to arch corners', f(r0.y + Math.min(2, c.h / 3)));
          if (c.lay === 'stack') {
            row('Space between lites', f(c.gap));
            rs.forEach(function (r, k) { if (k) row('Top of ' + it.edge + ' to top of lite ' + (k + 1), f(r.y)); });
          }
          row('Top of ' + it.edge + ' to bottom of cutout', f(rl.y + rl.h));
          row('Bottom of cutout to bottom of ' + it.edge, f(H - rl.y - rl.h));
        }
        if (c.lay === 'pair') {
          row('Each side edge to outer edge of cutouts', f(r0.x));
          row('Space between the two lites', f(rs[1].x - r0.x - r0.w));
        } else {
          row('Each side edge to cutout (centered)', f(r0.x));
        }
        box.appendChild(ul);
      });
    }

    // Item Reference tab: the products in this setup, in plain words.
    function itemRows(i, r) {
      var rows = [], cs = i.cuts || {}, d = i.numDoors, sl = i.numSidelites;
      var qty = function (n) { return n > 1 ? n + ' x ' : ''; };
      if (d > 0) {
        if (i.door && i.doorFit && i.doorFit.ok) {
          var z = i.doorFit.stock;
          rows.push(['Door slab', qty(d) + i.door.label + ', ' + nomLabel(z) + ' x ' + heightLabel(z.hh) +
            (i.doorFit.trim !== 'none' ? ', trimmed to ' + toFraction(i.slabH) + ' tall' : '')]);
          rows.push(['Door SKU', 'SE-' + i.door.style + '-' + z.ww + z.hh + '-' + i.door.tex + '-' + i.door.build]);
        } else {
          rows.push(['Door slab', qty(d) + toFraction(i.slabW) + ' x ' + toFraction(i.slabH) + ' (style not picked)']);
        }
        rows.push(['Handing', (i.handing === 'Left' ? 'Left' : 'Right') + ' hand ' + i.swing.toLowerCase()]);
        if (cs.door && !cs.blocked && cs.door.place.ok) {
          rows.push(['Door glass', qty(d) + cutName(cs.door.c, i.slabH) + ' kit, frame ' + toFraction(kitSize(cs.door.c).fw).replace('"', '') +
            ' x ' + toFraction(kitSize(cs.door.c).fh) + (i.cutInstall === 'yes' ? ', installed' : ', ships loose')]);
        }
        if (cs.pet && !cs.blocked && cs.pet.place.ok) rows.push(['Pet door', cutName(cs.pet.c, i.slabH)]);
      }
      if (sl > 0) {
        rows.push(['Sidelite' + (sl > 1 ? 's' : ''), qty(sl) + toFraction(i.sideliteW) + ' x ' + toFraction(i.slabH) +
          (cs.side && cs.side.place.ok ? ', ' + cutName(cs.side.c, i.slabH) + ' glass' + (i.sideInstall === 'yes' ? ', installed' : ', ships loose') : ', flush panel')]);
      }
      if (i.ship !== 'slab' && d + sl > 0) {
        rows.push(['Jamb set', toFraction16(i.jambDepth) + ' deep: legs ' + toFraction16(r.jambHt) + ', head ' + toFraction16(r.headJamb)]);
        if (r.mullCount > 0) rows.push(['Mull post' + (r.mullCount > 1 ? 's' : ''), qty(r.mullCount) + toFraction16(r.mullHt)]);
        rows.push(['Threshold', toFraction16(r.threshold) + ' wide (' + i.threshold.toLowerCase() + ')']);
        rows.push(['Brickmold', 'legs ' + toFraction16(r.bmLegs) + ', head ' + toFraction16(r.bmHead)]);
      }
      if (d > 0) {
        rows.push(['Hinges', i.hingeCount + ' per door, ' + toFraction(i.hingeSize).replace('"', '') + '" x ' + toFraction(i.hingeSize)]);
        if (r.hasLatch) rows.push(['Lockset', (r.hasDeadbolt ? 'Lockset and deadbolt' : 'Lockset') + ', ' + toFraction(i.backset) + ' backset']);
      }
      rows.push(['Ships as', (SHIP_LABELS[i.ship] || i.ship).replace(/^./, function (ch) { return ch.toUpperCase(); })]);
      return rows;
    }

    // Door style fields, size quick picks and the info line.
    function renderDoorInfo(i) {
      var fs = sectionEl.querySelector('[data-door-style-fieldset]');
      if (!fs) return;
      fs.style.display = (DOOR && i.numDoors > 0) ? '' : 'none';
      var chosen = !!i.door;
      var show = function (key, on) {
        var el = sectionEl.querySelector('[data-group="' + key + '"]');
        if (el) el.style.display = on ? '' : 'none';
      };
      show('door-style', i.doorMaterial !== 'none');
      show('door-texture', i.doorMaterial === 'fiberglass');
      show('door-build', i.doorMaterial !== 'none');
      // Quick picks: only the chosen door's stock sizes.
      var widths = chosen ? i.door.sizes.map(function (z) { return z.w; }) : null;
      var heights = chosen ? i.door.sizes.map(function (z) { return z.h; }) : null;
      [['slabW', widths], ['slabH', heights]].forEach(function (pair) {
        sectionEl.querySelectorAll('[data-chips-for="' + pair[0] + '"] .pease-chip').forEach(function (c) {
          var v = parseFrac(c.getAttribute('data-chip'));
          c.hidden = !!pair[1] && !pair[1].some(function (x) { return Math.abs(x - v) < 1e-6; });
        });
      });
      var info = sectionEl.querySelector('[data-door-info]');
      if (!info) return;
      if (!chosen) { info.textContent = ''; return; }
      var ws = [], hs = [];
      i.door.sizes.forEach(function (z) {
        if (ws.indexOf(z.ww) < 0) ws.push(z.ww);
        if (hs.indexOf(z.hh) < 0) hs.push(z.hh);
      });
      ws.sort(function (a, b) { return a - b; });
      hs.sort(function (a, b) { return a - b; });
      var trimText = i.door.trimmable
        ? 'Height: up to 1/2" off the bottom, or more with a re-rail while keeping 4" below the lowest panel. Width can\'t be trimmed.'
        : (i.door.steel ? 'Steel doors can\'t be trimmed.' : 'Impact and fire-rated doors can\'t be trimmed.');
      info.textContent = 'Comes in ' + ws.join('", ') + '" wide x ' + hs.map(heightLabel).join(', ') + ' tall. ' + trimText;
    }

    // ---- Shop services for this setup (Shop Services Guide rules) ----
    var SHIP_LABELS = { prehung: 'prehung', kit: 'pre-drilled kit', slab: 'slab only', components: 'components' };
    function serviceLines(i, r) {
      var lines = [], notes = [], orderNotes = [];
      var unit = i.ship === 'prehung' || i.ship === 'kit';
      var d = i.numDoors, sl = i.numSidelites;
      // Line properties (Shop Services Guide): "Door" names which leaf a line
      // is for whenever the order has more than one door or sidelite.
      var many = d + sl > 1;
      var LBL = {
        doors: d === 2 ? 'Door 1 & 2' : 'Door 1',
        active: d === 2 ? 'Door 1 (active)' : 'Door 1',
        inactive: 'Door 2 (inactive)',
        sides: sl === 2 ? 'Sidelites 1 & 2'
          : 'Sidelite 1' + (d > 0 && i.sideliteSide ? (i.sideliteSide === 'L' ? ' (left' : ' (right') + ', viewed from outside)' : '')
      };
      var add = function (sku, qty, why, desc, scope, extra) {
        var props = {};
        if (many && scope) props.Door = LBL[scope];
        if (extra) Object.keys(extra).forEach(function (k) { props[k] = extra[k]; });
        lines.push({ sku: sku, qty: qty || 1, why: why || '', desc: desc, props: props });
      };
      var dash = function (v) { return toFraction(v).replace('"', '').replace(' ', '-'); };
      var trimTo = dash(i.slabW) + ' x ' + dash(i.slabH) + ' (finished slab)';
      // The door itself, and any trimming it needs.
      var dc = i.door, fit = i.doorFit;
      if (dc && fit && fit.ok) {
        add('SE-' + dc.style + '-' + fit.stock.ww + fit.stock.hh + '-' + dc.tex + '-' + dc.build, d, '',
          'Door slab: ' + dc.label + ', ' + nomLabel(fit.stock) + ' x ' + heightLabel(fit.stock.hh), 'doors');
        if (fit.trim === 'slab') {
          add('ZTRIM-SLAB', d, toFraction(fit.cut) + ' off the bottom', null, 'doors', { 'Trim to': trimTo });
        } else if (fit.trim === 'rerail') {
          add('ZTRIM-RERAIL', d, toFraction(fit.cut) + ' off the bottom', null, 'doors', { 'Trim to': trimTo });
          add(i.slabW <= 35.75 ? 'SE-RAIL-36' : 'SE-RAIL-72', d, '', null, 'doors');
        }
      }
      if (d > 0) {
        add('ZASY-SETUP-' + (i.handing === 'Left' ? 'LH' : 'RH') + (i.swing === 'Inswing' ? 'IS' : 'OS'), 1,
          d === 2 ? 'names the active door' : '', null, d === 2 ? 'doors' : 'active');
        // Lock prep: one line, on the active door.
        var lockSku;
        var customLock = r.hasLatch && (
          (i.latchBoreTop !== null && Math.abs(r.latchBore - r.std.latchBore) > 1e-9) ||
          (r.hasDeadbolt && Math.abs(i.boreSpacing - 5.5) > 1e-9));
        if (!r.hasLatch) lockSku = 'ZPREP-EXT-NOLOCK';
        else if (customLock) lockSku = 'ZPREP-EXT-L-CUST-CYL';
        else {
          var bs = i.backset > 2.5 ? 'LONG' : (i.backset < 2.2 ? 'SHORT' : 'STD');
          lockSku = r.hasDeadbolt
            ? (bs === 'STD' ? 'ZPREP-EXT-L-STD' : 'ZPREP-EXT-L-DB-' + bs)
            : 'ZPREP-EXT-L-SB-' + bs;
        }
        // Hinge prep: included with a unit (custom is extra); optional on a slab, where
        // "none" is a $0 line so production knows the hinge edge stays blank.
        var hingeSku = null, custHinge = customHinges(i);
        if (unit) {
          if (custHinge) hingeSku = 'ZPREP-EXT-H-CUST';
          else notes.push('Standard hinge prep is included with the ' + (i.ship === 'prehung' ? 'prehung unit' : 'pre-drilled kit') + '.');
        } else if (i.hingePrep === 'yes') {
          hingeSku = custHinge ? 'ZPREP-EXT-H-CUST' : 'ZPREP-EXT-H-STD';
        } else {
          hingeSku = 'ZPREP-EXT-NOHINGE';
        }
        if (dc && dc.build === 'FRE') {
          if (lockSku === 'ZPREP-EXT-L-STD' && !custHinge) {
            notes.push('Fire-rated doors ship with standard hinge and double-bore lock prep at no charge.');
          } else {
            add('ZPREP-EXT-HL-FRE', d, 'special order, 6-10 weeks', null, 'doors');
            notes.push('Custom prep on a fire-rated door is built as a one-off at the slab plant. Steer to standard prep if the hardware allows.');
          }
          lockSku = null; hingeSku = null;
        } else if (!unit && hingeSku === 'ZPREP-EXT-H-STD' && lockSku === 'ZPREP-EXT-L-STD') {
          // Both exactly standard on a slab-only order: the combo SKU.
          add('ZPREP-EXT-HL-STD', 1, d === 2 ? 'active door' : '', null, 'active');
          if (d === 2) add('ZPREP-EXT-H-STD', 1, 'inactive door', null, 'inactive');
        } else {
          if (lockSku) add(lockSku, 1, d === 2 ? 'active door' : '', null, 'active');
          if (hingeSku) add(hingeSku, d, d === 2 ? 'both doors' : '', null, 'doors');
        }
        if (lockSku === 'ZPREP-EXT-L-CUST-CYL') {
          orderNotes.push('Custom lock prep: ' + (r.hasDeadbolt ? 'deadbolt bore at ' + toFraction(r.deadboltBore) + ', ' : '') +
            'latch bore at ' + toFraction(r.latchBore) + ' (centers, from top of slab), ' + toFraction(i.backset) + ' backset.');
        }
        if (hingeSku === 'ZPREP-EXT-H-CUST') {
          orderNotes.push('Custom hinge prep: ' + i.hingeCount + ' hinges, ' + toFraction(i.hingeSize).replace('"', '') + '" x ' +
            toFraction(i.hingeSize).replace('"', '') + '", tops at ' +
            [r.slab1, r.slab2, r.slab3, r.slab4].filter(function (v) { return typeof v === 'number'; })
              .map(function (v) { return toFraction(v); }).join(', ') + ' from top of slab.');
        }
      }
      // Cutouts
      var cs = i.cuts || {};
      var glassQty = 0;
      // "Standard half lite position": the cut's family name, without the width variant.
      var stdPos = function (c) { return 'Standard ' + cutName(c, i.slabH).split(',')[0].replace(/ \(\d\)$/, '').toLowerCase() + ' position'; };
      var doorGlass = d > 0 && cs.door && !cs.blocked && cs.door.place.ok;
      var sideGlass = sl > 0 && cs.side && cs.side.place.ok;
      if (doorGlass) {
        // Paneled doors need no position when the cut follows the panels.
        // A spec-sheet cut that crosses the panels gets its position too.
        add(cs.door.sku, d, d === 2 ? 'both doors' : '', null, 'doors', cs.geo && cs.door.place.aligned !== false ? null :
          { 'Cut position': stdPos(cs.door.c) + (cs.geo ? ', ' + dash(cs.door.place.rects[0].y) + ' from the top, centered' : '') });
        if (i.cutInstall === 'yes') add('ZASY-INSTALL-GLASS', d, '', null, 'doors');
        glassQty += d;
      }
      if (sideGlass) {
        add(cs.side.sku, sl, sl === 2 ? 'both sidelites' : '', null, 'sides', { 'Cut position': stdPos(cs.side.c) });
        if (i.sideInstall === 'yes') add('ZASY-INSTALL-GLASS', sl, '', null, 'sides');
        glassQty += sl;
      }
      var instQty = (doorGlass && i.cutInstall === 'yes' ? d : 0) + (sideGlass && i.sideInstall === 'yes' ? sl : 0);
      if (glassQty) {
        var gk = [cs.door && cs.door.place.ok && d > 0 ? cs.door.c : null, cs.side && cs.side.place.ok && sl > 0 ? cs.side.c : null]
          .filter(Boolean).map(function (c) {
            return cutName(c, i.slabH) + ' kit, frame ' + toFraction(kitSize(c).fw).replace('"', '') + ' x ' + toFraction(kitSize(c).fh).replace('"', '') + '"';
          });
        notes.push('Glass kits are separate lines: ' + gk.join('; ') + '.' +
          (instQty === 0 ? ' They ship loose.' : instQty < glassQty ? ' The ' + (i.cutInstall === 'yes' ? 'sidelite' : 'door') + ' glass ships loose.' : ''));
      }
      if (d > 0 && cs.pet && !cs.blocked && cs.pet.place.ok) {
        var prc = cs.pet.place.rects[0];
        add(cs.pet.sku, 1, d === 2 ? 'active door' : '', null, 'active', {
          'Cut position': 'Bottom of cutout ' + dash(i.slabH - prc.y - prc.h) + ' from the bottom of the door, centered (' +
            dash(prc.x) + ' from each edge)'
        });
        notes.push('The customer supplies the pet door unless it is on the order (then add ZASY-INSTALL-PET to ship it installed).');
      }
      // Assembly
      if (i.ship === 'components') {
        add('ZASY-EXT-COMP', 1, '');
      } else if (unit) {
        var base = i.ship === 'prehung' ? 'ZASY-EXT-PREHUNG' : 'ZASY-EXT-KIT';
        var asy = null;
        if (i.transom !== 1) {
          if (d === 1 && sl === 0) asy = base;
          else if (d === 1 && sl === 1) asy = base + (i.sideliteSide === 'L' ? '-SLL' : '-SLR');
          else if (d === 1 && sl === 2) asy = base + '-SL2';
          else if (d === 2 && sl === 0) asy = base + '-DBL';
        }
        if (asy) {
          add(asy, 1, '');
          if (i.ship === 'prehung' && (sl > 0 || d === 2)) {
            notes.push('Prehung sidelite and double units are too large to ship on a pallet, so they are pickup only. Choose Pre-drilled kit to ship it.');
          }
        } else {
          notes.push('This layout (' + (i.transom === 1 ? 'with a transom' : d === 0 ? 'sidelite only' : 'double with sidelites') +
            ') needs Special Assembly. Confirm the scope and level (ZASY-SPECIAL) with production before quoting.');
        }
      }
      if (r.mullCount > 0 && d > 0 && i.ship !== 'components') {
        notes.push('Prep includes the matching jamb and mull post prep when the jambs are on the same order.');
      }
      return { lines: lines, notes: notes, orderNotes: orderNotes };
    }

    // One-line recap of the setup, shown above the results.
    function summaryText(i) {
      var parts = [];
      if (i.numDoors === 0) {
        parts.push(toFraction(i.sideliteW) + ' × ' + toFraction(i.slabH) + ' sidelite only');
      } else {
        parts.push(toFraction(i.slabW) + ' × ' + toFraction(i.slabH) + (i.numDoors === 2 ? ' double door' : ' single door'));
        if (i.door) parts.push(i.door.label);
        if (i.cuts && i.cuts.door && !i.cuts.blocked && i.cuts.door.place.ok) parts.push(cutName(i.cuts.door.c, i.slabH).toLowerCase());
        if (i.cuts && i.cuts.pet && !i.cuts.blocked && i.cuts.pet.place.ok) parts.push('pet door');
        parts.push((i.handing === 'Left' ? 'left hand ' : 'right hand ') + i.swing.toLowerCase() + (i.numDoors === 2 ? ' (active door)' : ''));
        if (i.numSidelites === 2) parts.push('2 sidelites (' + toFraction(i.sideliteW) + ')');
        else if (i.numSidelites === 1) parts.push((i.sideliteSide === 'L' ? 'left' : 'right') + ' sidelite (' + toFraction(i.sideliteW) + ')');
      }
      if (i.transom === 1) parts.push('transom (' + toFraction(i.transomH) + ')');
      parts.push(toFraction16(i.jambDepth) + ' jamb');
      if (i.numDoors > 0) parts.push(LOCK_PREP_LABELS[i.lockPrep].toLowerCase());
      parts.push(SHIP_LABELS[i.ship]);
      if (i.sizeMode === 'ro') parts.push('for a ' + toFraction(i.roW) + ' × ' + toFraction(i.roH) + ' opening');
      var text = parts.join(' · ');
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
    function stickyText(r) {
      return 'Unit ' + toFraction16(r.unitW) + ' × ' + toFraction16(r.unitH) +
        ' · Opening ' + toFraction16(r.roWmin) + '–' + toFraction16(r.roWmax) +
        ' × ' + toFraction16(r.roHmin) + '–' + toFraction16(r.roHmax);
    }

    // ---- Render ----
    function setOut(key, val, fmt) {
      var el = sectionEl.querySelector('[data-out="' + key + '"]');
      if (!el) return;
      el.textContent = fmt ? fmt(val) : val;
    }

    function render() {
      var i = getInputs();
      if (DOOR) syncDoorOptions(i);
      sizeByOpening(i);
      i.door = doorChoice(i);
      i.doorFit = i.door ? doorFit(i, i.door) : null;
      i.cuts = cutState(i);
      var r = calculate(i);

      // Buyer tab
      // Width/height dimensions can land on sixteenths once 1/16"-capable
      // fractional inputs are enabled, so format them at 1/16" precision.
      // Hinge/bore positions on the slab stay at 1/8" since calculate()
      // explicitly rounds them with r8().
      setOut('unitW', r.unitW, toFraction16);
      setOut('unitH', r.unitH, toFraction16);
      setOut('unitD', r.unitD, toFraction16);
      setOut('unitBmW', r.unitBmW, toFraction16);
      setOut('unitBmH', r.unitBmH, toFraction16);
      setOut('unitBmD', r.unitBmD, toFraction16);
      setOut('roWmin', r.roWmin, toFraction16);
      setOut('roWmax', r.roWmax, toFraction16);
      setOut('roHmin', r.roHmin, toFraction16);
      setOut('roHmax', r.roHmax, toFraction16);
      setOut('roDmin', r.roDmin, toFraction16);
      setOut('roDmax', r.roDmax, toFraction16);

      // Installer tab — slab
      setOut('slab1', r.slab1, toFraction);
      setOut('slab2', r.slab2, toFraction);
      setOut('slab3', r.slab3, toFraction);
      setOut('slab4', r.slab4, toFraction);
      setOut('lockPrepOut', LOCK_PREP_LABELS[i.lockPrep]);
      setOut('deadboltBore', r.deadboltBore, toFraction);
      setOut('latchBore', r.latchBore, toFraction);
      setOut('boreSpacingOut', i.boreSpacing, toFraction16);
      setOut('backset', i.backset, toFraction);

      // Installer tab — hinge jamb
      setOut('jambHt', r.jambHt, toFraction16);
      setOut('jamb1', r.jamb1, toFraction);
      setOut('jamb2', r.jamb2, toFraction);
      setOut('jamb3', r.jamb3, toFraction);
      setOut('jamb4', r.jamb4, toFraction);

      // Installer tab — strike jamb
      setOut('dbMortTop', r.dbMortTop, toFraction);
      setOut('dbStrike', r.dbStrike, toFraction);
      setOut('dbMortBot', r.dbMortBot, toFraction);
      setOut('latchMortTop', r.latchMortTop, toFraction);
      setOut('latchStrike', r.latchStrike, toFraction);
      setOut('latchMortBot', r.latchMortBot, toFraction);

      // Installer tab — mull posts (only when the unit has mulls)
      setOut('mullHt', r.mullHt, toFraction16);
      setOut('mullDropNote', i.mullHeadDrop, toFraction16);
      ['mull1', 'mull2', 'mull3', 'mull4',
       'mullDbMortTop', 'mullDbStrike', 'mullDbMortBot',
       'mullLatchMortTop', 'mullLatchStrike', 'mullLatchMortBot'].forEach(function (k) {
        setOut(k, r[k], toFraction);
      });
      var plural = function (n, one) { return n > 1 ? n + ' ' + one + 's' : one; };
      setOut('mullHingeTitle', plural(r.mullHinge, 'Hinge-side mull'));
      setOut('mullStrikeTitle', plural(r.mullStrike, 'Strike-side mull'));
      var showSpec = function (name, on) {
        var el = sectionEl.querySelector('[data-spec="' + name + '"]');
        if (el) el.hidden = !on;
      };
      showSpec('mull', r.mullCount > 0);
      showSpec('strikeJamb', r.legStrike);
      setOut('hingeJambTitle', r.legHinge ? 'Hinge jamb' : 'Leg jambs');
      sectionEl.querySelector('[data-mull-group="hinge"]').hidden = r.mullHinge === 0;
      sectionEl.querySelector('[data-mull-group="strike"]').hidden = r.mullStrike === 0;

      // Lock prep rows: deadbolt rows only for double bore, latch rows for
      // single or double, the "none" row only when there's no bore.
      sectionEl.querySelectorAll('[data-panel="installer"] [data-row]').forEach(function (row) {
        var kind = row.getAttribute('data-row');
        row.hidden = kind === 'deadbolt' ? !r.hasDeadbolt
                   : kind === 'latch' ? !r.hasLatch
                   : kind === 'nobore' ? r.hasLatch
                   : kind === 'legHinge' ? !r.legHinge
                   : kind === 'noLegHinge' ? r.legHinge
                   : false;
      });
      sectionEl.querySelector('[data-group="bore-spacing"]').style.display = r.hasDeadbolt ? '' : 'none';

      // Advanced settings: placeholders show the standard value each blank
      // override falls back to; hide fields that don't apply.
      sectionEl.querySelectorAll('[data-auto]').forEach(function (el) {
        var v = r.std[el.getAttribute('data-auto')];
        el.placeholder = typeof v === 'number' ? formatFractionalInput(v) : '';
      });
      // Hinge override fields: clamp (on blur) so every hinge keeps 4" of
      // slab above and below it.
      ['hinge2', 'hinge3', 'hinge4'].forEach(function (k) {
        var el = sectionEl.querySelector('[data-input="' + k + '"]');
        el.setAttribute('data-min', HINGE_EDGE_MIN);
        el.setAttribute('data-max', i.slabH - HINGE_EDGE_MIN - i.hingeSize);
      });
      var showAdv = function (key, on) {
        sectionEl.querySelectorAll('[data-group="' + key + '"]').forEach(function (el) {
          el.style.display = on ? '' : 'none';
        });
      };
      setStdOption(sectionEl, 'hingeCount', i.hingeCountStd, 'Standard (' + i.hingeCountStd + ')');
      setStdOption(sectionEl, 'backset', i.backsetStd, 'Standard (' + toFraction(i.backsetStd).replace('"', '') + ')');
      sectionEl.querySelector('[data-input="jambDepthCustom"]').placeholder = formatFractionalInput(i.jambDepthPreset);
      showAdv('hinge3', i.hingeCount >= 3);
      showAdv('hinge4', i.hingeCount === 4);
      showAdv('bore-placement', r.hasLatch);
      showAdv('mull-settings', r.mullCount > 0);
      sectionEl.querySelector('[data-adv-active]').hidden =
        !hasCustomAdvanced(i) || !sectionEl.querySelector('[data-adv-body]').hidden;
      sectionEl.querySelector('[data-lockprep-hint]').textContent =
        i.lockPrep === 'double' ? 'Deadbolt bore above the latch bore. Standard for exterior doors.'
        : i.lockPrep === 'single' ? 'Latch bore only, at the standard latch height. No deadbolt.'
        : 'No bore or strike prep on the slab or jamb.';

      // Installer tab — head jamb / threshold / brickmold
      setOut('headJamb', r.headJamb, toFraction16);
      setOut('threshold', r.threshold, toFraction16);
      setOut('bmLegs', r.bmLegs, toFraction16);
      setOut('bmHead', r.bmHead, toFraction16);

      // Show/hide conditional fields
      var slField = sectionEl.querySelector('[data-group="sidelite-width"]');
      slField.style.display = i.numSidelites > 0 ? '' : 'none';
      var thField = sectionEl.querySelector('[data-group="transom-height"]');
      thField.style.display = i.transom === 1 ? '' : 'none';

      // Show/hide Bumper option based on swing; auto-revert to Saddle if invalid combo
      var thresholdSel = sectionEl.querySelector('[data-input="threshold"]');
      var bumperOpt = thresholdSel.querySelector('[data-outswing-only]');
      var lowOpt = thresholdSel.querySelector('[data-inswing-only]');
      var outswing = i.swing === 'Outswing';
      if ((outswing && thresholdSel.value === 'Low profile') || (!outswing && thresholdSel.value === 'Bumper')) {
        thresholdSel.value = 'Saddle';
        i.threshold = 'Saddle';
      }
      bumperOpt.hidden = bumperOpt.disabled = !outswing;
      if (lowOpt) lowOpt.hidden = lowOpt.disabled = outswing;

      // Sidelite dropdown: when there's at least one door, expose the
      // "1 (left side)" and "1 (right side)" options. With no doors there's
      // no door to position the sidelite next to, so use the plain "1".
      // Migrate the currently-selected value to remain valid in either mode.
      var slSel = sectionEl.querySelector('[data-input="numSidelites"]');
      var doored = slSel.querySelectorAll('[data-sidelites-doored]');
      var nodoor = slSel.querySelector('[data-sidelites-nodoor]');
      var requiresDoors = slSel.querySelectorAll('[data-sidelites-requires-doors]');
      var hasDoors = i.numDoors > 0;
      doored.forEach(function (opt) { opt.hidden = !hasDoors; opt.disabled = !hasDoors; });
      if (nodoor) { nodoor.hidden = hasDoors; nodoor.disabled = hasDoors; }
      // "None" and "2 sidelites" only make sense with at least one door:
      // no door + no sidelite is empty, and two adjacent sidelites would
      // just collapse to one wider glass panel.
      requiresDoors.forEach(function (opt) { opt.hidden = !hasDoors; opt.disabled = !hasDoors; });
      // Migrate selection if it doesn't match the current mode. With no
      // door the only valid choice is one sidelite, so "None" is hidden and
      // the unit becomes a single sidelite; the doored choice is remembered
      // and restored when a door is added back.
      var current = slSel.value;
      var migrated = false;
      if (hasDoors && current === '1') {
        var before = sectionEl._slBeforeNoDoor;
        if (before) {
          slSel.value = before;
        } else {
          // Default to the strike side of the active door (legacy behavior).
          var strikeOnLeft = !((activeHingeSide(i.handing, i.swing)) === 'L');
          slSel.value = strikeOnLeft ? '1L' : '1R';
        }
        sectionEl._slBeforeNoDoor = null;
        migrated = true;
      } else if (!hasDoors && current !== '1') {
        sectionEl._slBeforeNoDoor = current;
        slSel.value = '1';
        migrated = true;
      }
      // Outputs above were computed from the old selection; redo the pass.
      if (migrated) { render(); return; }

      // Handing dropdown: swap labels based on number of doors. For 2 doors,
      // use the astragal-based convention (Left Hand Astragal / Right Hand
      // Astragal), which is the industry order term. For 0 or 1 door, use the
      // conventional hinge-side label.
      var handingSel = sectionEl.querySelector('[data-input="handing"]');
      var handingLabel = sectionEl.querySelector('[data-handing-label]');
      var handingHint = sectionEl.querySelector('[data-handing-hint]');
      var isAstragalMode = i.numDoors === 2;
      handingSel.querySelectorAll('option').forEach(function (opt) {
        opt.textContent = isAstragalMode
          ? opt.getAttribute('data-label-double')
          : opt.getAttribute('data-label-single');
      });
      if (isAstragalMode) {
        handingLabel.textContent = 'Active door handing & swing';
        handingHint.textContent = 'Astragal handing matches the swing of the active door. The astragal attaches to the passive door.';
      } else {
        handingLabel.textContent = 'Handing & swing';
        handingHint.textContent = '';
      }

      // Warnings
      renderFit(sectionEl, i);
      if (i.sizeMode === 'ro' && i.numDoors === 0) slField.style.display = 'none';
      renderDoorInfo(i);
      renderCuts(i);
      renderCutSpec(i);
      renderItemList(sectionEl, itemRows(i, r));
      syncChoices(sectionEl);
      renderMessages(sectionEl, 'dsc', validate(i));
      setSummary(sectionEl, summaryText(i), stickyText(r));
      // Hinge prep choice only applies to a slab (or loose components).
      sectionEl.querySelectorAll('[data-group="hinge-prep"]').forEach(function (el) {
        el.style.display = (i.ship === 'slab' || i.ship === 'components') && (sectionEl._calcKey !== 'ext' || i.numDoors > 0) ? '' : 'none';
      });
      renderServices(sectionEl, '', serviceLines(i, r), shareUrl(sectionEl, sectionEl._calcKey));

      // Hide hinge rows that don't exist for the chosen hinge count.
      ['slab', 'jamb', 'mull'].forEach(function (pre) {
        [2, 3, 4].forEach(function (n) {
          var el = sectionEl.querySelector('[data-out="' + pre + n + '"]');
          if (!el) return;
          var li = el.closest('li'), na = r[pre + n] === 'na';
          // Rows with data-row were already shown/hidden for other reasons.
          li.hidden = li.hasAttribute('data-row') ? (li.hidden || na) : na;
        });
      });

      // Drawing (elevation + plan)
      drawElevation(i, r, sectionEl._dscShowBm === true);
      drawPlan(i, r, sectionEl._dscShowBm === true);

      // Store last result for print/email
      sectionEl._dscLast = { i: i, r: r };
    }

    // ---- Tabs ----
    sectionEl.querySelectorAll('.pease-dsc__tab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        sectionEl.querySelectorAll('.pease-dsc__tab').forEach(function (b) {
          b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false');
        });
        sectionEl.querySelectorAll('.pease-dsc__tabpanel').forEach(function (p) {
          p.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        sectionEl.querySelector('[data-panel="' + btn.dataset.tab + '"]').classList.add('is-active');
      });
    });

    // ---- Glass & cutouts: collapsed until opened (the flush-door list is long) ----
    var cutToggle = sectionEl.querySelector('[data-cut-toggle]');
    var cutBody = sectionEl.querySelector('[data-cut-body]');
    if (cutToggle) cutToggle.addEventListener('click', function () {
      var open = cutBody.hidden;
      cutBody.hidden = !open;
      cutToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      render();
    });
    var scutToggle = sectionEl.querySelector('[data-scut-toggle]');
    var scutBody = sectionEl.querySelector('[data-scut-body]');
    if (scutToggle) scutToggle.addEventListener('click', function () {
      var open = scutBody.hidden;
      scutBody.hidden = !open;
      scutToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      render();
    });

    // ---- Advanced settings toggle + reset ----
    var advToggle = sectionEl.querySelector('[data-adv-toggle]');
    var advBody = sectionEl.querySelector('[data-adv-body]');
    advToggle.addEventListener('click', function () {
      var open = advBody.hidden;
      advBody.hidden = !open;
      advToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      render();
    });
    sectionEl.querySelector('[data-adv-reset]').addEventListener('click', function () {
      advBody.querySelectorAll('[data-input]').forEach(function (el) {
        if (el.tagName === 'SELECT') {
          Array.prototype.forEach.call(el.options, function (o) { o.selected = o.defaultSelected; });
        } else {
          el.value = '';
        }
        el.removeAttribute('data-last-good');
      });
      render();
    });

    // ---- Shop services: collapsed by default (most customers won't need them) ----
    var svcToggle = sectionEl.querySelector('[data-svc-toggle]');
    var svcBody = sectionEl.querySelector('[data-svc-body]');
    if (svcToggle) svcToggle.addEventListener('click', function () {
      var open = svcBody.hidden;
      svcBody.hidden = !open;
      svcToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // ---- Reset: every input back to its default, sections closed, first tab ----
    var resetAll = sectionEl.querySelector('[data-action="reset-all"]');
    if (resetAll) resetAll.addEventListener('click', function () {
      sectionEl.querySelectorAll('[data-input]').forEach(function (el) {
        if (el.tagName === 'SELECT') {
          Array.prototype.forEach.call(el.options, function (o) { o.selected = o.defaultSelected; });
        } else {
          el.value = el.defaultValue || '';
        }
        el.removeAttribute('data-last-good');
      });
      sectionEl.querySelectorAll('[data-adv-body], [data-cut-body], [data-scut-body], [data-svc-body]').forEach(function (b) { b.hidden = true; });
      sectionEl.querySelectorAll('[data-adv-toggle], [data-cut-toggle], [data-scut-toggle], [data-svc-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      var firstTab = sectionEl.querySelector('[data-tab="buyer"]');
      if (firstTab) firstTab.click();
      // Drop a shared setup from the address bar so a reload doesn't bring it back.
      if (/calc=/.test(location.hash)) history.replaceState(null, '', location.pathname + location.search);
      render();
    });

    // ---- Brickmold toggle (drawing) ----
    sectionEl._dscShowBm = false;
    sectionEl.querySelectorAll('.pease-dsc__bm-toggle button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        sectionEl.querySelectorAll('.pease-dsc__bm-toggle button').forEach(function (b) {
          b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        sectionEl._dscShowBm = btn.dataset.bm === '1';
        render();
      });
    });

    // ---- Input listeners ----
    sectionEl.querySelectorAll('[data-input]').forEach(function (el) {
      var isFrac = el.getAttribute('data-fractional') === 'true';
      if (isFrac) {
        // Live recalc as the user types, but only when the value parses
        // cleanly. Empty fields fall through to data-default in getInputs(),
        // so clearing also re-renders at the default.
        el.addEventListener('input', function () {
          var raw = el.value.trim();
          if (!raw) { render(); return; }
          var n = parseFractional(raw);
          if (!isNaN(n)) render();
        });
        // On blur: parse, snap to 1/16", clamp, rewrite in canonical form.
        // Empty stays empty so the placeholder reappears. If the snapped
        // value matches the field's default, clear the field so the
        // placeholder shows the default instead of duplicating it.
        el.addEventListener('blur', function () {
          var raw = el.value.trim();
          if (!raw) { render(); return; }
          var n = parseFractional(raw);
          if (isNaN(n)) {
            var last = el.getAttribute('data-last-good');
            el.value = last ? last : '';
          } else {
            var snapped = snapAndClamp(n, el);
            // Always keep the typed value visible in dark text — even when
            // it matches the default. The placeholder is only for genuinely
            // empty fields.
            el.value = formatFractionalInput(snapped);
            el.setAttribute('data-last-good', el.value);
          }
          render();
        });
      } else {
        el.addEventListener('input', render);
        el.addEventListener('change', render);
      }
    });

    // ---- Print ----
    function buildPrintHTML() {
      var d = sectionEl._dscLast;
      if (!d) return '';
      var i = d.i, r = d.r;
      var row = function (label, val) {
        if (val === 'na') return '';
        return '<tr><td>' + label + '</td><td>' + toFraction(val) + '</td></tr>';
      };
      var row16 = function (label, val) {
        return '<tr><td>' + label + '</td><td>' + toFraction16(val) + '</td></tr>';
      };
      var inputRow = function (label, val) {
        return '<tr><td>' + label + '</td><td>' + val + '</td></tr>';
      };
      // Strike prep rows for a leg jamb (prefix '') or a mull (prefix 'mull'),
      // filtered by the selected lock prep.
      var strikeRows = function (prefix, r) {
        var k = function (name) {
          return prefix ? prefix + name.charAt(0).toUpperCase() + name.slice(1) : name;
        };
        if (!r.hasLatch) return inputRow('Strike prep', 'None (no bore)');
        return (r.hasDeadbolt
            ? row('Deadbolt strike mortise — top', r[k('dbMortTop')]) +
              row('Deadbolt strike bore center', r[k('dbStrike')]) +
              row('Deadbolt strike mortise — bottom', r[k('dbMortBot')])
            : '') +
          row('Latch strike mortise — top', r[k('latchMortTop')]) +
          row('Latch strike bore center', r[k('latchStrike')]) +
          row('Latch strike mortise — bottom', r[k('latchMortBot')]);
      };

      // Visual references — clone the currently-rendered elevation and plan
      // SVGs. The drawings already reflect the active brickmold toggle state
      // (they're re-rendered whenever the toggle flips), so cloning gives us
      // the correct one-or-the-other view without needing to re-generate.
      var activeBmBtn = sectionEl.querySelector('.pease-dsc__bm-toggle button.is-active');
      var bmLabel = (activeBmBtn && activeBmBtn.textContent) ? activeBmBtn.textContent.trim() : '';
      var elevSvg = sectionEl.querySelector('[data-drawing="elevation"]');
      var planSvg = sectionEl.querySelector('[data-drawing="plan"]');
      var cloneSvgHtml = function (svg) {
        if (!svg) return '';
        var clone = svg.cloneNode(true);
        // Remove any fixed width/height that would block print-scaling; the
        // SVG's own viewBox handles aspect ratio.
        clone.removeAttribute('width');
        clone.removeAttribute('height');
        clone.setAttribute('style', 'width:100%;height:auto;max-height:4.5in;');
        return clone.outerHTML;
      };
      var visualSection =
        '<h2>Visual reference' + (bmLabel ? ' — ' + bmLabel : '') + '</h2>' +
        '<div class="pease-dsc-print-visuals">' +
          '<div class="pease-dsc-print-visual">' +
            '<div class="pease-dsc-print-visual-label">Elevation (exterior)</div>' +
            cloneSvgHtml(elevSvg) +
          '</div>' +
          '<div class="pease-dsc-print-visual">' +
            '<div class="pease-dsc-print-visual-label">Plan (top view)</div>' +
            cloneSvgHtml(planSvg) +
          '</div>' +
        '</div>';

      return '<div class="pease-dsc-print-root">' +
        '<h1>Pease Doors — Door System Spec Sheet</h1>' +
        '<p>' + summaryText(i) + '</p>' +
        '<p>Open this setup: ' + shareUrl(sectionEl, 'ext').replace(/&/g, '&amp;') + '</p>' +
        '<h2>Shop services</h2>' + sectionEl.querySelector('[data-svc-table]').outerHTML +
        sectionEl.querySelector('[data-svc-notes]').outerHTML +
        '<p>Generated ' + new Date().toLocaleString() + '</p>' +
        visualSection +
        '<h2>Configuration</h2><table>' +
          inputRow('Slab width', toFraction(i.slabW)) +
          inputRow('Slab height', toFraction(i.slabH)) +
          inputRow('Handing', i.handing) +
          inputRow('Swing', i.swing) +
          inputRow('Threshold', i.threshold) +
          inputRow('Number of doors', i.numDoors) +
          inputRow('Number of sidelites', i.numSidelites) +
          (i.numSidelites > 0 ? inputRow('Sidelite width', toFraction(i.sideliteW)) : '') +
          inputRow('Transom', i.transom === 1 ? 'Yes' : 'No') +
          (i.transom === 1 ? inputRow('Transom height', toFraction(i.transomH)) : '') +
          inputRow('Hinge size', i.hingeSize + '"') +
          inputRow('Hinge count', i.hingeCount) +
          inputRow('First hinge offset', toFraction(i.firstHingeOffset)) +
          inputRow('Hinge placement', customHinges(i) ? 'Custom (see below)' : 'Standard') +
          inputRow('Lock prep', LOCK_PREP_LABELS[i.lockPrep]) +
          (r.hasLatch ? inputRow('Bore placement', i.latchBoreTop !== null ? 'Custom (see below)' : 'Standard') : '') +
          (r.hasDeadbolt ? inputRow('Bore spacing', toFraction16(i.boreSpacing)) : '') +
          (r.hasLatch ? inputRow('Backset', toFraction(i.backset)) : '') +
          inputRow('Jamb depth', toFraction16(i.jambDepth)) +
        '</table>' +
        '<h2>Unit size (w/o brickmold)</h2><table>' +
          row16('Width', r.unitW) + row16('Height', r.unitH) + row16('Depth', r.unitD) +
        '</table>' +
        '<h2>Unit size (with brickmold)</h2><table>' +
          row16('Width', r.unitBmW) + row16('Height', r.unitBmH) + row16('Depth', r.unitBmD) +
        '</table>' +
        '<h2>Rough opening</h2><table>' +
          '<tr><td>Width (min)</td><td>' + toFraction16(r.roWmin) + '</td></tr>' +
          '<tr><td>Width (max)</td><td>' + toFraction16(r.roWmax) + '</td></tr>' +
          '<tr><td>Height (min)</td><td>' + toFraction16(r.roHmin) + '</td></tr>' +
          '<tr><td>Height (max)</td><td>' + toFraction16(r.roHmax) + '</td></tr>' +
          '<tr><td>Depth (min)</td><td>' + toFraction16(r.roDmin) + '</td></tr>' +
          '<tr><td>Depth (max)</td><td>' + toFraction16(r.roDmax) + '</td></tr>' +
        '</table>' +
        '<h2>Slab — hinge positions (from top of door)</h2><table>' +
          row('1st hinge', r.slab1) + row('2nd hinge', r.slab2) +
          row('3rd hinge', r.slab3) + row('4th hinge', r.slab4) +
          inputRow('Lock prep', LOCK_PREP_LABELS[i.lockPrep]) +
          (r.hasDeadbolt ? row('Deadbolt bore center', r.deadboltBore) : '') +
          (r.hasLatch ? row('Latch bore center', r.latchBore) : '') +
          (r.hasDeadbolt ? row16('Bore spacing (center to center)', i.boreSpacing) : '') +
          (r.hasLatch ? row('Backset (strike edge to bore center)', i.backset) : '') +
        '</table>' +
        '<h2>' + (r.legHinge ? 'Hinge jamb' : 'Leg jambs') + ' (from top of jamb)</h2><table>' +
          row16('Jamb height', r.jambHt) +
          (r.legHinge
            ? row('1st hinge', r.jamb1) + row('2nd hinge', r.jamb2) +
              row('3rd hinge', r.jamb3) + row('4th hinge', r.jamb4)
            : inputRow('Hinge prep', 'On the mull post')) +
        '</table>' +
        (r.legStrike
          ? '<h2>Strike jamb (from top of jamb)</h2><table>' + strikeRows('', r) + '</table>'
          : '') +
        (r.mullCount > 0
          ? '<h2>Mull post prep (from top of mull)</h2>' +
            '<p>A mull post fits into a mortise in the head jamb and sits on the threshold sill deck. Its top is ' + toFraction16(i.mullHeadDrop).replace(/"/g, '&quot;') + ' below the top of the leg jambs, so every mull prep location is that much less than the matching leg jamb measurement.</p>' +
            '<table>' +
              row16('Mull post height', r.mullHt) +
              row16('Head jamb mortise drop', i.mullHeadDrop) +
              row16('Sill deck height', i.mullSillDeck) +
              (r.mullHinge > 0
                ? inputRow('<strong>' + (r.mullHinge > 1 ? r.mullHinge + ' hinge-side mulls' : 'Hinge-side mull') + '</strong>', '') +
                  row('1st hinge', r.mull1) + row('2nd hinge', r.mull2) +
                  row('3rd hinge', r.mull3) + row('4th hinge', r.mull4)
                : '') +
              (r.mullStrike > 0
                ? inputRow('<strong>' + (r.mullStrike > 1 ? r.mullStrike + ' strike-side mulls' : 'Strike-side mull') + '</strong>', '') +
                  strikeRows('mull', r)
                : '') +
            '</table>'
          : '') +
        '<h2>Head jamb, threshold &amp; brickmold</h2><table>' +
          row16('Head jamb width', r.headJamb) +
          row16('Threshold width', r.threshold) +
          row16('Brickmold leg length', r.bmLegs) +
          row16('Brickmold head width', r.bmHead) +
        '</table>' +
      '</div>';
    }

    sectionEl.querySelector('[data-action="print"]').addEventListener('click', function () {
      var existing = document.querySelector('.pease-dsc-print-root');
      if (existing) existing.remove();
      var host = document.createElement('div');
      host.innerHTML = buildPrintHTML();
      document.body.appendChild(host.firstChild);
      window.print();
      setTimeout(function () {
        var n = document.querySelector('.pease-dsc-print-root');
        if (n) n.remove();
      }, 500);
    });

    // ---- Lead capture modal ----
    // Uses Shopify's built-in contact form (rendered via Liquid's form tag
    // with 'contact' as the type) to capture leads. The form submits natively
    // to Shopify's contact endpoint; Shopify sends the notification to the
    // store's Sender email (set to info@peasedoors.com in Shopify admin →
    // Settings → Notifications).
    var modal = sectionEl.querySelector('[data-modal]');
    var leadForm = sectionEl.querySelector('#pease-dsc-lead-form');
    var formTemplate = sectionEl.querySelector('[data-form-template]');

    // Swap the current form contents with a fresh copy from the template.
    // Used when the user clicks "Send to Pease" again after a successful
    // submit in the same session — we want them to see a blank form, not
    // the post-success confirmation, so they can submit fresh details.
    function resetFormState() {
      if (!leadForm || !formTemplate) return;
      // Only swap if the form is currently in the success state.
      if (!leadForm.querySelector('[data-form-success]')) return;
      leadForm.innerHTML = '';
      leadForm.appendChild(formTemplate.content.cloneNode(true));
      // Rebind modal-close handlers on the freshly injected Cancel button
      // (the form-template is the Liquid-rendered template, so it ships with
      // markup but no event listeners).
      bindCloseButtons();
    }

    function openModal() {
      resetFormState();
      modal.hidden = false;
      var msg = leadForm ? leadForm.querySelector('[data-modal-msg]') : null;
      if (msg) {
        msg.textContent = '';
        msg.classList.remove('is-ok', 'is-err');
      }
      setTimeout(function () {
        var input = sectionEl.querySelector('[data-email-input]');
        if (input) input.focus();
      }, 50);
    }
    function closeModal() { modal.hidden = true; }

    // Bind close handlers to every [data-modal-close] button currently in
    // the DOM. Called both initially and after form-state swaps.
    function bindCloseButtons() {
      sectionEl.querySelectorAll('[data-modal-close]').forEach(function (b) {
        if (!b.dataset.dscBound) {
          b.addEventListener('click', closeModal);
          b.dataset.dscBound = '1';
        }
      });
    }

    sectionEl.querySelector('[data-action="email"]').addEventListener('click', openModal);
    bindCloseButtons();
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    // Build the body text (shown in the notification email) from the current
    // calculator state. Called just before form submission.
    function buildBody() {
      var d = sectionEl._dscLast;
      if (!d) return 'No calculator data available.';
      var i = d.i, r = d.r;
      var lines = [];
      lines.push('Pease Doors — Door System Calculator lead');
      lines.push('Generated: ' + new Date().toLocaleString());
      lines.push('Source: ' + window.location.href);
      lines.push('Open this setup: ' + shareUrl(sectionEl, 'ext'));
      if (i.sizeMode === 'ro') lines.push('Sized from a rough opening of ' + toFraction(i.roW) + ' x ' + toFraction(i.roH));
      lines.push('');
      // Customer notes first so they're the first thing the team reads.
      var notesEl = sectionEl.querySelector('[data-notes-input]');
      var notes = notesEl ? notesEl.value.trim() : '';
      if (notes) {
        lines.push('=== CUSTOMER NOTES ===');
        lines.push(notes);
        lines.push('');
      }
      draftOrderText(i, r).forEach(function (t) { lines.push(t); });
      lines.push('');
      lines.push('=== CONFIGURATION ===');
      lines.push('Slab: ' + toFraction(i.slabW) + ' W x ' + toFraction(i.slabH) + ' H');
      lines.push('Handing: ' + i.handing);
      lines.push('Swing: ' + i.swing);
      lines.push('Threshold: ' + i.threshold);
      lines.push('Doors: ' + i.numDoors + '   Sidelites: ' + i.numSidelites);
      if (i.numSidelites > 0) lines.push('Sidelite width: ' + toFraction(i.sideliteW));
      if (i.transom === 1) lines.push('Transom height: ' + toFraction(i.transomH));
      lines.push('Hinge: ' + i.hingeSize + '" x ' + i.hingeCount + (i.hingeCount !== i.hingeCountStd ? ' (standard is ' + i.hingeCountStd + ')' : ''));
      if (customHinges(i)) lines.push('Hinge placement: CUSTOM');
      lines.push('Lock prep: ' + LOCK_PREP_LABELS[i.lockPrep]);
      if (r.hasLatch && i.latchBoreTop !== null) lines.push('Bore placement: CUSTOM');
      if (r.hasDeadbolt) lines.push('Bore spacing: ' + toFraction16(i.boreSpacing));
      if (r.hasLatch) lines.push('Backset: ' + toFraction(i.backset));
      lines.push('Jamb depth: ' + toFraction16(i.jambDepth));
      lines.push('');
      lines.push('=== UNIT SIZE (w/o brickmold) ===');
      lines.push('W ' + toFraction16(r.unitW) + '  x  H ' + toFraction16(r.unitH) + '  x  D ' + toFraction16(r.unitD));
      lines.push('');
      lines.push('=== UNIT SIZE (with brickmold) ===');
      lines.push('W ' + toFraction16(r.unitBmW) + '  x  H ' + toFraction16(r.unitBmH) + '  x  D ' + toFraction16(r.unitBmD));
      lines.push('');
      lines.push('=== ROUGH OPENING ===');
      lines.push('Width:  ' + toFraction16(r.roWmin) + ' – ' + toFraction16(r.roWmax));
      lines.push('Height: ' + toFraction16(r.roHmin) + ' – ' + toFraction16(r.roHmax));
      lines.push('Depth:  ' + toFraction16(r.roDmin) + ' – ' + toFraction16(r.roDmax));
      lines.push('');
      lines.push('=== SLAB HINGE POSITIONS (from top of door) ===');
      ['slab1','slab2','slab3','slab4'].forEach(function (k, idx) {
        if (r[k] !== 'na') lines.push('Hinge ' + (idx + 1) + ': ' + toFraction(r[k]));
      });
      if (r.hasDeadbolt) lines.push('Deadbolt bore: ' + toFraction(r.deadboltBore));
      if (r.hasLatch) lines.push('Latch bore: ' + toFraction(r.latchBore));
      if (r.mullCount > 0) {
        lines.push('');
        lines.push('=== MULL POST PREP (from top of mull; ' + toFraction16(i.mullHeadDrop) + ' below top of leg jambs) ===');
        lines.push('Mull post height: ' + toFraction16(r.mullHt) +
          ' (head mortise drop ' + toFraction16(i.mullHeadDrop) + ', sill deck ' + toFraction16(i.mullSillDeck) + ')');
        if (r.mullHinge > 0) {
          lines.push('Hinge-side mull' + (r.mullHinge > 1 ? 's (' + r.mullHinge + ')' : '') + ':');
          ['mull1','mull2','mull3','mull4'].forEach(function (k, idx) {
            if (r[k] !== 'na') lines.push('  Hinge ' + (idx + 1) + ': ' + toFraction(r[k]));
          });
        }
        if (r.mullStrike > 0) {
          lines.push('Strike-side mull' + (r.mullStrike > 1 ? 's (' + r.mullStrike + ')' : '') + ':');
          if (r.hasDeadbolt) lines.push('  Deadbolt strike center: ' + toFraction(r.mullDbStrike));
          if (r.hasLatch) lines.push('  Latch strike center: ' + toFraction(r.mullLatchStrike));
          if (!r.hasLatch) lines.push('  No strike prep (no bore)');
        }
      }
      return lines.join('\n');
    }

    // ---- Order handoff: everything CS needs to build the draft order ----
    function draftOrderText(i, r) {
      var res = serviceLines(i, r), out = [], cs = i.cuts || {};
      var d = i.numDoors, sl = i.numSidelites;
      var dash = function (v) { return toFraction16(v).replace('"', '').replace(' ', '-'); };
      out.push('=== DRAFT ORDER (build in this order; properties go on the line) ===');
      if (!i.door && d > 0) out.push('*  Door slab: not picked in the calculator. ' + (d === 2 ? '2 slabs, ' : '') +
        toFraction(i.slabW) + ' x ' + toFraction(i.slabH) + ' finished.');
      res.lines.forEach(function (l, k) {
        var c = SVC[l.sku] || [l.desc || '', 0];
        if (l.desc) c = [l.desc, c[1]];
        out.push((k + 1) + '. ' + l.sku + '  x' + l.qty + '  ' + c[0]);
        Object.keys(l.props || {}).forEach(function (pk) { out.push('     ' + pk + ': ' + l.props[pk]); });
      });
      if (res.orderNotes.length) {
        out.push('');
        out.push('Order notes:');
        res.orderNotes.forEach(function (n) { out.push('- ' + n); });
      }
      // What the calculator doesn't pick: products CS still adds.
      var todo = [];
      var kit = function (c, qty, who) {
        var ks = kitSize(c);
        todo.push('Glass kit for the ' + cutName(c, i.slabH) + ' (' + who + '): frame ' + dash(ks.fw) + ' x ' + dash(ks.fh) +
          ', glass ' + dash(ks.gw) + ' x ' + dash(ks.gh) + (c.n ? ', ' + c.n + ' per door' : c.lay === 'pair' ? ', 2 per door' : '') +
          ', qty ' + qty + (i.door && /HMP|WBD/.test(i.door.build) && who !== 'sidelites' ? ' (impact-rated glass)' : ''));
      };
      if (d > 0 && cs.door && !cs.blocked && cs.door.place.ok) kit(cs.door.c, d, d === 2 ? 'both doors' : 'door');
      if (sl > 0 && cs.side && cs.side.place.ok) kit(cs.side.c, sl, sl === 2 ? 'sidelites' : 'sidelite');
      if (d > 0 && cs.pet && !cs.blocked && cs.pet.place.ok) todo.push('Pet door (' + cutName(cs.pet.c, i.slabH) + '), if the customer is not supplying it; then add ZASY-INSTALL-PET');
      if (sl > 0) todo.push('Sidelite panel' + (sl === 2 ? 's (2)' : '') + ': ' + toFraction(i.sideliteW) + ' x ' + toFraction(i.slabH) +
        (cs.side && cs.side.place.ok ? ', for the ' + cutName(cs.side.c, i.slabH) + ' cutout' : ', flush (no glass)'));
      if (i.ship !== 'slab') {
        todo.push('Jamb set, ' + toFraction16(i.jambDepth) + ' deep: legs ' + toFraction16(r.jambHt) + ', head ' + toFraction16(r.headJamb));
        if (r.mullCount > 0) todo.push('Mull post' + (r.mullCount > 1 ? 's (' + r.mullCount + ')' : '') + ': ' + toFraction16(r.mullHt));
        todo.push('Threshold (' + i.threshold + '): ' + toFraction16(r.threshold) + ' wide');
        todo.push('Brickmold: legs ' + toFraction16(r.bmLegs) + ', head ' + toFraction16(r.bmHead));
        if (i.ship === 'components') todo.push('Framing cuts if we cut the parts to length: ZCUT-FRAMING-1, then ZCUT-FRAMING-2 per extra cut');
      }
      if (d > 0 && r.hasLatch) todo.push('Lockset' + (r.hasDeadbolt ? ' and deadbolt' : '') + ' (' + toFraction(i.backset) + ' backset)');
      todo.push('Finish, if wanted: ZFIN-* labor with a Color property, plus paint/stain and primer quarts');
      out.push('');
      out.push('Still to add (not picked in the calculator):');
      todo.forEach(function (t) { out.push('- ' + t); });
      // Glass kit and pet door notes are already in the list above.
      var shopNotes = res.notes.filter(function (n) { return !/^Glass kits are separate|^The customer supplies the pet door/.test(n); });
      if (shopNotes.length) {
        out.push('');
        out.push('Shop notes:');
        shopNotes.forEach(function (n) { out.push('- ' + n); });
      }
      return out;
    }

    // Populate the hidden contact[body] field right before Shopify submission.
    if (leadForm) {
      leadForm.addEventListener('submit', function () {
        var bodyField = sectionEl.querySelector('[data-form-body]');
        if (bodyField) bodyField.value = buildBody();
      });
    }

    // If the page was loaded with a successful form post (Shopify appends
    // ?contact_posted=true and the Liquid branch renders the success message),
    // open the modal so the user sees the confirmation rather than a blank
    // section. Use openModal WITHOUT the reset, since we want them to see
    // the thank-you state they just triggered.
    var successOnLoad = leadForm && leadForm.querySelector('[data-form-success]');
    if (successOnLoad) {
      modal.hidden = false;
    }

    // Initial render
    render();
    });

    // ---- idc ----
    document.querySelectorAll('.pease-idc').forEach(function (sectionEl) {
    if (!sectionEl || sectionEl.dataset.initialized) return;
    sectionEl.dataset.initialized = '1';
    wireChoices(sectionEl);
    var sizeByOpening = roSizer(sectionEl, function (t) { return calculate(t); }, {
      widthKey: function () { return 'slabW'; },
      std: { slabW: [18, 24, 28, 30, 32, 34, 36], slabH: [80, 84, 96] },
      range: { slabW: [10, 48], slabH: [60, 100] }
    });
    if (applyShare(sectionEl, 'int')) {
      var shellEl = sectionEl.closest('.pease-calc-shell');
      var intTab = shellEl && shellEl.querySelector('[data-calc-tab="interior"]');
      if (intTab) intTab.click();
    }
    sectionEl._calcKey = 'int';
    wireShare(sectionEl, 'int');
    wireServices(sectionEl);
    wireSticky(sectionEl, 'idc');
    // Drawing shortcut: click the door (front or top view) to flip handing.
    sectionEl.querySelectorAll('[data-drawing]').forEach(function (svg) {
      svg.addEventListener('click', function (e) {
        if (!e.target.closest('[data-draw-action="flip-handing"]')) return;
        var sel = sectionEl.querySelector('[data-input="handing"]');
        sel.value = sel.value === 'Left' ? 'Right' : 'Left';
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // ---- Fraction formatter (inches, nearest 1/8" by default) ----
    function toFraction(v, den) {
      if (v === null || v === undefined || v === 'na' || (typeof v === 'number' && !isFinite(v))) return 'n/a';
      if (typeof v !== 'number') return v;
      den = den || 8;
      var sign = v < 0 ? '-' : '';
      v = Math.abs(v);
      var whole = Math.floor(v);
      var frac = v - whole;
      var numer = Math.round(frac * den);
      if (numer === den) { whole += 1; numer = 0; }
      if (numer === 0) return sign + whole + '"';
      while (numer % 2 === 0) { numer /= 2; den /= 2; }
      return sign + (whole > 0 ? whole + ' ' : '') + numer + '/' + den + '"';
    }
    // 1/16" precision helper for depths that fall on 16ths.
    function toFraction16(v) { return toFraction(v, 16); }
    // Round to nearest 1/8"
    function r8(v) { return Math.round(v * 8) / 8; }
    // Round to nearest 1/16" — used as the canonical input snap.
    function r16(v) { return Math.round(v * 16) / 16; }

    // ---- Fractional input parsing ----
    // Accepts: "33", "33.5", "33.5625",
    //          "33 9/16", "33-9/16",  (whole + space/dash + fraction)
    //          "9/16",                 (pure fraction)
    //          and tolerates a trailing inch mark.
    // Returns NaN if it can't parse.
    function parseFractional(raw) {
      if (raw === null || raw === undefined) return NaN;
      var s = String(raw).trim();
      if (!s) return NaN;
      // Strip a trailing inch mark or quote
      s = s.replace(/["”]$/, '').trim();
      // Pure decimal or integer
      if (/^-?\d+(\.\d+)?$/.test(s)) return parseFloat(s);
      // Pure fraction: n/d
      var pure = s.match(/^(\d+)\s*\/\s*(\d+)$/);
      if (pure) {
        var d1 = parseInt(pure[2], 10);
        return d1 === 0 ? NaN : parseInt(pure[1], 10) / d1;
      }
      // Whole + fraction with space or dash: w n/d  or  w-n/d
      var mixed = s.match(/^(\d+)(?:\s+|-)(\d+)\s*\/\s*(\d+)$/);
      if (mixed) {
        var d2 = parseInt(mixed[3], 10);
        return d2 === 0 ? NaN : parseInt(mixed[1], 10) + parseInt(mixed[2], 10) / d2;
      }
      return NaN;
    }

    // Snap to nearest 1/16" and clamp to [min, max] from the input's data-*
    // attributes. Returns the clamped numeric value.
    function snapAndClamp(value, el) {
      var snapped = r16(value);
      var min = parseFloat(el.getAttribute('data-min'));
      var max = parseFloat(el.getAttribute('data-max'));
      if (!isNaN(min) && snapped < min) snapped = r16(min);
      if (!isNaN(max) && snapped > max) snapped = r16(max);
      return snapped;
    }

    // Canonical input display: like toFraction16 but without the inch mark,
    // so users see "33 9/16" (matches what they would type).
    function formatFractionalInput(v) {
      return toFraction16(v).replace(/["”]$/, '');
    }

    // ---- Input gathering ----
    function getInputs() {
      var g = function (k) { return sectionEl.querySelector('[data-input="' + k + '"]'); };
      // num() reads a numeric input. For fractional text inputs it parses
      // the fraction string; for dropdowns/decimal inputs it parseFloat's.
      // Empty fractional fields fall back to the field's data-default so
      // the placeholder ghost-text acts as the working default.
      var num = function (k) {
        var el = g(k);
        if (el.getAttribute('data-fractional') === 'true') {
          var raw = el.value.trim();
          if (!raw) {
            // Empty → use the default the placeholder is advertising
            var def = el.getAttribute('data-default');
            var dn = parseFractional(def);
            return isNaN(dn) ? 0 : dn;
          }
          var n = parseFractional(raw);
          return isNaN(n) ? 0 : n;
        }
        return parseFloat(el.value) || 0;
      };
      // numOpt() reads an optional override (Advanced settings): blank or
      // unparseable means "use the standard value" and returns null.
      var numOpt = function (k) {
        var n = parseFractional(g(k).value.trim());
        return isNaN(n) ? null : n;
      };
      var str = function (k) { return g(k).value; };
      return {
        config: str('config'),                  // 'single' | 'double-fixed-astragal' | 'double-floating-astragal' | 'double-ballcatch'
        slabW: num('slabW'),
        slabH: num('slabH'),
        slabThk: num('slabThk'),
        handing: str('handing'),
        hingeSize: num('hingeSize'),
        // "auto" = the Shop Services Guide standard for this door size
        hingeCount: str('hingeCount') === 'auto' ? stdHingeCount(num('slabH')) : parseInt(str('hingeCount'), 10),
        hingeCountStd: stdHingeCount(num('slabH')),
        firstHingeOffset: num('firstHingeOffset'),
        hinge2: numOpt('hinge2'),               // Advanced overrides (null = standard)
        hinge3: numOpt('hinge3'),
        hinge4: numOpt('hinge4'),
        lockPrep: str('lockPrep'),              // 'single' | 'double' | 'none'
        boreSpacing: num('boreSpacing'),        // deadbolt-to-latch, center to center
        boreFromBottom: num('boreFromBottom'),
        backset: str('backset') === 'auto' ? stdBackset(num('slabW')) : parseFloat(str('backset')),
        backsetStd: stdBackset(num('slabW')),
        jambThickness: num('jambThickness'),
        jambDepthPreset: parseFloat(str('jambDepthPreset')),
        // Interior jambs are double-rabbeted and can't be ripped: 4 9/16" or 6 9/16" only.
        jambDepth: parseFloat(str('jambDepthPreset')),
        sizeMode: str('sizeMode'),              // 'slab' | 'ro' (size by rough opening)
        roW: num('roW'),
        roH: num('roH'),
        ship: str('ship'),                      // 'prehung' | 'kit' | 'slab' | 'components'
        hingePrep: str('hingePrep'),            // slab/components only: 'yes' | 'no'
        floorClearance: num('floorClearance')
      };
    }

    // Standard values for the Advanced settings, used to flag custom setups.
    function customHinges(i) {
      return i.hinge2 !== null || (i.hingeCount >= 3 && i.hinge3 !== null)
        || (i.hingeCount === 4 && i.hinge4 !== null)
        || i.hingeCount !== i.hingeCountStd
        || Math.abs(i.hingeSize - 3.5) > 1e-9
        || Math.abs(i.firstHingeOffset - 7) > 1e-9;
    }
    function customBore(i) {
      return boreOn(i) && Math.abs(i.boreFromBottom - 36) > 1e-9;
    }
    function hasCustomAdvanced(i) {
      return customHinges(i) || customBore(i)
        || (boreOn(i) && i.backset !== i.backsetStd)
        || (deadboltOn(i) && Math.abs(i.boreSpacing - 5.5) > 1e-9)
        || Math.abs(i.jambThickness - 0.6875) > 1e-9
        || Math.abs(i.floorClearance - 0.875) > 1e-9;
    }
    // Shop Services Guide standards: hinges 3, or 4 above 84 1/2". Interior
    // backset is always 2 3/8" regardless of width (long/short is an
    // explicit choice, not a width-based default as on exterior doors).
    function stdHingeCount(slabH) { return slabH > 84.5 ? 4 : 3; }
    // Minimum slab above the top hinge and below the bottom hinge.
    var HINGE_EDGE_MIN = 4;
    function stdBackset() { return 2.375; }

    // ---- Constants (interior-specific) ----
    // Interior assemblies do not have a threshold or brickmold. The jamb's
    // top extension above the slab is the top air gap (1/8") plus the head
    // jamb thickness (now a user input). The bottom extension is the user's
    // floor clearance value (slab is shorter than the opening by this amount
    // so it can swing over finished flooring/carpet).
    //
    // SIDE GAPS (Pease spec): the head jamb is sized so the hung slab has a
    // tight 1/16" reveal on the hinge side (the pivot, where the gap barely
    // changes through the swing) and a wider 1/8" reveal on the strike side
    // (to clear the swing diagonal and seasonal movement). Head jamb width =
    // slab width + 1/16" + 1/8" = slab width + 3/16".
    var C = {
      topAirGap: 0.1875,          // air gap between top of slab and bottom of head jamb (3/16")
      hingeSideGap: 0.0625,       // reveal on the hinge side of the slab (1/16")
      strikeSideGap: 0.125,       // reveal on the strike/lock side of the slab (1/8")
      hingeMortDepth: 0.125,      // hinge leaf mortised flush ~ 1/8" into jamb edge
      hingeJambEdgeOff: 0.25,     // hinge leaf typically set back 1/4" from jamb stop face (visual)
      latchMortLen: 2.25,         // strike mortise length (2 1/4")
      // ---- Hinge & strike mortise width into the jamb edge ----
      // Pease interior jambs are double-rabbeted: a single stock with the
      // stop built into each face. The "thin" face is meant for 1 3/8"
      // doors and places the stop 1 7/16" (1.4375") in from the jamb edge.
      // The "thick" face is meant for 1 3/4" doors and places the stop
      // 1 13/16" (1.8125") in. Both hinge and strike mortises sit at a
      // fixed 1/4" clearance from the stop, so the mortise width equals
      // (stop offset - 1/4"):
      //   1 3/8" door → 1.4375" - 0.25" = 1.1875"  (1 3/16")
      //   1 3/4" door → 1.8125" - 0.25" = 1.5625"  (1 9/16")
      mortiseWidthThin:  1.1875,  // for 1 3/8" slab
      mortiseWidthThick: 1.5625,  // for 1 3/4" slab
      boreDiameter: 2.125,        // standard 2 1/8" bore
      roSideMin: 0.25,            // shim space per side, min (1/4")
      roSideMax: 0.75,            // shim space per side, max (3/4")
      roTopMin: 0.25,
      roTopMax: 1,
      // ---- Double-door specific ----
      // Center allowance between the two leaves depends on the meeting style:
      //   ball catch:        1/8" gap between slab edges
      //   fixed astragal:    1/8" + 1/2" astragal + 1/8" = 3/4"
      //   floating astragal: 1/2" astragal (fixed to inactive leaf) + 1/8"
      //                      gap to active leaf = 5/8"
      ballCatchCenterGap: 0.125,
      fixedAstragalCenterGap: 0.75,
      floatingAstragalCenterGap: 0.625,
      astragalThk: 0.5,           // astragal thickness (1/2")
      astragalActiveGap: 0.125,   // gap between active leaf and astragal (1/8")
      flushBoltFromEnd: 6,        // flush/surface bolts inset 6" from top/bottom of inactive leaf
      ballCatchInset: 1.5,        // ball catch installed 1 1/2" in from meeting stile
      ballCatchFromTop: 0.5       // ball catch body centered in top edge of slab
    };

    function isDouble(cfg) {
      return cfg === 'double-fixed-astragal'
          || cfg === 'double-floating-astragal'
          || cfg === 'double-ballcatch';
    }
    // Active leaf carries a privacy bore only on a single door or a floating
    // astragal pair. Fixed-astragal and ball-catch pairs use dummies + ball
    // catches on both leaves, so neither leaf is bored for a latch.
    function hasBore(cfg) {
      return cfg === 'single' || cfg === 'double-floating-astragal';
    }
    // The config allows a bore AND the customer hasn't picked "No bore".
    function boreOn(i) {
      return hasBore(i.config) && i.lockPrep !== 'none';
    }
    // Double bore adds a deadbolt bore above the latch bore.
    function deadboltOn(i) {
      return boreOn(i) && i.lockPrep === 'double';
    }
    var LOCK_PREP_LABELS = {
      single: 'Single bore',
      double: 'Double bore (custom)',
      none: 'No bore'
    };
    function hasAstragal(cfg) {
      return cfg === 'double-fixed-astragal' || cfg === 'double-floating-astragal';
    }
    function isFixedAstragal(cfg) { return cfg === 'double-fixed-astragal'; }
    function isFloatingAstragal(cfg) { return cfg === 'double-floating-astragal'; }
    function usesBallCatch(cfg) {
      // Ball catches hold the doors on both the no-astragal pair AND the
      // fixed-astragal pair (per Pease shop practice).
      return cfg === 'double-ballcatch' || cfg === 'double-fixed-astragal';
    }
    // Center gap between the two leaves for a given config.
    function centerGap(cfg) {
      if (cfg === 'double-ballcatch') return C.ballCatchCenterGap;
      if (cfg === 'double-fixed-astragal') return C.fixedAstragalCenterGap;
      if (cfg === 'double-floating-astragal') return C.floatingAstragalCenterGap;
      return 0;
    }

    // Hinge & strike mortise width derived from slab thickness.
    // See the C.mortiseWidthThin / C.mortiseWidthThick comments above for
    // the carpentry rationale (Pease double-rabbeted jamb).
    function mortiseWidthFor(slabThk) {
      if (Math.abs(slabThk - 1.375) < 1e-9) return C.mortiseWidthThin;
      if (Math.abs(slabThk - 1.75)  < 1e-9) return C.mortiseWidthThick;
      // Defensive fallback for legacy/unknown thicknesses: pick the closer
      // of the two standard faces.
      return slabThk < (1.375 + 1.75) / 2 ? C.mortiseWidthThin : C.mortiseWidthThick;
    }

    // ---- Core calculation ----
    function calculate(i) {
      var r = {};
      var dbl = isDouble(i.config);
      var jt = i.jambThickness;

      // slab-top to jamb-top offset = top air gap (1/8") + head jamb thickness.
      // (Head jamb thickness equals the jamb plank thickness input.)
      var slabToJambOffset = C.topAirGap + jt;
      r.slabToJambOffset = slabToJambOffset;

      // ---- Head jamb width ----
      // Single: slab + hinge-side gap (1/16") + strike-side gap (1/8") = slab + 3/16".
      // Double: both leaves + a hinge-side gap (1/16") at each OUTER edge +
      //   the center gap between leaves (depends on meeting style). On a
      //   double the active leaf's strike clearance is taken up at the
      //   center gap (astragal/ball-catch joint), not at a jamb.
      var headJambW;
      if (!dbl) {
        headJambW = i.slabW + C.hingeSideGap + C.strikeSideGap;
      } else {
        headJambW = 2 * i.slabW + 2 * C.hingeSideGap + centerGap(i.config);
      }
      r.headJamb = headJambW;
      r.centerGap = dbl ? centerGap(i.config) : 0;

      // Jamb height: top air gap + head jamb thickness above slab + slab + floor clearance
      var jambH = i.slabH + slabToJambOffset + i.floorClearance;
      r.jambHt = jambH;

      // Unit width = head jamb + two leg jambs
      var unitW = headJambW + 2 * jt;
      r.unitW = unitW;

      r.unitH = jambH;
      r.unitD = i.jambDepth;

      // Rough opening
      r.roWmin = unitW + 2 * C.roSideMin;
      r.roWmax = unitW + 2 * C.roSideMax;
      r.roHmin = jambH + C.roTopMin;
      r.roHmax = jambH + C.roTopMax;
      r.roDmin = i.jambDepth - 0.125;
      r.roDmax = i.jambDepth;

      // ---- Slab hinge positions (rounded to 1/8") ----
      // Layout is identical for single and double; both leaves of a double
      // use the same numbers, mirrored across the centerline.
      r.slab1 = r8(i.firstHingeOffset);

      if (i.hingeCount === 2) {
        // Bottom hinge mirrors the top hinge.
        r.slab2 = r8(i.slabH - i.firstHingeOffset - i.hingeSize);
        r.slab3 = 'na';
        r.slab4 = 'na';
      } else if (i.hingeCount === 3) {
        var slab3 = i.slabH - i.firstHingeOffset - i.hingeSize;
        var slab2 = (i.firstHingeOffset + slab3) / 2;
        r.slab2 = r8(slab2);
        r.slab3 = r8(slab3);
        r.slab4 = 'na';
      } else {
        var bottomOffset = Math.max(9 + i.hingeSize, i.firstHingeOffset + i.hingeSize);
        var lastTop = i.slabH - bottomOffset;
        var span = lastTop - i.firstHingeOffset;
        var step = span / 3;
        r.slab2 = r8(i.firstHingeOffset + step);
        r.slab3 = r8(i.firstHingeOffset + 2 * step);
        r.slab4 = r8(lastTop);
      }

      // Advanced overrides: keep the standard positions for the placeholders.
      r.std = { slab2: r.slab2, slab3: r.slab3, slab4: r.slab4 };
      if (i.hinge2 !== null) r.slab2 = r8(i.hinge2);
      if (i.hinge3 !== null && r.slab3 !== 'na') r.slab3 = r8(i.hinge3);
      if (i.hinge4 !== null && r.slab4 !== 'na') r.slab4 = r8(i.hinge4);

      // ---- Latch bore ----
      // Only single doors and floating-astragal pairs (active leaf, privacy
      // set) get a bore. Fixed-astragal and ball-catch pairs use dummies +
      // ball catches on both leaves, so no leaf is bored.
      // Lock prep can also turn the bore off ("No bore"); a double bore adds
      // a deadbolt bore one bore-spacing above the latch.
      if (boreOn(i)) {
        r.latchBore = r8(i.slabH - i.boreFromBottom);
      } else {
        r.latchBore = 'na';
      }
      r.deadboltBore = deadboltOn(i) ? r8(i.slabH - i.boreFromBottom - i.boreSpacing) : 'na';

      // ---- Jamb hinge positions ----
      var off = slabToJambOffset;
      r.jamb1 = r.slab1 === 'na' ? 'na' : r.slab1 + off;
      r.jamb2 = r.slab2 === 'na' ? 'na' : r.slab2 + off;
      r.jamb3 = r.slab3 === 'na' ? 'na' : r.slab3 + off;
      r.jamb4 = r.slab4 === 'na' ? 'na' : r.slab4 + off;

      // ---- Strike positions (only for configs with a bore) ----
      // Single: strike is on the lock jamb. Floating astragal: the active
      // leaf's latch throws into the astragal, so the strike sits on the
      // astragal at the same height (still measured from top of slab).
      if (boreOn(i)) {
        var latchStrike = r.latchBore + off;
        r.latchStrike = latchStrike;
        r.latchMortTop = latchStrike - C.latchMortLen / 2;
        r.latchMortBot = latchStrike + C.latchMortLen / 2;
      } else {
        r.latchStrike = 'na';
        r.latchMortTop = 'na';
        r.latchMortBot = 'na';
      }
      if (deadboltOn(i)) {
        var dbStrike = r.deadboltBore + off;
        r.dbStrike = dbStrike;
        r.dbMortTop = dbStrike - C.latchMortLen / 2;
        r.dbMortBot = dbStrike + C.latchMortLen / 2;
      } else {
        r.dbStrike = r.dbMortTop = r.dbMortBot = 'na';
      }

      // ---- Double-door hardware specifics ----
      if (hasAstragal(i.config)) {
        r.astragalLen = i.slabH;
      }
      if (isFloatingAstragal(i.config)) {
        // Flush/surface bolts on the inactive leaf, 6" from each end.
        r.flushBoltTop = C.flushBoltFromEnd;
        r.flushBoltBot = C.flushBoltFromEnd;
      }
      if (usesBallCatch(i.config)) {
        // Ball catch in the top edge of each slab, inset from the meeting
        // stile. The head-jamb strike sits the same inset out from the
        // centerline plus half the center gap.
        r.ballCatchInset = C.ballCatchInset;
        r.ballCatchHeadOffset = C.ballCatchInset + r.centerGap / 2;
      }

      return r;
    }

    // ============================================================
    // DRAWING — SVG elevation + plan with swing arc
    // ============================================================
    var SVG_NS = 'http://www.w3.org/2000/svg';
    function svgMk(tag, attrs) {
      var e = document.createElementNS(SVG_NS, tag);
      for (var k in attrs) e.setAttribute(k, attrs[k]);
      return e;
    }
    function svgClear(svg) { while (svg.firstChild) svg.removeChild(svg.firstChild); }

    // Handing convention.
    //
    // The user selects handing using the standard industry convention: stand
    // on the PUSH side of the door (for an interior inswing door, the hallway
    // side — outside the room it swings into) and note which side the hinges
    // are on. RH → hinges right, LH → hinges left (both push-side view).
    //
    // The calculator draws two views of the same physical door, each from a
    // different viewpoint. Because of that, the screen-left / screen-right
    // mapping is different in each view:
    //
    //   PLAN view (top-down, room at top, hallway at bottom): the physical
    //   "hinge side" maps directly to screen-side, so
    //     RH → pivot RIGHT, LH → pivot LEFT.
    //
    //   ELEVATION view (drawn from the PULL side, inside the room looking
    //   AT the door): the viewer is facing the opposite direction, so the
    //   horizontal axis flips:
    //     RH → hinges LEFT,  LH → hinges RIGHT.
    //
    // Helpers below return the side ('L' / 'R') to RENDER the hinge edge
    // on, for each respective view.
    function hingeSidePlan(handing) {
      // Canonical / standard convention (push-side view ↔ plan top-down).
      return handing === 'Left' ? 'L' : 'R';
    }
    function hingeSideElevation(handing) {
      // Pull-side view; mirror of the canonical side.
      return handing === 'Left' ? 'R' : 'L';
    }

    // Horizontal dim line with inward-pointing arrows.
    function drawHorizDim(svg, xL, xR, y, label, color, labelAbove) {
      var xLeft = Math.min(xL, xR);
      var xRight = Math.max(xL, xR);
      var extLen = 5, extReach = 14, arrowSize = 5;
      var tickDir = labelAbove ? 1 : -1;
      var labelOffset = labelAbove ? -10 : 14;
      svg.appendChild(svgMk('line', {
        x1: xLeft, y1: y + tickDir * extLen,
        x2: xLeft, y2: y + tickDir * extReach,
        stroke: color, 'stroke-width': 0.5
      }));
      svg.appendChild(svgMk('line', {
        x1: xRight, y1: y + tickDir * extLen,
        x2: xRight, y2: y + tickDir * extReach,
        stroke: color, 'stroke-width': 0.5
      }));
      svg.appendChild(svgMk('line', {
        x1: xLeft, y1: y, x2: xRight, y2: y,
        stroke: color, 'stroke-width': 0.8
      }));
      svg.appendChild(svgMk('polygon', {
        points: xLeft + ',' + y + ' '
              + (xLeft + arrowSize) + ',' + (y - arrowSize / 2) + ' '
              + (xLeft + arrowSize) + ',' + (y + arrowSize / 2),
        fill: color
      }));
      svg.appendChild(svgMk('polygon', {
        points: xRight + ',' + y + ' '
              + (xRight - arrowSize) + ',' + (y - arrowSize / 2) + ' '
              + (xRight - arrowSize) + ',' + (y + arrowSize / 2),
        fill: color
      }));
      var cx = (xLeft + xRight) / 2;
      var t = svgMk('text', {
        x: cx, y: y + labelOffset,
        'text-anchor': 'middle', 'font-size': 11, 'font-weight': 700,
        fill: color, 'font-family': 'Source Sans 3, Source Sans Pro, sans-serif'
      });
      t.textContent = label;
      svg.appendChild(t);
    }

    // Vertical dim line with inward-pointing arrows.
    function drawVertDim(svg, x, yT, yB, label, color, labelRight) {
      if (labelRight === undefined) labelRight = true;
      var yTop = Math.min(yT, yB);
      var yBot = Math.max(yT, yB);
      var extLen = 5, extReach = 14, arrowSize = 5;
      var tickDir = labelRight ? -1 : 1;
      var labelOffset = labelRight ? 14 : -14;
      svg.appendChild(svgMk('line', {
        x1: x + tickDir * extLen, y1: yTop,
        x2: x + tickDir * extReach, y2: yTop,
        stroke: color, 'stroke-width': 0.5
      }));
      svg.appendChild(svgMk('line', {
        x1: x + tickDir * extLen, y1: yBot,
        x2: x + tickDir * extReach, y2: yBot,
        stroke: color, 'stroke-width': 0.5
      }));
      svg.appendChild(svgMk('line', {
        x1: x, y1: yTop, x2: x, y2: yBot,
        stroke: color, 'stroke-width': 0.8
      }));
      svg.appendChild(svgMk('polygon', {
        points: x + ',' + yTop + ' '
              + (x - arrowSize / 2) + ',' + (yTop + arrowSize) + ' '
              + (x + arrowSize / 2) + ',' + (yTop + arrowSize),
        fill: color
      }));
      svg.appendChild(svgMk('polygon', {
        points: x + ',' + yBot + ' '
              + (x - arrowSize / 2) + ',' + (yBot - arrowSize) + ' '
              + (x + arrowSize / 2) + ',' + (yBot - arrowSize),
        fill: color
      }));
      var cy = (yTop + yBot) / 2;
      var t = svgMk('text', {
        x: x + labelOffset, y: cy + 4,
        'text-anchor': 'middle', 'font-size': 11, 'font-weight': 700,
        fill: color, 'font-family': 'Source Sans 3, Source Sans Pro, sans-serif',
        transform: 'rotate(-90 ' + (x + labelOffset) + ' ' + cy + ')'
      });
      t.textContent = label;
      svg.appendChild(t);
    }

    // Elevation view — front, looking at the room the door swings INTO.
    // Interior convention: hinges on outer edges, strike/active hardware
    // at meeting stiles (doubles) or strike jamb (single). Both leaves of
    // a double share the same hinge layout, mirrored across the centerline.
    function drawElevation(i, r) {
      var svg = sectionEl.querySelector('[data-drawing="elevation"]');
      if (!svg) return;
      svgClear(svg);

      var dbl = isDouble(i.config);
      var withAstragal = hasAstragal(i.config);
      var withBore = boreOn(i);
      var jt = i.jambThickness;

      var DIM_MARGIN_L = 70;
      var DIM_MARGIN_R = 70;
      // Doubles need extra room ABOVE the drawing for the astragal /
      // ball-catch callouts so they don't overlap the head jamb or the
      // width dimension below.
      var DIM_MARGIN_T = dbl ? 64 : 30;
      var DIM_MARGIN_B = 50;
      var logicalW = r.unitW;
      var logicalH = r.unitH;
      var availW = 560 - DIM_MARGIN_L - DIM_MARGIN_R;
      var availH = 560 - DIM_MARGIN_T - DIM_MARGIN_B;
      var scale = Math.min(availW / logicalW, availH / logicalH);

      var drawnW = logicalW * scale + DIM_MARGIN_L + DIM_MARGIN_R;
      var drawnH = logicalH * scale + DIM_MARGIN_T + DIM_MARGIN_B;
      svg.setAttribute('viewBox', '0 0 ' + drawnW + ' ' + drawnH);
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');

      var unitLeftPx = DIM_MARGIN_L;
      var unitBottomPxY = DIM_MARGIN_T + logicalH * scale;
      function px(x) { return unitLeftPx + x * scale; }
      function py(y) { return unitBottomPxY - y * scale; }

      var JAMB_FILL = '#FFFFFF';
      var JAMB_STROKE = '#26292C';
      var JAMB_STROKE_W = 0.8;
      var STOP_OPACITY = 0.6;

      // Real-world stack-up dimensions
      var FLOOR_CLEAR_REAL = i.floorClearance;
      var HEAD_GAP_REAL = C.topAirGap;
      var HEAD_H_REAL = jt;

      // Visually exaggerate the thin stackup elements so they're readable
      var VIS_FACTOR = 1.6;
      var FLOOR_CLEAR = FLOOR_CLEAR_REAL * VIS_FACTOR;
      var HEAD_GAP = HEAD_GAP_REAL * VIS_FACTOR;
      var HEAD_H = HEAD_H_REAL * VIS_FACTOR;
      var realStackupTotal = FLOOR_CLEAR_REAL + HEAD_GAP_REAL + HEAD_H_REAL;
      var visualStackupTotal = FLOOR_CLEAR + HEAD_GAP + HEAD_H;
      var slabVisualH = i.slabH - (visualStackupTotal - realStackupTotal);

      // Zones (y=0 at bottom of jamb)
      var floorBotY = 0;
      var floorTopY = floorBotY + FLOOR_CLEAR;
      var slabBotY = floorTopY;
      var slabTopY = slabBotY + slabVisualH;
      var headGapBotY = slabTopY;
      var headGapTopY = headGapBotY + HEAD_GAP;
      var headBotY = headGapTopY;
      var headTopY = headBotY + HEAD_H;

      // Unit outer frame
      svg.appendChild(svgMk('rect', {
        x: px(0), y: py(r.unitH),
        width: r.unitW * scale, height: r.unitH * scale,
        fill: 'none', stroke: JAMB_STROKE, 'stroke-width': 1.5
      }));

      // Head jamb band
      svg.appendChild(svgMk('rect', {
        x: px(jt), y: py(headTopY),
        width: (r.unitW - 2 * jt) * scale,
        height: HEAD_H * scale,
        fill: JAMB_FILL, stroke: JAMB_STROKE, 'stroke-width': JAMB_STROKE_W
      }));

      // Head gap above slab
      svg.appendChild(svgMk('rect', {
        x: px(jt), y: py(headBotY),
        width: (r.unitW - 2 * jt) * scale,
        height: HEAD_GAP * scale,
        fill: '#F3F7FC', stroke: 'none'
      }));

      // Leg jambs — run full vertical extent from just under the head jamb
      // all the way down to the bottom of the unit (the bottom of the leg).
      // The space between the two extended jambs below the slab is air, where
      // the slab swings over the finished floor; no horizontal piece spans it.
      svg.appendChild(svgMk('rect', {
        x: px(0), y: py(headBotY),
        width: jt * scale, height: headBotY * scale,
        fill: JAMB_FILL, stroke: JAMB_STROKE, 'stroke-width': JAMB_STROKE_W
      }));
      svg.appendChild(svgMk('rect', {
        x: px(r.unitW - jt), y: py(headBotY),
        width: jt * scale, height: headBotY * scale,
        fill: JAMB_FILL, stroke: JAMB_STROKE, 'stroke-width': JAMB_STROKE_W
      }));

      var slabShrink = slabVisualH / i.slabH;
      var boreR = C.boreDiameter / 2;
      var hingeWidth = 0.5;
      var STOP_W = 0.5;
      var mkStop = function (x, y, w, h) {
        svg.appendChild(svgMk('rect', {
          x: px(x), y: py(y), width: w * scale, height: h * scale,
          fill: JAMB_FILL, stroke: JAMB_STROKE, 'stroke-width': JAMB_STROKE_W,
          opacity: STOP_OPACITY, 'pointer-events': 'none'
        }));
      };

      // Draw one slab. hingeSide is 'L' or 'R' (which edge the hinges are on).
      // showBore = should the latch bore be drawn on this leaf? (active leaf only)
      function drawSlab(slabLeft, slabRight, hingeSide, showBore) {
        // Slab rectangle. Clicking it flips the handing.
        svg.appendChild(svgTitle(svgMk('rect', {
          x: px(slabLeft), y: py(slabTopY),
          width: (slabRight - slabLeft) * scale,
          height: slabVisualH * scale,
          fill: '#F3F7FC', stroke: '#42474D', 'stroke-width': 1,
          'data-draw-action': 'flip-handing', 'class': 'pease-draw-hit'
        }), 'Door: ' + (i.handing === 'Left' ? 'left' : 'right') + ' hand. Click to flip the handing.'));

        // Bore (only on active leaf for double; always for single if hasBore)
        if (showBore && withBore && typeof r.latchBore === 'number') {
          var strikeEdgeX = hingeSide === 'L' ? slabRight : slabLeft;
          var boreXin = hingeSide === 'L' ? -i.backset : i.backset;
          var boreCenterX = strikeEdgeX + boreXin;
          var boreYs = [slabTopY - r.latchBore * slabShrink];
          var boreTips = ['Latch bore: ' + toFraction(r.latchBore) + ' from top of door to center'];
          if (typeof r.deadboltBore === 'number') {
            boreYs.push(slabTopY - r.deadboltBore * slabShrink);
            boreTips.push('Deadbolt bore: ' + toFraction(r.deadboltBore) + ' from top of door to center');
          }
          boreYs.forEach(function (boreY, bi) {
            svg.appendChild(svgTitle(svgMk('circle', {
              cx: px(boreCenterX), cy: py(boreY),
              r: boreR * scale,
              fill: 'rgba(255,255,255,0.01)', stroke: '#26292C', 'stroke-width': 0.6
            }), boreTips[bi] + ', ' + toFraction(i.backset) + ' backset'));
            svg.appendChild(svgMk('circle', {
              cx: px(boreCenterX), cy: py(boreY),
              r: 0.15 * scale, fill: '#26292C'
            }));
          });
        }

        // Hinges
        var hingeX = hingeSide === 'L' ? slabLeft : slabRight - hingeWidth;
        var hingePositions = [r.slab1, r.slab2, r.slab3, r.slab4]
          .filter(function (v) { return v !== 'na' && typeof v === 'number' && isFinite(v); });
        hingePositions.forEach(function (topFromSlabTop, hi) {
          var hingeTopY = slabTopY - topFromSlabTop * slabShrink;
          svg.appendChild(svgTitle(svgMk('rect', {
            x: px(hingeX), y: py(hingeTopY),
            width: hingeWidth * scale, height: i.hingeSize * slabShrink * scale,
            fill: '#1A2028', stroke: '#26292C', 'stroke-width': 0.4
          }), ['1st', '2nd', '3rd', '4th'][hi] + ' hinge: ' + toFraction(topFromSlabTop) + ' from top of door to top of hinge'));
        });

        // Stops around this slab
        mkStop(slabLeft, slabTopY, slabRight - slabLeft, STOP_W);   // top
        mkStop(slabLeft, slabBotY + STOP_W, slabRight - slabLeft, STOP_W); // bottom
        mkStop(slabLeft, slabTopY, STOP_W, slabVisualH);            // left edge
        mkStop(slabRight - STOP_W, slabTopY, STOP_W, slabVisualH);  // right edge
      }

      if (!dbl) {
        // ---- SINGLE DOOR ----
        var hinge = hingeSideElevation(i.handing);
        var slabLeft = jt;
        var slabRight = r.unitW - jt;
        drawSlab(slabLeft, slabRight, hinge, true);

        // Strike plate on the strike-side leg jamb
        if (withBore && typeof r.latchBore === 'number') {
          var strikeSide = hinge === 'L' ? 'R' : 'L';
          var strikeJambX = strikeSide === 'L' ? 0 : r.unitW - jt;
          var strikeMortVisH = C.latchMortLen * slabShrink;
          [r.latchBore, r.deadboltBore].filter(function (v) { return typeof v === 'number'; })
            .forEach(function (boreFromTop) {
              var strikeCenterY = slabTopY - boreFromTop * slabShrink;
              svg.appendChild(svgMk('rect', {
                x: px(strikeJambX), y: py(strikeCenterY + strikeMortVisH / 2),
                width: jt * scale,
                height: strikeMortVisH * scale,
                fill: '#3D4651', stroke: '#26292C', 'stroke-width': 0.4
              }));
            });
        }
      } else {
        // ---- DOUBLE DOOR ----
        // activeOn: which leaf is the active/operating leaf. For ball-catch
        // and fixed-astragal pairs (both dummies) it's only a labeling/visual
        // choice; for floating astragal it determines which leaf is bored.
        // Mirror the user's handing for the pull-side view (matching
        // hingeSideElevation above): RH → active leaf renders LEFT.
        var leftHinge = 'L', rightHinge = 'R';
        var activeOn = i.handing === 'Left' ? 'R' : 'L';
        var inactiveSide = activeOn === 'L' ? 'R' : 'L';

        var centerX = r.unitW / 2;
        var gap = r.centerGap;
        var leftSlabL = jt;
        var leftSlabR = centerX - gap / 2;
        var rightSlabL = centerX + gap / 2;
        var rightSlabR = r.unitW - jt;

        var boreOnActive = withBore; // only floating astragal among doubles

        // Draw the two leaves. drawSlab draws the bore only if showBore.
        drawSlab(leftSlabL, leftSlabR, leftHinge, boreOnActive && activeOn === 'L');
        drawSlab(rightSlabL, rightSlabR, rightHinge, boreOnActive && activeOn === 'R');

        var inactiveLeafL = inactiveSide === 'L' ? leftSlabL : rightSlabL;
        var inactiveLeafR = inactiveSide === 'L' ? leftSlabR : rightSlabR;

        // ---- Astragal strip (fixed or floating) ----
        if (withAstragal) {
          var astrVisW = Math.max(0.6, C.astragalThk);
          // Fixed astragal sits centered in the gap (1/8" each side). Floating
          // astragal is fastened to the inactive leaf, so it sits against the
          // inactive leaf with the 1/8" gap on the active side. Visually we
          // center it in the gap for both — the difference is captured in the
          // gap width itself (3/4" vs 5/8").
          var astrCenterX = centerX;
          if (isFloatingAstragal(i.config)) {
            // Shift toward the inactive leaf so the 1/8" gap shows on the
            // active side.
            var shift = (C.astragalActiveGap / 2);
            astrCenterX = inactiveSide === 'L'
              ? centerX - shift
              : centerX + shift;
          }
          svg.appendChild(svgMk('rect', {
            x: px(astrCenterX - astrVisW / 2), y: py(slabTopY),
            width: astrVisW * scale,
            height: slabVisualH * scale,
            fill: '#21409A', stroke: '#14255F', 'stroke-width': 0.5
          }));
          // Astragal callout — placed ABOVE the drawing so it never overlaps
          // the head jamb or the width dimension below. A dashed leader runs
          // down from the label to the top of the astragal strip.
          var astrLabelY = py(r.unitH) - 28;
          svg.appendChild(svgMk('line', {
            x1: px(astrCenterX), y1: astrLabelY + 4,
            x2: px(astrCenterX), y2: py(slabTopY),
            stroke: '#21409A', 'stroke-width': 0.6, 'stroke-dasharray': '2 2'
          }));
          var astrLabel = svgMk('text', {
            x: px(astrCenterX), y: astrLabelY,
            'text-anchor': 'middle', 'font-size': 9, 'font-weight': 700,
            fill: '#21409A', 'font-family': 'Source Sans 3, Source Sans Pro, sans-serif'
          });
          astrLabel.textContent = isFixedAstragal(i.config) ? 'ASTRAGAL (FIXED)' : 'ASTRAGAL (FLOATING)';
          svg.appendChild(astrLabel);
        }

        // ---- Flush/surface bolts on inactive leaf (floating astragal only) ----
        if (isFloatingAstragal(i.config)) {
          var fbX = inactiveSide === 'L' ? inactiveLeafR - 0.6 : inactiveLeafL;
          var fbTopY = slabTopY - C.flushBoltFromEnd * slabShrink;
          var fbBotY = slabTopY - (i.slabH - C.flushBoltFromEnd) * slabShrink;
          [fbTopY, fbBotY].forEach(function (fY) {
            svg.appendChild(svgMk('rect', {
              x: px(fbX), y: py(fY + 0.5),
              width: 0.6 * scale, height: 1 * slabShrink * scale,
              fill: '#3D4651', stroke: '#26292C', 'stroke-width': 0.4
            }));
          });

          // Inactive leaf carries a double dummy (handle, no functional
          // latch): draw a dashed knob ring at the bore height, no center dot.
          // The dummy sits one backset INWARD from the inactive leaf's meeting
          // (strike) edge — mirroring the active leaf's bore across the gap.
          // Inactive on RIGHT  → meeting edge is its LEFT edge  (inactiveLeafL),
          //                      dummy at inactiveLeafL + backset.
          // Inactive on LEFT   → meeting edge is its RIGHT edge (inactiveLeafR),
          //                      dummy at inactiveLeafR - backset.
          var dummyEdgeX = inactiveSide === 'L'
            ? (inactiveLeafR - i.backset)
            : (inactiveLeafL + i.backset);
          if (typeof r.latchBore === 'number') {
            var dummyY = slabTopY - r.latchBore * slabShrink;
            svg.appendChild(svgMk('circle', {
              cx: px(dummyEdgeX), cy: py(dummyY),
              r: (C.boreDiameter / 2) * scale,
              fill: 'none', stroke: '#677079', 'stroke-width': 0.6,
              'stroke-dasharray': '2 1.5'
            }));
          }
        }

        // ---- Ball catches (ball-catch pair AND fixed-astragal pair) ----
        if (usesBallCatch(i.config)) {
          var bcInset = C.ballCatchInset;
          var bcSize = 0.5;
          var bcLeftX = leftSlabR - bcInset - bcSize / 2;
          var bcRightX = rightSlabL + bcInset - bcSize / 2;
          var bcY = slabTopY - 1.0 * slabShrink; // ~1" down from top edge
          [bcLeftX, bcRightX].forEach(function (bx) {
            svg.appendChild(svgMk('circle', {
              cx: px(bx + bcSize / 2), cy: py(bcY),
              r: 0.22 * scale,
              fill: '#CC5E47', stroke: '#26292C', 'stroke-width': 0.5
            }));
          });
          // Catch plate marks on the head jamb above each ball catch
          [bcLeftX, bcRightX].forEach(function (bx) {
            svg.appendChild(svgMk('rect', {
              x: px(bx + bcSize / 2 - 0.3), y: py(headBotY + HEAD_H * 0.5),
              width: 0.6 * scale, height: 0.25 * scale,
              fill: '#CC5E47', stroke: '#26292C', 'stroke-width': 0.4
            }));
          });
          // BALL CATCH callout ABOVE the drawing with a leader down to the
          // catch on the active/primary leaf. When a fixed astragal is also
          // present, this stacks ABOVE the astragal label.
          var primaryBcX = activeOn === 'L' ? bcLeftX : bcRightX;
          var bcLabelY = py(r.unitH) - (withAstragal ? 46 : 28);
          svg.appendChild(svgMk('line', {
            x1: px(primaryBcX + bcSize / 2), y1: bcLabelY + 4,
            x2: px(primaryBcX + bcSize / 2), y2: py(bcY),
            stroke: '#CC5E47', 'stroke-width': 0.6, 'stroke-dasharray': '2 2'
          }));
          var bcLabel = svgMk('text', {
            x: px(primaryBcX + bcSize / 2), y: bcLabelY,
            'text-anchor': 'middle', 'font-size': 8.5, 'font-weight': 700,
            fill: '#CC5E47', 'font-family': 'Source Sans 3, Source Sans Pro, sans-serif'
          });
          bcLabel.textContent = 'BALL CATCH (EACH LEAF)';
          svg.appendChild(bcLabel);

          // Both leaves carry a double-dummy handle (no bore). Draw a dashed
          // dummy ring on each leaf's meeting edge so handles show on both —
          // applies to the plain ball-catch pair AND the fixed-astragal pair.
          if (typeof i.boreFromBottom === 'number') {
            var dummyH = i.slabH - i.boreFromBottom;
            var dY = slabTopY - dummyH * slabShrink;
            var leftDummyX = leftSlabR - i.backset;
            var rightDummyX = rightSlabL + i.backset;
            [leftDummyX, rightDummyX].forEach(function (dx) {
              svg.appendChild(svgMk('circle', {
                cx: px(dx), cy: py(dY),
                r: (C.boreDiameter / 2) * scale,
                fill: 'none', stroke: '#677079', 'stroke-width': 0.6,
                'stroke-dasharray': '2 1.5'
              }));
            });
          }
        }
      }

      // ---- Dimension lines ----
      // Use 1/16" precision: with an 11/16" jamb and 1/16" hinge reveal the
      // true unit width/height land on sixteenths (e.g. 33 9/16", 81 11/16"),
      // which 1/8" rounding would distort.
      drawHorizDim(svg, px(0), px(r.unitW), py(0) + 28, toFraction16(r.unitW), '#21409A');
      drawVertDim(svg, px(r.unitW) + 28, py(0), py(r.unitH), toFraction16(r.unitH), '#21409A');
      drawVertDim(svg, px(0) - 28, py(slabBotY), py(slabTopY),
                  toFraction16(i.slabH), '#677079', false);
    }

    // Plan view (top-down). Interior is always inswing; no brickmold and
    // no threshold. Wall is drawn on both sides of the jamb with a shim
    // gap for clarity.
    function drawPlan(i, r) {
      var svg = sectionEl.querySelector('[data-drawing="plan"]');
      if (!svg) return;
      svgClear(svg);

      var DIM_MARGIN = 52;
      var WALL_EXTEND = 12;
      var LABEL_SPACE = 18;
      var availW = 700 - DIM_MARGIN * 2;
      var availH = 360 - DIM_MARGIN * 2 - LABEL_SPACE * 2;

      var planW = r.unitW;
      var planD = r.unitD;
      var swingR = i.slabW;

      var SHIM = 0.5;
      // Inswing: arc projects ABOVE the unit (toward the room, top of plan)
      // Per-leaf swing radius = slabW (single or double), so spaceAbove is same.
      var spaceAbove = swingR;
      var spaceBelow = 0;
      var sideMargin = SHIM;

      var logicalW = planW + 2 * sideMargin + 2 * WALL_EXTEND;
      var logicalH = planD + spaceAbove + spaceBelow;
      var scale = Math.min(availW / logicalW, availH / logicalH);

      var drawnW = logicalW * scale + DIM_MARGIN * 2;
      var drawnH = logicalH * scale + DIM_MARGIN * 2 + LABEL_SPACE * 2;
      svg.setAttribute('viewBox', '0 0 ' + drawnW + ' ' + drawnH);
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');

      var unitXinLogical = sideMargin + WALL_EXTEND;
      var unitYinLogical = spaceAbove;

      var unitLeftPx = DIM_MARGIN + unitXinLogical * scale;
      var unitTopPx = DIM_MARGIN + LABEL_SPACE + unitYinLogical * scale;

      function px(x) { return unitLeftPx + x * scale; }
      function py(y) { return unitTopPx + y * scale; }

      // Wall layered: drywall on BOTH sides for interior partitions
      // (vs sheathing+drywall on an exterior wall). Stud cavity in middle.
      var DRYWALL = 0.5;
      var FUDGE = 0.0625;
      var studDepth = planD - 2 * DRYWALL - FUDGE;
      var showLayered = studDepth >= 1.0;

      function drawWallSide(xStart, wallW) {
        if (showLayered) {
          // Both sides interior — drywall on TOP (room door opens into)
          svg.appendChild(svgMk('rect', {
            x: px(xStart), y: py(0),
            width: wallW * scale, height: (DRYWALL + FUDGE / 2) * scale,
            fill: '#ECE7DB', stroke: '#677079', 'stroke-width': 0.5
          }));
          // Stud cavity
          var studY0 = DRYWALL + FUDGE / 2;
          var studY1 = studY0 + studDepth;
          svg.appendChild(svgMk('rect', {
            x: px(xStart), y: py(studY0),
            width: wallW * scale, height: studDepth * scale,
            fill: '#F5EFE4', stroke: '#677079', 'stroke-width': 0.5
          }));
          var hatchStep = Math.max(1.2, studDepth * 0.25);
          var clipId = 'idc-stud-clip-' + Math.random().toString(36).slice(2, 9);
          var defs = svgMk('defs', {});
          var clip = svgMk('clipPath', { id: clipId });
          clip.appendChild(svgMk('rect', {
            x: px(xStart), y: py(studY0),
            width: wallW * scale, height: studDepth * scale
          }));
          defs.appendChild(clip);
          svg.appendChild(defs);
          for (var hx = xStart - studDepth; hx < xStart + wallW + studDepth; hx += hatchStep) {
            svg.appendChild(svgMk('line', {
              x1: px(hx), y1: py(studY0),
              x2: px(hx + studDepth), y2: py(studY1),
              stroke: '#A89D85', 'stroke-width': 0.4,
              'clip-path': 'url(#' + clipId + ')'
            }));
          }
          // Drywall on BOTTOM (other side of partition)
          svg.appendChild(svgMk('rect', {
            x: px(xStart), y: py(studY1),
            width: wallW * scale, height: (DRYWALL + FUDGE / 2) * scale,
            fill: '#ECE7DB', stroke: '#677079', 'stroke-width': 0.5
          }));
        } else {
          svg.appendChild(svgMk('rect', {
            x: px(xStart), y: py(0),
            width: wallW * scale, height: planD * scale,
            fill: '#E8E3DA', stroke: '#677079', 'stroke-width': 0.5
          }));
          var hatchSpacing = 1.8;
          for (var thinHx = xStart; thinHx < xStart + wallW; thinHx += hatchSpacing) {
            svg.appendChild(svgMk('line', {
              x1: px(thinHx), y1: py(0),
              x2: px(thinHx + hatchSpacing), y2: py(planD),
              stroke: '#677079', 'stroke-width': 0.4
            }));
          }
        }
      }

      drawWallSide(-SHIM - WALL_EXTEND, WALL_EXTEND);
      drawWallSide(planW + SHIM, WALL_EXTEND);

      // Unit frame
      svg.appendChild(svgMk('rect', {
        x: px(0), y: py(0),
        width: planW * scale, height: planD * scale,
        fill: '#F3F7FC', stroke: '#26292C', 'stroke-width': 1.2
      }));

      // Door panel(s) — interior is always inswing
      var jt = i.jambThickness;
      var slabW = i.slabW;
      var doorThick = i.slabThk;
      var dirY = -1; // inswing → up
      var dbl = isDouble(i.config);

      function drawLeaf(pivotX, hingeSide) {
        // pivotX = where the hinge edge of the leaf is at the top of plan
        var pivotY = planD / 2;
        var thickDir = hingeSide === 'L' ? 1 : -1;
        var doorX1 = pivotX;
        var doorX2 = pivotX + thickDir * doorThick;
        var doorY1 = pivotY;
        var doorY2 = pivotY + dirY * slabW;
        var minX = Math.min(doorX1, doorX2), maxX = Math.max(doorX1, doorX2);
        var minY = Math.min(doorY1, doorY2), maxY = Math.max(doorY1, doorY2);
        var flipTip = (i.handing === 'Left' ? 'Left' : 'Right') + ' hand. Click to flip the handing.';
        svg.appendChild(svgTitle(svgMk('polygon', {
          points: px(minX) + ',' + py(minY) + ' ' + px(maxX) + ',' + py(minY) + ' ' + px(maxX) + ',' + py(maxY) + ' ' + px(minX) + ',' + py(maxY),
          fill: '#42474D', stroke: '#26292C', 'stroke-width': 0.5,
          'data-draw-action': 'flip-handing', 'class': 'pease-draw-hit pease-draw-hit--leaf'
        }), flipTip));
        // Swing arc
        var strikeDir = hingeSide === 'L' ? 1 : -1;
        var closedEndX = pivotX + strikeDir * slabW;
        var closedEndY = pivotY;
        var openEndX = pivotX;
        var openEndY = pivotY + dirY * slabW;
        var sweep = hingeSide === 'L' ? 0 : 1;
        var arcD = 'M ' + px(closedEndX) + ' ' + py(closedEndY) + ' A ' + (slabW * scale) + ' ' + (slabW * scale) + ' 0 0 ' + sweep + ' ' + px(openEndX) + ' ' + py(openEndY);
        svg.appendChild(svgMk('path', {
          d: arcD,
          fill: 'none', stroke: '#3B6CC7', 'stroke-width': 1, 'stroke-dasharray': '4 3'
        }));
        // Wide invisible copy of the arc so it is easy to click.
        svg.appendChild(svgTitle(svgMk('path', {
          d: arcD, fill: 'none', stroke: 'transparent', 'stroke-width': 14,
          'data-draw-action': 'flip-handing', 'class': 'pease-draw-hit-line'
        }), flipTip));
      }

      if (!dbl) {
        var hinge = hingeSidePlan(i.handing);
        var slabLeftPlan = jt;
        var pivotX = hinge === 'L' ? slabLeftPlan : slabLeftPlan + slabW;
        drawLeaf(pivotX, hinge);
      } else {
        // Two leaves. Hinges on outer (jamb-adjacent) edges. Each leaf pivots
        // at its outer edge; the meeting edges are separated by the center gap.
        var leftPivot = jt;                 // left leaf hinge edge
        var rightPivot = planW - jt;        // right leaf hinge edge
        drawLeaf(leftPivot, 'L');
        drawLeaf(rightPivot, 'R');

        // Astragal shown in plan at the closed (centerline) position.
        if (hasAstragal(i.config)) {
          var astrThk = C.astragalThk;
          svg.appendChild(svgMk('rect', {
            x: px(planW / 2 - astrThk / 2),
            y: py(planD / 2 - 0.25),
            width: Math.max(astrThk, 0.4) * scale,
            height: 0.5 * scale,
            fill: '#21409A', stroke: '#14255F', 'stroke-width': 0.4
          }));
        }
      }

      // Labels
      var labelX = px(planW / 2);
      var labelYTop = py(0) - 6;
      var labelYBot = py(planD) + 14;
      var tIn = svgMk('text', {
        x: labelX, y: labelYTop,
        'text-anchor': 'middle', 'font-size': 10, 'font-weight': 600,
        fill: '#677079', 'letter-spacing': '0.08em',
        'font-family': 'Source Sans 3, Source Sans Pro, sans-serif'
      });
      tIn.textContent = 'ROOM DOOR SWINGS INTO';
      svg.appendChild(tIn);
      var tEx = svgMk('text', {
        x: labelX, y: labelYBot,
        'text-anchor': 'middle', 'font-size': 10, 'font-weight': 600,
        fill: '#677079', 'letter-spacing': '0.08em',
        'font-family': 'Source Sans 3, Source Sans Pro, sans-serif'
      });
      tEx.textContent = 'ADJACENT ROOM / HALLWAY';
      svg.appendChild(tEx);

      // Depth dim (right side)
      drawVertDim(svg, px(planW + sideMargin + WALL_EXTEND) + 14, py(0), py(planD),
                  toFraction16(r.unitD), '#21409A');
      // Width dim (below)
      drawHorizDim(svg, px(0), px(planW),
                   labelYBot + 22, toFraction16(r.unitW), '#21409A');
    }

    // ---- Validation / warnings ----
    function validate(i) {
      var w = [];
      if (i.sizeMode === 'ro') {
        if (i.slabW < 10 || i.slabW > 48) w.push(msg('No slab from 10" to 48" wide fits this opening.', 'roW'));
        if (i.slabH < 60 || i.slabH > 100) w.push(msg('No slab from 60" to 100" tall fits this opening.', 'roH'));
      } else {
        if (i.slabW < 10 || i.slabW > 48) w.push(msg('Enter a slab width from 10" to 48".', 'slabW'));
        if (i.slabH < 60 || i.slabH > 100) w.push(msg('Enter a slab height from 60" to 100".', 'slabH'));
      }
      if (i.firstHingeOffset < HINGE_EDGE_MIN || i.firstHingeOffset > 12) w.push(msg('Leave at least 4" between the top of the door and the top of the 1st hinge (max 12").', 'firstHingeOffset'));
      if (i.jambThickness < 0.5 || i.jambThickness > 1.25) w.push(msg('Enter a jamb thickness from 1/2" to 1 1/4".', 'jambThickness'));
      if (i.floorClearance < 0.25 || i.floorClearance > 2) w.push(msg('Enter a floor clearance from 1/4" to 2".', 'floorClearance'));
      if (boreOn(i) && (i.boreFromBottom < 30 || i.boreFromBottom > 48)) w.push(msg('Enter a bore height from 30" to 48".', 'boreFromBottom'));
      if (deadboltOn(i) && (i.boreSpacing < 3 || i.boreSpacing > 12)) w.push(msg('Enter a bore spacing from 3" to 12".', 'boreSpacing'));
      // Advanced overrides
      var r = calculate(i);
      var hinges = [r.slab1, r.slab2, r.slab3, r.slab4].filter(function (v) { return typeof v === 'number'; });
      for (var h = 1; h < hinges.length; h++) {
        if (hinges[h] < hinges[h - 1] + i.hingeSize) { w.push(msg('This hinge overlaps the one above it. Each hinge must start below the bottom of the one above.', 'hinge' + (h + 1))); break; }
      }
      // Hinges need at least 4" of slab above the top hinge and below the
      // bottom hinge (the top limit is the 1st-hinge 4" minimum above).
      if (hinges.length && hinges[hinges.length - 1] + i.hingeSize > i.slabH - HINGE_EDGE_MIN) w.push(msg('Leave at least 4" between the bottom of the last hinge and the bottom of the slab.', 'hinge' + hinges.length));
      // Notes: allowed, but custom or unusual
      if (customHinges(i)) w.push(msg('Non-standard hinge size, count or placement is a custom hinge prep.', 'hingeCount', 'note'));
      if (customBore(i)) w.push(msg('Non-standard bore placement is a custom lock prep.', 'boreFromBottom', 'note'));
      if (i.slabH > 84.5 && i.hingeCount === 3) w.push(msg('Doors taller than 84 1/2" typically need 4 hinges.', 'hingeCount', 'note'));
      if (i.slabH > 60 && i.hingeCount === 2) w.push(msg('2 hinges is typically only for doors 60" or shorter. Taller doors need at least 3 to stay flat and carry the weight.', 'hingeCount', 'note'));
      if (i.slabH <= 84 && i.hingeCount === 4) w.push(msg('Doors 84" and shorter typically use only 3 hinges.', 'hingeCount', 'note'));
      return w;
    }

    // Item Reference tab: the products in this setup, in plain words.
    function itemRows(i, r) {
      var rows = [], dbl = isDouble(i.config);
      rows.push(['Door slab', (dbl ? '2 x ' : '') + toFraction(i.slabW) + ' x ' + toFraction(i.slabH) + ' x ' + toFraction(i.slabThk)]);
      rows.push(['Handing', i.handing + (dbl ? ' (active leaf)' : '')]);
      if (i.ship !== 'slab') {
        rows.push(['Jamb set', toFraction16(i.jambDepth) + ' deep: legs ' + toFraction16(r.jambHt) + ', head ' + toFraction16(r.headJamb)]);
      }
      rows.push(['Hinges', i.hingeCount + ' per door, ' + toFraction(i.hingeSize).replace('"', '') + '" x ' + toFraction(i.hingeSize)]);
      if (i.lockPrep !== 'none') rows.push(['Lockset', (i.lockPrep === 'double' ? 'Lockset and deadbolt' : 'Lockset') + ', ' + toFraction(i.backset) + ' backset']);
      rows.push(['Ships as', (SHIP_LABELS[i.ship] || i.ship).replace(/^./, function (ch) { return ch.toUpperCase(); })]);
      return rows;
    }

    // ---- Shop services for this setup (Shop Services Guide rules) ----
    var SHIP_LABELS = { prehung: 'prehung', kit: 'pre-drilled kit', slab: 'slab only', components: 'components' };
    function serviceLines(i, r) {
      var lines = [], notes = [], orderNotes = [];
      var add = function (sku, qty, why) { lines.push({ sku: sku, qty: qty || 1, why: why || '' }); };
      var dbl = isDouble(i.config);
      var unit = i.ship === 'prehung' || i.ship === 'kit';
      var hand = i.handing === 'Left' ? 'LH' : 'RH';
      var other = hand === 'LH' ? 'RH' : 'LH';
      add('ZASY-SETUP-' + hand + 'IS', 1, dbl ? 'names the active leaf' : '');
      // Lock prep
      var lockSku;
      if (!boreOn(i)) {
        lockSku = 'ZPREP-INT-NOLOCK';
        if (!hasBore(i.config)) notes.push('This pair uses dummy handles and ball catches, so neither leaf is bored.');
      } else if (deadboltOn(i) || customBore(i)) {
        lockSku = 'ZPREP-INT-L-CUST-CYL';
      } else {
        var bs = i.backset > 2.5 ? 'LONG' : (i.backset < 2.2 ? 'SHORT' : 'STD');
        lockSku = 'ZPREP-INT-L-SB-' + bs;
      }
      // Hinge prep: included with a unit (custom is extra); optional on a slab.
      var custHinge = customHinges(i);
      var hingeLines = [];
      // Interior pairs are only offered as kits, so a "prehung" pair is a kit.
      var asKit = i.ship === 'kit' || (dbl && i.ship === 'prehung');
      if (unit) {
        if (custHinge) hingeLines.push(['ZPREP-INT-H-CUST', dbl ? 2 : 1, dbl ? 'both leaves' : '']);
        else notes.push('Standard hinge prep is included with the ' + (asKit ? 'pre-drilled kit' : 'prehung unit') + '.');
      } else if (i.hingePrep === 'yes') {
        if (custHinge) hingeLines.push(['ZPREP-INT-H-CUST', dbl ? 2 : 1, dbl ? 'both leaves' : '']);
        else {
          hingeLines.push(['ZPREP-INT-H-STD-' + hand, 1, dbl ? 'active leaf' : '']);
          if (dbl) hingeLines.push(['ZPREP-INT-H-STD-' + other, 1, 'inactive leaf']);
        }
      } else {
        // No hinge prep on a slab: a $0 line, so production knows the hinge edge stays blank.
        hingeLines.push(['ZPREP-INT-NOHINGE', dbl ? 2 : 1, dbl ? 'both leaves' : '']);
      }
      if (!unit && lockSku === 'ZPREP-INT-L-SB-STD' && hingeLines.length && hingeLines[0][0] === 'ZPREP-INT-H-STD-' + hand) {
        // Both exactly standard on a slab-only order: the combo SKU.
        add('ZPREP-INT-HL-STD-' + hand, 1, dbl ? 'active leaf' : '');
        hingeLines.slice(1).forEach(function (h) { add(h[0], h[1], h[2]); });
      } else {
        add(lockSku, 1, dbl ? 'active leaf' : '');
        hingeLines.forEach(function (h) { add(h[0], h[1], h[2]); });
      }
      if (lockSku === 'ZPREP-INT-L-CUST-CYL') {
        orderNotes.push('Custom lock prep: ' + (typeof r.deadboltBore === 'number' ? 'deadbolt bore at ' + toFraction(r.deadboltBore) + ', ' : '') +
          'latch bore at ' + toFraction(r.latchBore) + ' (centers, from top of slab), ' + toFraction(i.backset) + ' backset.');
      }
      if (custHinge && hingeLines.length) {
        orderNotes.push('Custom hinge prep: ' + i.hingeCount + ' hinges, ' + toFraction(i.hingeSize).replace('"', '') + '" x ' +
          toFraction(i.hingeSize).replace('"', '') + '", tops at ' +
          [r.slab1, r.slab2, r.slab3, r.slab4].filter(function (v) { return typeof v === 'number'; })
            .map(function (v) { return toFraction(v); }).join(', ') + ' from top of slab.');
      }
      // Assembly
      if (i.ship === 'components') {
        add('ZASY-INT-COMP', 1, '');
      } else if (unit) {
        if (!dbl) {
          add(i.ship === 'prehung' ? 'ZASY-INT-PREHUNG' : 'ZASY-INT-KIT', 1, '');
        } else {
          add({ 'double-floating-astragal': 'ZASY-INT-KIT-DBL-FLOAT', 'double-fixed-astragal': 'ZASY-INT-KIT-DBL-FIXED', 'double-ballcatch': 'ZASY-INT-KIT-DBL-NONE' }[i.config], 1, '');
          if (i.ship === 'prehung') notes.push('Interior pairs are not offered prehung, so this is priced as a pre-drilled kit.');
        }
      }
      return { lines: lines, notes: notes, orderNotes: orderNotes };
    }

    // One-line recap of the setup, shown above the results.
    function summaryText(i) {
      var cfg = {
        'single': 'single door',
        'double-fixed-astragal': 'pair, fixed astragal',
        'double-floating-astragal': 'pair, floating astragal',
        'double-ballcatch': 'pair, ball catches'
      }[i.config];
      var parts = [];
      parts.push((isDouble(i.config) ? '2 × ' : '') + toFraction(i.slabW) + ' × ' + toFraction(i.slabH) + ' ' + cfg);
      parts.push(i.handing === 'Left' ? 'left hand' : 'right hand');
      parts.push(toFraction(i.slabThk) + ' slab');
      parts.push(toFraction16(i.jambDepth) + ' jamb');
      if (hasBore(i.config)) parts.push(LOCK_PREP_LABELS[i.lockPrep].toLowerCase());
      parts.push(SHIP_LABELS[i.ship]);
      if (i.sizeMode === 'ro') parts.push('for a ' + toFraction(i.roW) + ' × ' + toFraction(i.roH) + ' opening');
      var text = parts.join(' · ');
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
    function stickyText(r) {
      return 'Unit ' + toFraction16(r.unitW) + ' × ' + toFraction16(r.unitH) +
        ' · Opening ' + toFraction16(r.roWmin) + '–' + toFraction16(r.roWmax) +
        ' × ' + toFraction16(r.roHmin) + '–' + toFraction16(r.roHmax);
    }

    // ---- Render ----
    function setOut(key, val, fmt) {
      var el = sectionEl.querySelector('[data-out="' + key + '"]');
      if (!el) return;
      el.textContent = fmt ? fmt(val) : val;
    }

    function render() {
      var i = getInputs();
      sizeByOpening(i);
      var r = calculate(i);
      var dbl = isDouble(i.config);
      var withBore = boreOn(i);
      var withAstragal = hasAstragal(i.config);
      var fixedAstr = isFixedAstragal(i.config);
      var floatAstr = isFloatingAstragal(i.config);
      var ballPair = i.config === 'double-ballcatch';

      // ---- Slab width label / hint ----
      var slabWLabel = sectionEl.querySelector('[data-slab-w-label]');
      var slabWHint = sectionEl.querySelector('[data-slab-w-hint]');
      if (slabWLabel) slabWLabel.textContent = dbl ? 'Slab width (each leaf)' : 'Slab width';
      if (slabWHint) {
        slabWHint.textContent = (dbl ? 'Per leaf. ' : '') +
          'Pick a common size or type your own (min 10", max 48"). Fractions like 35 3/4 work.';
      }

      // ---- Handing label / hint ----
      var handingLabel = sectionEl.querySelector('[data-handing-label]');
      var handingHint = sectionEl.querySelector('[data-handing-hint]');
      if (handingLabel) handingLabel.textContent = dbl ? 'Active leaf' : 'Handing';
      if (handingHint) {
        if (floatAstr) {
          handingHint.textContent = 'Left = active leaf on the LEFT (privacy handle, latch throws into the astragal); inactive leaf on the right carries the astragal + bolts. Right = mirrored.';
        } else if (fixedAstr) {
          handingHint.textContent = 'Left/Right marks which leaf you treat as primary. Both leaves are dummies held by ball catches; the fixed astragal sits centered between them.';
        } else if (ballPair) {
          handingHint.textContent = 'Left/Right marks which leaf you treat as primary. Both leaves are hardware-identical; ball catches hold each closed.';
        } else {
          handingHint.textContent = '';
        }
      }

      // ---- Config hint ----
      var cfgHint = sectionEl.querySelector('[data-cfg-hint]');
      if (cfgHint) {
        if (fixedAstr) {
          cfgHint.textContent = 'Pair of doors with a fixed astragal (1/2" thick) centered between them — 1/8" gap on each side (3/4" total). Both leaves get a double dummy handle and a ball catch; neither leaf is bored.';
        } else if (floatAstr) {
          cfgHint.textContent = 'Pair of doors with a floating astragal (1/2") fastened to the inactive leaf, secured by flush/surface bolts to the head jamb (and floor). 1/8" gap to the active leaf (5/8" total). Active leaf gets a privacy handle; inactive gets a double dummy.';
        } else if (ballPair) {
          cfgHint.textContent = 'Pair of doors with no astragal — leaves meet with a 1/8" gap. Ball catches in the top edge of each slab engage strike plates in the head jamb. No latch bore in either leaf.';
        } else {
          cfgHint.textContent = 'Single door — standard hinged passage door.';
        }
      }

      // ---- Slab spec bore rows ----
      var withDeadbolt = deadboltOn(i);
      var showRow = function (key, on) {
        sectionEl.querySelectorAll('[data-row="' + key + '"]').forEach(function (el) { el.hidden = !on; });
      };
      showRow('lockPrep', hasBore(i.config));
      showRow('latchBore', withBore);
      showRow('backset', withBore);
      showRow('deadboltBore', withDeadbolt);
      showRow('boreSpacing', withDeadbolt);
      showRow('dbStrike', withDeadbolt);
      setOut('lockPrepOut', LOCK_PREP_LABELS[i.lockPrep]);
      setOut('deadboltBore', r.deadboltBore, toFraction);
      setOut('boreSpacingOut', i.boreSpacing, toFraction16);
      setOut('dbMortTop', r.dbMortTop, toFraction16);
      setOut('dbStrike', r.dbStrike, toFraction16);
      setOut('dbMortBot', r.dbMortBot, toFraction16);

      // ---- Lock prep inputs ----
      // Only configs that can carry a bore show the lock prep choice; bore
      // spacing only matters for a double bore.
      var showGroup = function (key, on) {
        sectionEl.querySelectorAll('[data-group="' + key + '"]').forEach(function (el) {
          el.style.display = on ? '' : 'none';
        });
      };
      showGroup('lock-prep', hasBore(i.config));
      showGroup('bore-spacing', withDeadbolt);
      showGroup('bore-height', withBore);
      showGroup('backset', withBore);

      // ---- Advanced settings ----
      // Placeholders show the standard value each blank override falls back to.
      sectionEl.querySelectorAll('[data-auto]').forEach(function (el) {
        var v = r.std[el.getAttribute('data-auto')];
        el.placeholder = typeof v === 'number' ? formatFractionalInput(v) : '';
      });
      // Hinge override fields: clamp (on blur) so every hinge keeps 4" of
      // slab above and below it.
      ['hinge2', 'hinge3', 'hinge4'].forEach(function (k) {
        var el = sectionEl.querySelector('[data-input="' + k + '"]');
        el.setAttribute('data-min', HINGE_EDGE_MIN);
        el.setAttribute('data-max', i.slabH - HINGE_EDGE_MIN - i.hingeSize);
      });
      showGroup('hinge3', i.hingeCount >= 3);
      showGroup('hinge4', i.hingeCount === 4);
      setStdOption(sectionEl, 'hingeCount', i.hingeCountStd, 'Standard (' + i.hingeCountStd + ')');
      setStdOption(sectionEl, 'backset', i.backsetStd, 'Standard (' + toFraction(i.backsetStd).replace('"', '') + ')');
      sectionEl.querySelector('[data-adv-active]').hidden =
        !hasCustomAdvanced(i) || !sectionEl.querySelector('[data-adv-body]').hidden;
      var lpHint = sectionEl.querySelector('[data-lockprep-hint]');
      if (lpHint) {
        lpHint.textContent = i.lockPrep === 'double'
          ? 'Deadbolt bore above the latch bore. Double bore on an interior door is a custom lock prep.'
          : i.lockPrep === 'none' ? 'No bore or strike prep on the slab or jamb.'
          : 'Latch bore only. Standard for interior doors.';
      }

      // ---- Spec block visibility ----
      var strikeSpec = sectionEl.querySelector('[data-spec="strike"]');
      var astragalSpec = sectionEl.querySelector('[data-spec="astragal"]');
      var ballcatchSpec = sectionEl.querySelector('[data-spec="ballcatch"]');
      if (strikeSpec) strikeSpec.hidden = !withBore;          // single + floating astragal
      if (astragalSpec) astragalSpec.hidden = !withAstragal;  // fixed + floating
      if (ballcatchSpec) ballcatchSpec.hidden = !usesBallCatch(i.config); // ball pair + fixed astragal

      // ---- Strike-block heading ----
      var strikeHeading = sectionEl.querySelector('[data-strike-heading]');
      if (strikeHeading) {
        strikeHeading.textContent = floatAstr
          ? 'Latch strike on astragal (from top of slab)'
          : 'Strike jamb (from top of jamb)';
      }

      // ---- Slab heading / note ----
      var slabHeading = sectionEl.querySelector('[data-slab-heading]');
      var slabNote = sectionEl.querySelector('[data-slab-note]');
      var hingeJambNote = sectionEl.querySelector('[data-hinge-jamb-note]');
      if (slabHeading) slabHeading.textContent = dbl ? 'Slab — each leaf (from top of door)' : 'Slab (from top of door)';
      if (slabNote) {
        if (floatAstr) {
          slabNote.hidden = false;
          slabNote.textContent = 'The latch bore shown here is on the ACTIVE leaf (privacy set, latch throws into the floating astragal). The inactive leaf gets a double dummy and is not bored. Both leaves share the same hinge layout, mirrored across the centerline.';
        } else if (fixedAstr) {
          slabNote.hidden = false;
          slabNote.textContent = 'Neither leaf is bored — both get a double dummy and a ball catch. The fixed astragal sits centered between the leaves. Both leaves share the same hinge layout, mirrored across the centerline.';
        } else if (ballPair) {
          slabNote.hidden = false;
          slabNote.textContent = 'Both leaves are identical and hardware-symmetric. Each gets one ball catch in the top edge near the meeting stile — see Ball catches below.';
        } else {
          slabNote.hidden = true;
        }
      }
      if (hingeJambNote) hingeJambNote.hidden = !dbl;

      // ---- Astragal block (dynamic) ----
      if (withAstragal) {
        var astrHeading = sectionEl.querySelector('[data-astragal-heading]');
        var astrNote = sectionEl.querySelector('[data-astragal-note]');
        if (astrHeading) astrHeading.textContent = fixedAstr
          ? 'Fixed astragal' : 'Floating astragal, handles & bolts';
        setOut('astragalType', fixedAstr
          ? 'Fixed — centered, 1/8" gap each side'
          : 'Floating — fastened to inactive leaf');
        setOut('astragalLen', r.astragalLen, toFraction);
        setOut('centerGapOut', r.centerGap, toFraction);

        // Rows that only apply to the floating astragal (handles/bore/bolts)
        var floatRows = ['activeHandle','inactiveHandle','bore','backset','deadbolt','boltDivider','boltTop','boltBot'];
        floatRows.forEach(function (key) {
          var el = sectionEl.querySelector('[data-astragal-row="' + key + '"]');
          var on = floatAstr
            && (key !== 'bore' && key !== 'backset' || withBore)
            && (key !== 'deadbolt' || withDeadbolt);
          if (el) el.hidden = !on;
        });
        var boreDivider = sectionEl.querySelector('[data-astragal-bore-divider]');
        if (boreDivider) boreDivider.hidden = !floatAstr;

        if (floatAstr) {
          setOut('activeHandleOut', withBore ? 'Privacy set — latch into astragal' : 'No bore (no lock prep)');
          setOut('inactiveHandleOut', 'Double dummy (non-latching)');
          setOut('deadboltBore2', r.deadboltBore, toFraction);
          setOut('latchBore2', r.latchBore, toFraction);
          setOut('backsetOut2', i.backset, toFraction);
          setOut('flushBoltTop', r.flushBoltTop, toFraction);
          setOut('flushBoltBot', r.flushBoltBot, toFraction);
          if (astrNote) astrNote.textContent = 'The floating astragal is screwed to the inactive leaf and secured with flush or surface bolts to the head jamb (and usually the floor). The active leaf carries a privacy handle whose latch throws into the astragal, so it locks like a bedroom door. The inactive leaf carries a double dummy. If surface bolts are used, the active leaf sometimes gets matching surface bolts for symmetry — not required for function.';
        } else {
          if (astrNote) astrNote.textContent = 'The fixed astragal is centered between the leaves with a 1/8" gap on each side (3/4" total). Both leaves carry a double dummy handle and a ball catch into the head jamb (see Ball catches). Neither leaf is bored for a latch.';
        }
      }

      // ---- Ball catch block note ----
      if (usesBallCatch(i.config)) {
        setOut('ballCatchInset', r.ballCatchInset, toFraction);
        setOut('ballCatchHeadOffset', r.ballCatchHeadOffset, toFraction);
        var ballNote = sectionEl.querySelector('[data-ballcatch-note]');
        if (ballNote) {
          ballNote.textContent = fixedAstr
            ? 'Both leaves carry a ball catch in the top edge near the meeting stile, engaging a strike plate in the underside of the head jamb. With the fixed astragal between them, the catches hold each leaf closed.'
            : 'With no astragal the two leaves meet with a 1/8" gap. A ball catch is installed at the top of each slab near the meeting stile and engages a strike plate mortised into the underside of the head jamb. There is no latch bore; the catches alone hold the doors closed.';
        }
      }

      // ---- Buyer tab ----
      // Unit and rough-opening dimensions inherit the jamb thickness (11/16")
      // and 1/16" hinge reveal, so they can land on sixteenths — format at
      // 1/16" precision. Slab sizes the user typed stay as-is.
      setOut('unitW', r.unitW, toFraction16);
      setOut('unitH', r.unitH, toFraction16);
      setOut('unitD', r.unitD, toFraction16);
      var slabWOutEl = sectionEl.querySelector('[data-out="slabWOut"]');
      if (slabWOutEl) slabWOutEl.textContent = dbl ? (toFraction16(i.slabW) + ' (each leaf)') : toFraction16(i.slabW);
      setOut('slabHOut', i.slabH, toFraction16);
      setOut('slabThkOut', i.slabThk, toFraction16);
      setOut('roWmin', r.roWmin, toFraction16);
      setOut('roWmax', r.roWmax, toFraction16);
      setOut('roHmin', r.roHmin, toFraction16);
      setOut('roHmax', r.roHmax, toFraction16);
      setOut('roDmin', r.roDmin, toFraction16);
      setOut('roDmax', r.roDmax, toFraction16);

      // ---- Installer tab — slab ----
      setOut('slab1', r.slab1, toFraction);
      setOut('slab2', r.slab2, toFraction);
      setOut('slab3', r.slab3, toFraction);
      setOut('slab4', r.slab4, toFraction);
      setOut('latchBore', r.latchBore, toFraction);
      setOut('backsetOut', i.backset, toFraction);
      setOut('hingeMortW', mortiseWidthFor(i.slabThk), toFraction16);

      // ---- Installer tab — hinge jamb ----
      // Jamb positions = slab position (rounded to 1/8") + slabToJambOffset
      // (1/8" + jamb thickness = 13/16" with an 11/16" jamb), so they land on
      // sixteenths. Same for the strike, which adds the same offset.
      setOut('jambHt', r.jambHt, toFraction16);
      setOut('jamb1', r.jamb1, toFraction16);
      setOut('jamb2', r.jamb2, toFraction16);
      setOut('jamb3', r.jamb3, toFraction16);
      setOut('jamb4', r.jamb4, toFraction16);

      // ---- Installer tab — strike ----
      setOut('latchMortTop', r.latchMortTop, toFraction16);
      setOut('latchStrike', r.latchStrike, toFraction16);
      setOut('latchMortBot', r.latchMortBot, toFraction16);
      setOut('strikeMortW', mortiseWidthFor(i.slabThk), toFraction16);

      // ---- Installer tab — head jamb / assembly ----
      setOut('headJamb', r.headJamb, toFraction16);
      setOut('jambThkOut', i.jambThickness, toFraction16);
      setOut('jambLegW', i.jambDepth, toFraction16);
      setOut('hingeRevealOut', C.hingeSideGap, toFraction16);
      setOut('strikeRevealOut', C.strikeSideGap, toFraction16);
      // Floor clearance can be 15/16" (the standard), which 1/8" rounding
      // would push to 1". Use 1/16" precision so the user sees what they
      // configured.
      setOut('floorClearOut', i.floorClearance, toFraction16);
      // On doubles, side reveals are the outer (hinge) gaps; strike clearance
      // is taken at the center gap, so relabel the strike reveal row.
      var strikeRevealRow = sectionEl.querySelector('[data-row="strikeReveal"]');
      if (strikeRevealRow) {
        var lbl = strikeRevealRow.querySelector('span');
        if (lbl) lbl.textContent = dbl
          ? 'Center gap (between leaves)'
          : 'Strike-side reveal (slab to jamb)';
        var strong = strikeRevealRow.querySelector('strong');
        if (dbl && strong) strong.textContent = toFraction16(r.centerGap);
        else setOut('strikeRevealOut', C.strikeSideGap, toFraction16);
      }
      var hingeRevealRow = sectionEl.querySelector('[data-row="hingeReveal"]');
      if (hingeRevealRow) {
        var hlbl = hingeRevealRow.querySelector('span');
        if (hlbl) hlbl.textContent = dbl
          ? 'Outer (hinge-side) reveal — each leaf'
          : 'Hinge-side reveal (slab to jamb)';
      }

      // ---- Warnings ----
      renderFit(sectionEl, i);
      syncChoices(sectionEl);
      renderMessages(sectionEl, 'idc', validate(i));
      setSummary(sectionEl, summaryText(i), stickyText(r));
      renderItemList(sectionEl, itemRows(i, r));
      // Hinge prep choice only applies to a slab (or loose components).
      sectionEl.querySelectorAll('[data-group="hinge-prep"]').forEach(function (el) {
        el.style.display = (i.ship === 'slab' || i.ship === 'components') && (sectionEl._calcKey !== 'ext' || i.numDoors > 0) ? '' : 'none';
      });
      renderServices(sectionEl, '', serviceLines(i, r), shareUrl(sectionEl, sectionEl._calcKey));

      // Hide hinge rows that don't exist for the chosen hinge count.
      ['slab', 'jamb', 'mull'].forEach(function (pre) {
        [2, 3, 4].forEach(function (n) {
          var el = sectionEl.querySelector('[data-out="' + pre + n + '"]');
          if (!el) return;
          var li = el.closest('li'), na = r[pre + n] === 'na';
          // Rows with data-row were already shown/hidden for other reasons.
          li.hidden = li.hasAttribute('data-row') ? (li.hidden || na) : na;
        });
      });

      // ---- Drawings ----
      drawElevation(i, r);
      drawPlan(i, r);

      sectionEl._idcLast = { i: i, r: r };
    }

    // ---- Advanced settings toggle + reset ----
    var advToggle = sectionEl.querySelector('[data-adv-toggle]');
    var advBody = sectionEl.querySelector('[data-adv-body]');
    advToggle.addEventListener('click', function () {
      var open = advBody.hidden;
      advBody.hidden = !open;
      advToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      render();
    });
    sectionEl.querySelector('[data-adv-reset]').addEventListener('click', function () {
      advBody.querySelectorAll('[data-input]').forEach(function (el) {
        if (el.tagName === 'SELECT') {
          Array.prototype.forEach.call(el.options, function (o) { o.selected = o.defaultSelected; });
        } else {
          el.value = '';
        }
        el.removeAttribute('data-last-good');
      });
      render();
    });

    // ---- Shop services: collapsed by default (most customers won't need them) ----
    var svcToggle = sectionEl.querySelector('[data-svc-toggle]');
    var svcBody = sectionEl.querySelector('[data-svc-body]');
    if (svcToggle) svcToggle.addEventListener('click', function () {
      var open = svcBody.hidden;
      svcBody.hidden = !open;
      svcToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // ---- Reset: every input back to its default, sections closed, first tab ----
    var resetAll = sectionEl.querySelector('[data-action="reset-all"]');
    if (resetAll) resetAll.addEventListener('click', function () {
      sectionEl.querySelectorAll('[data-input]').forEach(function (el) {
        if (el.tagName === 'SELECT') {
          Array.prototype.forEach.call(el.options, function (o) { o.selected = o.defaultSelected; });
        } else {
          el.value = el.defaultValue || '';
        }
        el.removeAttribute('data-last-good');
      });
      sectionEl.querySelectorAll('[data-adv-body], [data-cut-body], [data-scut-body], [data-svc-body]').forEach(function (b) { b.hidden = true; });
      sectionEl.querySelectorAll('[data-adv-toggle], [data-cut-toggle], [data-scut-toggle], [data-svc-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      var firstTab = sectionEl.querySelector('[data-tab="buyer"]');
      if (firstTab) firstTab.click();
      // Drop a shared setup from the address bar so a reload doesn't bring it back.
      if (/calc=/.test(location.hash)) history.replaceState(null, '', location.pathname + location.search);
      render();
    });

    // ---- Tabs ----
    sectionEl.querySelectorAll('.pease-idc__tab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        sectionEl.querySelectorAll('.pease-idc__tab').forEach(function (b) {
          b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false');
        });
        sectionEl.querySelectorAll('.pease-idc__tabpanel').forEach(function (p) {
          p.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        sectionEl.querySelector('[data-panel="' + btn.dataset.tab + '"]').classList.add('is-active');
      });
    });

    // ---- Input listeners ----
    sectionEl.querySelectorAll('[data-input]').forEach(function (el) {
      var isFrac = el.getAttribute('data-fractional') === 'true';
      if (isFrac) {
        // Live recalc as the user types. If the field isn't parseable yet
        // (e.g. mid-typing "33 9/"), don't redraw — wait until the value
        // parses cleanly. Empty fields fall through to the placeholder
        // default in getInputs(), so clearing the field also triggers a
        // re-render at the default.
        el.addEventListener('input', function () {
          var raw = el.value.trim();
          if (!raw) { render(); return; }       // empty → render with default
          var n = parseFractional(raw);
          if (!isNaN(n)) render();
        });
        // On blur, snap to 1/16", clamp to min/max, and rewrite the field
        // with the canonical fraction. Empty stays empty so the placeholder
        // (the standard default) reappears. Unparseable garbage either
        // restores the last good value the user committed, or — if there
        // is none — clears the field so the placeholder is shown again.
        el.addEventListener('blur', function () {
          var raw = el.value.trim();
          if (!raw) { render(); return; }       // user cleared → leave empty, show placeholder
          var n = parseFractional(raw);
          if (isNaN(n)) {
            var last = el.getAttribute('data-last-good');
            el.value = last ? last : '';        // restore or clear
          } else {
            var snapped = snapAndClamp(n, el);
            // Always keep the typed value visible in dark text — even when
            // it matches the default. The placeholder is only for genuinely
            // empty fields.
            el.value = formatFractionalInput(snapped);
            el.setAttribute('data-last-good', el.value);
          }
          render();
        });
      } else {
        // Dropdowns and any remaining numeric inputs
        el.addEventListener('input', render);
        el.addEventListener('change', render);
      }
    });

    // ---- Print ----
    function buildPrintHTML() {
      var d = sectionEl._idcLast;
      if (!d) return '';
      var i = d.i, r = d.r;
      var row = function (label, val) {
        if (val === 'na') return '';
        return '<tr><td>' + label + '</td><td>' + toFraction(val) + '</td></tr>';
      };
      var row16 = function (label, val) {
        return '<tr><td>' + label + '</td><td>' + toFraction16(val) + '</td></tr>';
      };
      var inputRow = function (label, val) {
        return '<tr><td>' + label + '</td><td>' + val + '</td></tr>';
      };

      var elevSvg = sectionEl.querySelector('[data-drawing="elevation"]');
      var planSvg = sectionEl.querySelector('[data-drawing="plan"]');
      var cloneSvgHtml = function (svg) {
        if (!svg) return '';
        var clone = svg.cloneNode(true);
        clone.removeAttribute('width');
        clone.removeAttribute('height');
        clone.setAttribute('style', 'width:100%;height:auto;max-height:4.5in;');
        return clone.outerHTML;
      };
      var visualSection =
        '<h2>Visual reference</h2>' +
        '<div class="pease-idc-print-visuals">' +
          '<div class="pease-idc-print-visual">' +
            '<div class="pease-idc-print-visual-label">Elevation</div>' +
            cloneSvgHtml(elevSvg) +
          '</div>' +
          '<div class="pease-idc-print-visual">' +
            '<div class="pease-idc-print-visual-label">Plan (top view)</div>' +
            cloneSvgHtml(planSvg) +
          '</div>' +
        '</div>';

      var cfgLabel = {
        'single': 'Single door',
        'double-fixed-astragal': 'Double door — fixed astragal',
        'double-floating-astragal': 'Double door — floating astragal',
        'double-ballcatch': 'Double door — ball catches (no astragal)'
      }[i.config] || i.config;
      var dbl = isDouble(i.config);
      var withBore = boreOn(i);
      var withAstragal = hasAstragal(i.config);
      var fixedAstr = isFixedAstragal(i.config);
      var floatAstr = isFloatingAstragal(i.config);
      var handingLbl = dbl ? 'Active leaf' : 'Handing';

      var configRows =
          inputRow('Door configuration', cfgLabel) +
          inputRow(dbl ? 'Slab width (each leaf)' : 'Slab width', toFraction(i.slabW)) +
          inputRow('Slab height', toFraction(i.slabH)) +
          inputRow('Slab thickness', toFraction(i.slabThk)) +
          inputRow(handingLbl, i.handing) +
          inputRow('Hinge size', i.hingeSize + '"') +
          inputRow('Hinge count', i.hingeCount) +
          inputRow('First hinge offset', toFraction(i.firstHingeOffset)) +
          inputRow('Hinge placement', customHinges(i) ? 'Custom (see below)' : 'Standard') +
          (hasBore(i.config) ? inputRow('Lock prep', LOCK_PREP_LABELS[i.lockPrep]) : '') +
          (boreOn(i) ? inputRow('Bore placement', customBore(i) ? 'Custom' : 'Standard') : '') +
          (withBore ? inputRow('Latch bore center from bottom of slab', toFraction(i.boreFromBottom)) : '') +
          (deadboltOn(i) ? inputRow('Bore spacing', toFraction16(i.boreSpacing)) : '') +
          (withBore ? inputRow('Backset', toFraction(i.backset)) : '') +
          inputRow('Jamb thickness', toFraction16(i.jambThickness)) +
          inputRow('Jamb depth', toFraction16(i.jambDepth)) +
          (dbl ? inputRow('Gap between leaves (center)', toFraction16(r.centerGap)) : '') +
          inputRow('Hinge-side reveal', toFraction16(C.hingeSideGap)) +
          inputRow(dbl ? 'Center gap (strike clearance)' : 'Strike-side reveal',
                   toFraction16(dbl ? r.centerGap : C.strikeSideGap)) +
          inputRow('Floor clearance under slab', toFraction16(i.floorClearance));

      var slabHeading = dbl ? 'Slab — each leaf (from top of door)' : 'Slab (from top of door)';
      var slabRows =
          row('1st hinge', r.slab1) + row('2nd hinge', r.slab2) +
          row('3rd hinge', r.slab3) + row('4th hinge', r.slab4) +
          (deadboltOn(i) ? row('Deadbolt bore center', r.deadboltBore) : '') +
          (withBore ? row('Latch bore center', r.latchBore) : '') +
          (withBore ? row('Backset (strike edge to bore center)', i.backset) : '');

      var strikeBlock = '';
      if (withBore) {
        var strikeHeading = floatAstr ? 'Latch strike on astragal (from top of slab)' : 'Strike jamb (from top of jamb)';
        strikeBlock =
          '<h2>' + strikeHeading + '</h2><table>' +
            (deadboltOn(i)
              ? row16('Deadbolt strike mortise &mdash; top', r.dbMortTop) +
                row16('Deadbolt strike bore center', r.dbStrike) +
                row16('Deadbolt strike mortise &mdash; bottom', r.dbMortBot)
              : '') +
            row16('Latch strike mortise &mdash; top', r.latchMortTop) +
            row16('Latch strike bore center', r.latchStrike) +
            row16('Latch strike mortise &mdash; bottom', r.latchMortBot) +
            row16('Strike mortise width', mortiseWidthFor(i.slabThk)) +
          '</table>';
      }

      var astragalBlock = '';
      if (fixedAstr) {
        astragalBlock =
          '<h2>Fixed astragal</h2><table>' +
            '<tr><td>Astragal profile</td><td>1/2" thick, fixed (centered between leaves)</td></tr>' +
            row('Astragal length', r.astragalLen) +
            row('Gap between leaves (center)', r.centerGap) +
            '<tr><td>Active leaf handle</td><td>Double dummy</td></tr>' +
            '<tr><td>Inactive leaf handle</td><td>Double dummy</td></tr>' +
            '<tr><td>Retention</td><td>Ball catch on each leaf (see Ball catches)</td></tr>' +
          '</table>' +
          '<p style="font-size:0.85em;color:#555;margin:0.5em 0 1em;">The fixed astragal is centered between the leaves with a 1/8" gap on each side (3/4" total). Both leaves carry a double dummy handle and a ball catch into the head jamb. Neither leaf is bored for a latch.</p>';
      } else if (floatAstr) {
        astragalBlock =
          '<h2>Floating astragal, handles &amp; bolts</h2><table>' +
            '<tr><td>Astragal profile</td><td>1/2" thick, floating (fastened to inactive leaf)</td></tr>' +
            row('Astragal length', r.astragalLen) +
            row('Gap between leaves (center)', r.centerGap) +
            '<tr><td>Active leaf handle</td><td>Privacy set &mdash; latch throws into astragal</td></tr>' +
            '<tr><td>Inactive leaf handle</td><td>Double dummy (non-latching)</td></tr>' +
            (deadboltOn(i) ? row('Active leaf deadbolt bore &mdash; center from top of door', r.deadboltBore) : '') +
            (withBore ? row('Active leaf bore &mdash; center from top of door', r.latchBore) : '') +
            (withBore ? row('Backset (strike edge to bore center)', i.backset) : '') +
            row('Top flush/surface bolt (inactive) &mdash; from top of slab', r.flushBoltTop) +
            row('Bottom flush/surface bolt (inactive) &mdash; from bottom of slab', r.flushBoltBot) +
          '</table>' +
          '<p style="font-size:0.85em;color:#555;margin:0.5em 0 1em;">The floating astragal is screwed to the inactive leaf and secured with flush or surface bolts to the head jamb (and usually the floor). The active leaf carries a privacy handle whose latch throws into the astragal. The inactive leaf carries a double dummy. If surface bolts are used, the active leaf sometimes gets matching surface bolts for symmetry &mdash; not required for function.</p>';
      }

      var ballcatchBlock = '';
      if (usesBallCatch(i.config)) {
        var bcNote = fixedAstr
          ? 'Both leaves carry a ball catch in the top edge near the meeting stile, engaging a strike plate in the underside of the head jamb. With the fixed astragal between them, the catches hold each leaf closed.'
          : 'With no astragal the two leaves meet with a 1/8" gap. A ball catch is installed at the top of each slab near the meeting stile and engages a strike plate mortised into the underside of the head jamb. There is no latch bore; the catches alone hold the doors closed.';
        ballcatchBlock =
          '<h2>Ball catches</h2><table>' +
            '<tr><td>Hardware</td><td>Ball catch in each slab top edge + catch plate in head jamb</td></tr>' +
            row('Catch inset from meeting stile', r.ballCatchInset) +
            row('Catch position on head jamb (each side of centerline)', r.ballCatchHeadOffset) +
          '</table>' +
          '<p style="font-size:0.85em;color:#555;margin:0.5em 0 1em;">' + bcNote + '</p>';
      }

      return '<div class="pease-idc-print-root">' +
        '<h1>Pease Doors &mdash; Interior Door Spec Sheet</h1>' +
        '<p>' + summaryText(i) + '</p>' +
        '<p>Open this setup: ' + shareUrl(sectionEl, 'int').replace(/&/g, '&amp;') + '</p>' +
        '<h2>Shop services</h2>' + sectionEl.querySelector('[data-svc-table]').outerHTML +
        sectionEl.querySelector('[data-svc-notes]').outerHTML +
        '<p>Generated ' + new Date().toLocaleString() + '</p>' +
        visualSection +
        '<h2>Configuration</h2><table>' + configRows + '</table>' +
        '<h2>Unit size</h2><table>' +
          row16('Width', r.unitW) + row16('Height', r.unitH) + row16('Depth', r.unitD) +
        '</table>' +
        '<h2>Rough opening</h2><table>' +
          '<tr><td>Width (min)</td><td>' + toFraction16(r.roWmin) + '</td></tr>' +
          '<tr><td>Width (max)</td><td>' + toFraction16(r.roWmax) + '</td></tr>' +
          '<tr><td>Height (min)</td><td>' + toFraction16(r.roHmin) + '</td></tr>' +
          '<tr><td>Height (max)</td><td>' + toFraction16(r.roHmax) + '</td></tr>' +
          '<tr><td>Depth (min)</td><td>' + toFraction16(r.roDmin) + '</td></tr>' +
          '<tr><td>Depth (max)</td><td>' + toFraction16(r.roDmax) + '</td></tr>' +
        '</table>' +
        '<h2>' + slabHeading + '</h2><table>' + slabRows + '</table>' +
        '<h2>Hinge jamb (from top of jamb)</h2><table>' +
          row16('Jamb height', r.jambHt) +
          row16('1st hinge', r.jamb1) + row16('2nd hinge', r.jamb2) +
          row16('3rd hinge', r.jamb3) + row16('4th hinge', r.jamb4) +
          row16('Hinge mortise width', mortiseWidthFor(i.slabThk)) +
        '</table>' +
        strikeBlock +
        astragalBlock +
        ballcatchBlock +
        '<h2>Head jamb &amp; assembly</h2><table>' +
          row16('Head jamb width', r.headJamb) +
          row16('Jamb thickness', i.jambThickness) +
          row16('Jamb leg width (depth)', i.jambDepth) +
          row16('Floor clearance under slab', i.floorClearance) +
        '</table>' +
      '</div>';
    }

    sectionEl.querySelector('[data-action="print"]').addEventListener('click', function () {
      var existing = document.querySelector('.pease-idc-print-root');
      if (existing) existing.remove();
      var host = document.createElement('div');
      host.innerHTML = buildPrintHTML();
      document.body.appendChild(host.firstChild);
      window.print();
      setTimeout(function () {
        var n = document.querySelector('.pease-idc-print-root');
        if (n) n.remove();
      }, 500);
    });

    // ---- Lead capture modal ----
    var modal = sectionEl.querySelector('[data-modal]');
    var leadForm = sectionEl.querySelector('#pease-idc-lead-form');
    var formTemplate = sectionEl.querySelector('[data-form-template]');

    function resetFormState() {
      if (!leadForm || !formTemplate) return;
      if (!leadForm.querySelector('[data-form-success]')) return;
      leadForm.innerHTML = '';
      leadForm.appendChild(formTemplate.content.cloneNode(true));
      bindCloseButtons();
    }

    function openModal() {
      resetFormState();
      modal.hidden = false;
      var msg = leadForm ? leadForm.querySelector('[data-modal-msg]') : null;
      if (msg) {
        msg.textContent = '';
        msg.classList.remove('is-ok', 'is-err');
      }
      setTimeout(function () {
        var input = sectionEl.querySelector('[data-email-input]');
        if (input) input.focus();
      }, 50);
    }
    function closeModal() { modal.hidden = true; }

    function bindCloseButtons() {
      sectionEl.querySelectorAll('[data-modal-close]').forEach(function (b) {
        if (!b.dataset.idcBound) {
          b.addEventListener('click', closeModal);
          b.dataset.idcBound = '1';
        }
      });
    }

    sectionEl.querySelector('[data-action="email"]').addEventListener('click', openModal);
    bindCloseButtons();
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    function buildBody() {
      var d = sectionEl._idcLast;
      if (!d) return 'No calculator data available.';
      var i = d.i, r = d.r;
      var lines = [];
      lines.push('Pease Doors — Interior Door Calculator lead');
      lines.push('Generated: ' + new Date().toLocaleString());
      lines.push('Source: ' + window.location.href);
      lines.push('Open this setup: ' + shareUrl(sectionEl, 'int'));
      if (i.sizeMode === 'ro') lines.push('Sized from a rough opening of ' + toFraction(i.roW) + ' x ' + toFraction(i.roH));
      lines.push('');
      var notesEl = sectionEl.querySelector('[data-notes-input]');
      var notes = notesEl ? notesEl.value.trim() : '';
      if (notes) {
        lines.push('=== CUSTOMER NOTES ===');
        lines.push(notes);
        lines.push('');
      }
      lines.push('=== CONFIGURATION ===');
      var cfgLabelMap = {
        'single': 'Single door',
        'double-fixed-astragal': 'Double door — fixed astragal (1/2", centered, 3/4" total gap)',
        'double-floating-astragal': 'Double door — floating astragal (1/2", on inactive leaf, 5/8" total gap)',
        'double-ballcatch': 'Double door — ball catches (no astragal, 1/8" gap)'
      };
      var dbl = isDouble(i.config);
      var withBore = boreOn(i);
      var withAstragal = hasAstragal(i.config);
      var fixedAstr = isFixedAstragal(i.config);
      var floatAstr = isFloatingAstragal(i.config);
      lines.push('Door configuration: ' + (cfgLabelMap[i.config] || i.config));
      lines.push('Slab' + (dbl ? ' (each leaf)' : '') + ': ' + toFraction(i.slabW) + ' W x ' + toFraction(i.slabH) + ' H x ' + toFraction(i.slabThk) + ' thick');
      lines.push((dbl ? 'Active leaf: ' : 'Handing: ') + i.handing);
      lines.push('Hinge: ' + i.hingeSize + '" x ' + i.hingeCount + ' (per leaf' + (dbl ? ', mirrored)' : ')'));
      if (customHinges(i)) lines.push('Hinge placement: CUSTOM');
      if (customBore(i)) lines.push('Bore placement: CUSTOM');
      lines.push('First hinge offset: ' + toFraction(i.firstHingeOffset));
      if (hasBore(i.config)) lines.push('Lock prep: ' + LOCK_PREP_LABELS[i.lockPrep]);
      if (deadboltOn(i)) lines.push('Bore spacing: ' + toFraction16(i.boreSpacing));
      if (withBore) {
        lines.push('Latch bore center from bottom of slab: ' + toFraction(i.boreFromBottom));
        lines.push('Backset: ' + toFraction(i.backset));
      }
      lines.push('Jamb thickness: ' + toFraction16(i.jambThickness));
      lines.push('Jamb depth: ' + toFraction16(i.jambDepth));
      lines.push('Hinge-side reveal: ' + toFraction16(C.hingeSideGap));
      lines.push((dbl ? 'Center gap (strike clearance): ' : 'Strike-side reveal: ') + toFraction16(dbl ? r.centerGap : C.strikeSideGap));
      lines.push('Floor clearance under slab: ' + toFraction16(i.floorClearance));
      lines.push('');
      lines.push('=== UNIT SIZE ===');
      lines.push('W ' + toFraction16(r.unitW) + '  x  H ' + toFraction16(r.unitH) + '  x  D ' + toFraction16(r.unitD));
      lines.push('');
      lines.push('=== ROUGH OPENING ===');
      lines.push('Width:  ' + toFraction16(r.roWmin) + ' – ' + toFraction16(r.roWmax));
      lines.push('Height: ' + toFraction16(r.roHmin) + ' – ' + toFraction16(r.roHmax));
      lines.push('Depth:  ' + toFraction16(r.roDmin) + ' – ' + toFraction16(r.roDmax));
      lines.push('');
      lines.push('=== SLAB HINGE POSITIONS (from top of door' + (dbl ? ', per leaf' : '') + ') ===');
      ['slab1','slab2','slab3','slab4'].forEach(function (k, idx) {
        if (r[k] !== 'na') lines.push('Hinge ' + (idx + 1) + ': ' + toFraction(r[k]));
      });
      if (deadboltOn(i)) lines.push('Deadbolt bore: ' + toFraction(r.deadboltBore));
      if (withBore) lines.push('Latch bore: ' + toFraction(r.latchBore));
      if (fixedAstr) {
        lines.push('');
        lines.push('=== FIXED ASTRAGAL ===');
        lines.push('Astragal: 1/2" thick, fixed (centered), length ' + toFraction(r.astragalLen));
        lines.push('Gap between leaves: ' + toFraction(r.centerGap) + ' total (1/8" each side)');
        lines.push('Both leaves: double dummy handle + ball catch (no bore)');
      }
      if (floatAstr) {
        lines.push('');
        lines.push('=== FLOATING ASTRAGAL, HANDLES + BOLTS ===');
        lines.push('Astragal: 1/2" thick, floating (fastened to inactive leaf), length ' + toFraction(r.astragalLen));
        lines.push('Gap between leaves: ' + toFraction(r.centerGap) + ' (1/2" astragal + 1/8" to active leaf)');
        lines.push('Active leaf handle: privacy set (latch throws into astragal)');
        lines.push('Inactive leaf handle: double dummy (non-latching)');
        if (deadboltOn(i)) lines.push('Active leaf deadbolt bore (from top of door): ' + toFraction(r.deadboltBore));
        if (withBore) {
          lines.push('Active leaf bore (from top of door): ' + toFraction(r.latchBore));
          lines.push('Backset: ' + toFraction(i.backset));
        } else {
          lines.push('Active leaf: no bore');
        }
        lines.push('Top flush/surface bolt (from top of inactive leaf): ' + toFraction(r.flushBoltTop));
        lines.push('Bottom flush/surface bolt (from bottom of inactive leaf): ' + toFraction(r.flushBoltBot));
      }
      if (usesBallCatch(i.config)) {
        lines.push('');
        lines.push('=== BALL CATCHES ===');
        lines.push('Ball catch in top edge of each slab + strike in head jamb');
        lines.push('Catch inset from meeting stile: ' + toFraction(r.ballCatchInset));
        lines.push('Head jamb strike offset from centerline: ' + toFraction(r.ballCatchHeadOffset));
      }
      if (sectionEl._svcText) {
        lines.push('');
        lines.push('=== SHOP SERVICES ===');
        lines.push(sectionEl._svcText);
      }
      return lines.join('\n');
    }

    if (leadForm) {
      leadForm.addEventListener('submit', function () {
        var bodyField = sectionEl.querySelector('[data-form-body]');
        if (bodyField) bodyField.value = buildBody();
      });
    }

    var successOnLoad = leadForm && leadForm.querySelector('[data-form-success]');
    if (successOnLoad) {
      modal.hidden = false;
    }

    // Initial render
    render();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPeaseCalculators);
  } else {
    initPeaseCalculators();
  }
  document.addEventListener('shopify:section:load', initPeaseCalculators);
})();
